export const QUESTIONS = [
  {
    "id": 1,
    "question": "After running an nmap scan of a system, you receive scan data that indicates the following three ports are open:<br>22/TCP <br>443/TCP <br>1521/TCP <br>What services commonly run on these ports?",
    "choice_a": "SMTP, NetBIOS, MS-SQL",
    "choice_b": "SSH, LDAPS, LDAP",
    "choice_c": "SSH, HTTPS, Oracle",
    "choice_d": "FTP, HTTPS, MS-SQL",
    "correct_answer": "C",
    "explanation": "These three TCP ports are associated with SSH (22), HTTPS (443), and Oracle databases (1521). Other ports mentioned in the potential answers are SMTP (25), NetBIOS (137\u2013139), LDAP (389), LDAPS (636) and MS-SQL (1433/1434).",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      103,
      100,
      107,
      110,
      118
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 2,
    "question": "What type of system allows attackers to believe they have succeeded with their attack, thus providing defenders with information about their attack methods and tools?",
    "choice_a": "A honeypot",
    "choice_b": "A sinkhole",
    "choice_c": "A crackpot",
    "choice_d": "A darknet",
    "correct_answer": "A",
    "explanation": "Honeypots are systems that are designed to look like attractive targets. When they are attacked, they simulate a compromise, providing defenders with a chance to see how attackers operate and what tools they use. DNS sinkholes provide false information to malicious software, redirecting queries about command-and-control (C&C) systems to allow remediation. Darknets are segments of unused network space that are monitored to detect traffic\u2014since legitimate traffic should never be aimed at the darknet, this can be used to detect attacks and other unwanted traffic. Crackpots are eccentric people\u2014not a system you\u2019ll run into on a network.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      97,
      79,
      75,
      59,
      61
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 3,
    "question": "What cybersecurity objective could be achieved by running your organization\u2019s web servers in redundant, geographically separate datacenters?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Immutability",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "Redundant systems, particularly when run in multiple locations and with other protections to ensure uptime, can help provide availability.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      40,
      41,
      37,
      20
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 4,
    "question": "Which of the following vulnerability scanning methods will provide the most accurate detail during a scan?",
    "choice_a": "Black box/unknown environment",
    "choice_b": "Authenticated",
    "choice_c": "Internal view",
    "choice_d": "External view",
    "correct_answer": "B",
    "explanation": "An authenticated, or credentialed, scan provides the most detailed view of the system. Black-box assessments presume no knowledge of a system and would not have credentials or an agent to work with on the system. Internal views typically provide more detail than external views, but neither provides the same level of detail that credentials can allow.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      123,
      124,
      105,
      131,
      137
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 5,
    "question": "Security researchers recently discovered a flaw in the Chakra JavaScript scripting engine in Microsoft\u2019s Edge browser that could allow remote execution or denial of service via a specifically crafted website. The CVSS 3.1 score for this vulnerability reads:<br>CVSS:3.1/AV:N/AC:H/PR:N/UI:R/S:U/C:H/I:H/A:H <br>What is the attack vector and the impact to integrity based on this rating?",
    "choice_a": "System, 9, 8",
    "choice_b": "Browser, High",
    "choice_c": "Network, High",
    "choice_d": "None, High",
    "correct_answer": "C",
    "explanation": "When reading the CVSS score, AV is the attack vector. Here, N means network. Confidentiality (C), integrity (I), and availability (A) are listed at the end of the listing, and all three are rated as High in this CVSS rating.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      132,
      133,
      125,
      128,
      135
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 6,
    "question": "Alice is a security engineer tasked with performing vulnerability scans for her organization. She encounters a false positive error in one of her scans. What should she do about this?",
    "choice_a": "Verify that it is a false positive, and then document the exception.",
    "choice_b": "Implement a workaround.",
    "choice_c": "Update the vulnerability scanner.",
    "choice_d": "Use an authenticated scan, and then document the vulnerability.",
    "correct_answer": "A",
    "explanation": "When Alice encounters a false positive error in her scans, her first action should be to verify it. This may involve running a more in-depth scan like an authenticated scan, but it could also involve getting assistance from system administrators, checking documentation, or other validation actions. Once she is done, she should document the exception so that it is properly tracked. Implementing a workaround is not necessary for false positive vulnerabilities, and updating the scanner should be done before every vulnerability scan. Using an authenticated scan might help but does not cover all the possibilities for validation she may need to use.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      135,
      136,
      137,
      130,
      129
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 7,
    "question": "Which phase of the incident response process is most likely to include gathering additional evidence such as information that would support legal action?",
    "choice_a": "Preparation",
    "choice_b": "Detection and Analysis",
    "choice_c": "Containment, Eradication, and Recovery",
    "choice_d": "Post-incident Activity and Reporting",
    "correct_answer": "C",
    "explanation": "The Containment, Eradication, and Recovery phase of an incident includes steps to limit damage and document what occurred, including potentially identifying the attacker and tools used for the attack. This means that information useful to legal actions is most likely to be gathered during this phase.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      217,
      193,
      214,
      218,
      212
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 8,
    "question": "Which of the following descriptions explains an integrity loss?",
    "choice_a": "Systems were taken offline, resulting in a loss of business income.",
    "choice_b": "Sensitive or proprietary information was changed or deleted.",
    "choice_c": "Protected information was accessed or exfiltrated.",
    "choice_d": "Sensitive personally identifiable information was accessed or exfiltrated.",
    "correct_answer": "B",
    "explanation": "Integrity breaches involve data being modified or deleted. Systems being taken offline is an availability issue, protected information being accessed might be classified as a breach of proprietary information, and sensitive personally identifiable information breaches would typically be classified as privacy breaches.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      76,
      54,
      59,
      62
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 9,
    "question": "Hui\u2019s incident response program uses metrics to determine if their subscription to and use of IoC feeds is meeting the organization\u2019s requirements. Which of the following incident response metrics is most useful if Hui wants to assess their use of IoC feeds?",
    "choice_a": "Alert volume metrics",
    "choice_b": "Mean time to respond metrics",
    "choice_c": "Mean time to detect metrics",
    "choice_d": "Mean time to remediate metrics",
    "correct_answer": "C",
    "explanation": "IoCs are used to improve detection, and Hui knows that gathering mean time to detect metrics will help the organization determine if their use of IoC feeds is improving detection speed. Alert volume is driven by configuration and maintenance of alerts, and it would not determine if the IoC usage was appropriate. Response time and remediation time are better used to measure the organization\u2019s processes and procedures.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      208,
      211,
      192,
      225,
      224
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 10,
    "question": "Abdul\u2019s monitoring detects regular traffic sent from a system that is suspected to be compromised and participating in a botnet to a set of remote IP addresses. What is this called?",
    "choice_a": "Anomalous pings",
    "choice_b": "Probing",
    "choice_c": "Zombie chatter",
    "choice_d": "Beaconing",
    "correct_answer": "D",
    "explanation": "Regular traffic from compromised systems to command-and-control nodes is known as beaconing. Anomalous pings could describe unexpected pings, but they are not typically part of botnet behavior, zombie chatter is a made-up term, and probing is part of scanning behavior in some cases.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      79,
      75,
      56,
      95,
      55
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 11,
    "question": "What industry standard is used to describe risk scores?",
    "choice_a": "CRS",
    "choice_b": "CVE",
    "choice_c": "RSS",
    "choice_d": "CVSS",
    "correct_answer": "D",
    "explanation": "The Common Vulnerability Scoring System, or CVSS, is used to rate and describe risks. CVE, Common Vulnerabilities and Exposures, classifies vulnerabilities. RSS, or Really Simple Syndication, is used to create feeds of websites. CRS was made up for this question.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      132,
      133,
      128,
      121,
      140
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 12,
    "question": "What term is used to describe the retention of data and information related to pending or active litigation?",
    "choice_a": "Preservation",
    "choice_b": "Legal hold",
    "choice_c": "Criminal hold",
    "choice_d": "Forensic archiving",
    "correct_answer": "B",
    "explanation": "The term <i>legal hold</i> is used to describe the retention of data and information related to a pending or active legal investigation. Preservation is a broader term used to describe retention of data for any of a variety of reasons including business requirements. Criminal hold and forensic archiving were made up for this question.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      213,
      261,
      217,
      212,
      246
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 13,
    "question": "During a forensic investigation Maria discovers evidence that a crime has been committed. What do organizations typically do to ensure that law enforcement can use data to prosecute a crime?",
    "choice_a": "Securely wipe drives to prevent further issues",
    "choice_b": "Document a chain of custody for the forensic data",
    "choice_c": "Only perform forensic investigation on the original storage media",
    "choice_d": "Immediately implement a legal hold",
    "correct_answer": "B",
    "explanation": "Documenting a proper chain of custody will allow law enforcement to be more likely to use forensic data successfully in court. Wiping drives will cause data loss, forensic examination is done on copies, not original drives, and legal holds are done to preserve data when litigation is occurring or may occur.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      237,
      235,
      236,
      239,
      241
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 14,
    "question": "Oscar\u2019s manager has asked him to ensure that a compromised system has been completely purged of the compromise. What is Oscar\u2019s best course of action?",
    "choice_a": "Use an antivirus tool to remove any associated malware.",
    "choice_b": "Use an antimalware tool to completely scan and clean the system.",
    "choice_c": "Wipe and rebuild the system.",
    "choice_d": "Restore a recent backup.",
    "correct_answer": "C",
    "explanation": "The most foolproof means of ensuring that a system does not remain compromised is to wipe and rebuild it. Without full knowledge of when the compromise occurred, restoring a backup may not help, and both antimalware and antivirus software packages cannot always ensure that no remnant of the compromise remains, particularly if the attacker created accounts or otherwise made changes that wouldn\u2019t be detected as malicious software.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      220,
      221,
      222,
      219,
      216
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 15,
    "question": "Which of the following actions is not a common activity during the recovery phase of an incident response process?",
    "choice_a": "Reviewing accounts and adding new privileges",
    "choice_b": "Validating that only authorized user accounts are on the systems",
    "choice_c": "Verifying that all systems are logging properly",
    "choice_d": "Performing vulnerability scans of all systems",
    "correct_answer": "A",
    "explanation": "The recovery phase does not typically seek to add new privileges. Validating that only legitimate accounts exist, that the systems are all logging properly, and that systems have been vulnerability scanned are all common parts of an incident response recovery phase.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      222,
      223,
      224,
      219,
      225
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 16,
    "question": "A statement like \u201cWindows workstations must have the current security configuration template applied to them before being deployed\u201d is most likely to be part of which document?",
    "choice_a": "Policies",
    "choice_b": "Standards",
    "choice_c": "Procedures",
    "choice_d": "Guidelines",
    "correct_answer": "B",
    "explanation": "This statement is most likely to be part of a standard. Policies contain high-level statements of management intent; standards provide mandatory requirements for how policies are carried out, including statements like that provided in the question. A procedure would include the step-by-step process, and a guideline describes a best practice or recommendation.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      12,
      6,
      8,
      4,
      1
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 17,
    "question": "A firewall is an example of what type of control?",
    "choice_a": "Preventive",
    "choice_b": "Detective",
    "choice_c": "Responsive",
    "choice_d": "Corrective",
    "correct_answer": "A",
    "explanation": "The main purpose of a firewall is to block malicious traffic before it enters a network, therefore preventing a security incident from occurring. For this reason, it is best classified as a preventive control.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      162,
      161,
      112,
      160,
      164
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 18,
    "question": "Cathy wants to collect network-based indicators of compromise as part of her security monitoring practice. Which of the following is not a common network-related IoC?",
    "choice_a": "Bandwidth consumption",
    "choice_b": "Rogue devices on the network",
    "choice_c": "Scheduled updates",
    "choice_d": "Activity on unexpected ports",
    "correct_answer": "C",
    "explanation": "Scheduled updates are a normal activity on network connected devices. Common indicators of potentially malicious activity include bandwidth consumption, beaconing, irregular peer-to-peer communication, rogue devices, scans, unusual traffic spikes, and activity on unexpected ports.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      95,
      56,
      55,
      57,
      59
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 19,
    "question": "Nick wants to analyze a potentially malicious software package using an open source, locally hosted tool. Which of the following tools is best suited to his need if he wants to run the tool as part of the process?",
    "choice_a": "Strings",
    "choice_b": "A SIEM",
    "choice_c": "VirusTotal",
    "choice_d": "Cuckoo Sandbox",
    "correct_answer": "D",
    "explanation": "Cuckoo Sandbox is the only item from the list of potential answers that is a locally installed and run sandbox that analyzes potential malware by running it in a safe sandbox environment.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      77,
      18,
      61,
      75,
      81
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 20,
    "question": "Which software development life cycle model uses linear development concepts in an iterative, four-phase process?",
    "choice_a": "Waterfall",
    "choice_b": "Agile",
    "choice_c": "RAD",
    "choice_d": "Spiral",
    "correct_answer": "D",
    "explanation": "The Spiral model uses linear development concepts like those used in Waterfall but repeats four phases through its life cycle: requirements gathering, design, build, and evaluation.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      97
    ],
    "source": "182909_AssessmentTest"
  },
  {
    "id": 21,
    "question": "Naomi wants to make her applications portable and easy to move to new environments without the overhead of a full operating system. What type of solution should she select?",
    "choice_a": "An x86 architecture",
    "choice_b": "Virtualization",
    "choice_c": "Containerization",
    "choice_d": "A SASE solution",
    "correct_answer": "C",
    "explanation": "Naomi should containerize her application. This will provide her with a lightweight option that can be moved between services and environments without requiring her to have an OS included in her container. Virtualization would include a full operating system. SASE is a solution for edge-focused security, whereas x86 is a hardware architecture.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      27,
      38,
      29,
      33,
      39
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 22,
    "question": "Bharath wants to make changes to the Windows Registry. What tool should he select?",
    "choice_a": "<code>regwiz.msc</code>",
    "choice_b": "<code>notepad.exe</code>",
    "choice_c": "<code>secpol.msc</code>",
    "choice_d": "<code>regedit</code>",
    "correct_answer": "D",
    "explanation": "The built-in Windows Registry editor is regedit. The <code>secpol.msc</code> tool is used to view and manage security policies. There is no regwiz tool, and Notepad, while handy, shouldn\u2019t be used to try to edit the Registry!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      63,
      12,
      29
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 23,
    "question": "Tom wants to set an appropriate logging level for his Cisco networking equipment while he\u2019s troubleshooting. What log level should he set?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "Tom knows that log level 7 provides debugging messages that he will need during troubleshooting. Once he\u2019s done, he\u2019ll likely want to set a lower log level to ensure that he doesn\u2019t create lots of noise in his logs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      72,
      69,
      66,
      29
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 24,
    "question": "Which of the following is not a common use of network segmentation?",
    "choice_a": "Decreasing attack surfaces",
    "choice_b": "Limiting the scope of regulatory compliance",
    "choice_c": "Reducing availability",
    "choice_d": "Increasing the efficiency of a network",
    "correct_answer": "C",
    "explanation": "Segmentation is sometimes used to increase availability by reducing the potential impact of an attack or issue\u2014intentionally reducing availability is unlikely to be a path chosen by most organizations.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      37,
      11,
      1,
      53,
      59
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 25,
    "question": "Ric\u2019s organization wants to implement zero trust. What concern should Ric raise about zero trust implementations?",
    "choice_a": "They can be complex to implement.",
    "choice_b": "Zero trust does not support TLS inspection.",
    "choice_c": "Zero trust is not compatible with modern software-defined networks.",
    "choice_d": "They are likely to prevent users from accomplishing their jobs.",
    "correct_answer": "A",
    "explanation": "Ric knows that zero trust can be complex to implement. Zero trust does not specifically prevent TLS inspection or conflict with SDN, and a successful zero trust implementation needs to validate user permissions but allow them to do their jobs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      39,
      37,
      11,
      41,
      12
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 26,
    "question": "Michelle has a security token that her company issues to her. What type of authentication factor does she have?",
    "choice_a": "Biometric",
    "choice_b": "Possession",
    "choice_c": "Knowledge",
    "choice_d": "Inherence",
    "correct_answer": "B",
    "explanation": "Michelle\u2019s security token is an example of a possession factor, or \u201csomething you have.\u201d A password or PIN would be a knowledge factor or \u201csomething you know,\u201d and a fingerprint or retina scan would be a biometric, or inherence, factor.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      42,
      43,
      9,
      14,
      16
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 27,
    "question": "Which party in a federated identity service model makes assertions about identities to service providers?",
    "choice_a": "RPs",
    "choice_b": "CDUs",
    "choice_c": "IDPs",
    "choice_d": "APs",
    "correct_answer": "C",
    "explanation": "Identity providers (IDPs) make assertions about identities to relying parties and service providers in a federation. CDUs and APs are not terms used in federated identity designs.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      44,
      45,
      49,
      48,
      46
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 28,
    "question": "What design concept requires that each action requested be verified and validated before it is allowed to occur?",
    "choice_a": "Secure access service edge",
    "choice_b": "Zero trust",
    "choice_c": "Trust but verify",
    "choice_d": "Extended validation network",
    "correct_answer": "B",
    "explanation": "Zero trust requires each action or use of privileges to be validated and verified before it is allowed to occur. Secure access service edge combines software-defined networking with other security products and services to control edge device security rather than requiring a secured central service or network. Trust but verify and extended validation network are not design concepts.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      39,
      46,
      9,
      11,
      44
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 29,
    "question": "Juan\u2019s organization uses LDAP to allow users to log into a variety of services without having to type in their username and password again. What type of service is in use?",
    "choice_a": "SSO",
    "choice_b": "MFA",
    "choice_c": "EDR",
    "choice_d": "ZeroAuth",
    "correct_answer": "A",
    "explanation": "Juan\u2019s organization is using a single sign-on (SSO) solution that allows users to sign in once and use multiple services. MFA is multifactor authentication; EDR is endpoint detection and response, an endpoint security tool; and ZeroAuth was made up for this question.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      43,
      45,
      49,
      42,
      67
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 30,
    "question": "Jen\u2019s organization wants to ensure that administrator credentials are not used improperly. What type of solution should Jen recommend to address this requirement?",
    "choice_a": "SAML",
    "choice_b": "CASB",
    "choice_c": "PAM",
    "choice_d": "PKI",
    "correct_answer": "C",
    "explanation": "A privilege access management (PAM) system would not only allow Jen\u2019s organization to manage and monitor privilege use for administrator accounts but would be helpful for other privileges as well. SAML is an XML-based language used to send authorization and authentication data, a CASB is a cloud access security broker used to manage cloud access rights, and PKI is a public key infrastructure used to issue and manage security certificates.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      46,
      49,
      67,
      43,
      52
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 31,
    "question": "Financial and medical records are an example of what type of data?",
    "choice_a": "CHD",
    "choice_b": "PCI",
    "choice_c": "PII",
    "choice_d": "TS/SCI",
    "correct_answer": "C",
    "explanation": "Common examples of PII include financial records, addresses and phone numbers, and national or state identification numbers like Social Security numbers, passport numbers, and driver\u2019s license numbers in the United States. CHD is cardholder data. PCI is the payment card industry, which defines the PCI DSS security standard. TS/SCI is a U.S. classification label standing for Top Secret/Sensitive Compartmented Information.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      54,
      2,
      59,
      95,
      6
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 32,
    "question": "Which of the following is not part of cardholder data for credit cards?",
    "choice_a": "The cardholder\u2019s name",
    "choice_b": "The CVV code",
    "choice_c": "The expiration date",
    "choice_d": "The primary account number",
    "correct_answer": "B",
    "explanation": "The primary account number (PAN), the cardholder\u2019s name, and the expiration date of the card are considered cardholder data. Sensitive authentication data includes the CVV code, the contents of the magnetic stripe and chip, and the PIN code if one is used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      53,
      59,
      2,
      3
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 33,
    "question": "Sally wants to find configuration files for a Windows system. Which of the following is <i>not</i> a common configuration file location?",
    "choice_a": "The Windows Registry",
    "choice_b": "<code>C:\\Program Files\\</code>",
    "choice_c": "<code><i>directory:</i>\\Windows\\Temp</code>",
    "choice_d": "<code>C:\\ProgramData\\</code>",
    "correct_answer": "C",
    "explanation": "The temporary files directory is not a common location for configuration files for programs. Instead, the Registry, <code>ProgramData</code>, and <code>Program Data</code> directories are commonly used to store configuration information.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      31,
      12,
      32,
      72,
      60
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 34,
    "question": "What type of factor is a PIN?",
    "choice_a": "A location factor",
    "choice_b": "A biometric factor",
    "choice_c": "A possession factor",
    "choice_d": "A knowledge factor",
    "correct_answer": "D",
    "explanation": "A PIN is something you know and thus is a knowledge factor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 35,
    "question": "What protocol is used to ensure that logs are time synchronized?",
    "choice_a": "TTP",
    "choice_b": "NTP",
    "choice_c": "SAML",
    "choice_d": "FTP",
    "correct_answer": "B",
    "explanation": "NTP (Network Time Protocol) is the underlying protocol used to ensure that systems are using synchronized time.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      34,
      35,
      72,
      82,
      69
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 36,
    "question": "OAuth, OpenID, SAML, and AD FS are all examples of what type of technology?",
    "choice_a": "Federation",
    "choice_b": "Multifactor authentication",
    "choice_c": "Identity vetting",
    "choice_d": "PKI",
    "correct_answer": "A",
    "explanation": "OAuth, OpenID, SAML, and AD FS are all examples of technologies used for federated identity. They aren\u2019t MFA, identity vetting, or PKI technologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      49,
      43,
      48
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 37,
    "question": "Example Corporation has split their network into network zones that include sales, HR, research and development, and guest networks, each separated from the others using network security devices. What concept is Example Corporation using for their network security?",
    "choice_a": "Segmentation",
    "choice_b": "Software-defined networking",
    "choice_c": "Single-point-of-failure avoidance",
    "choice_d": "Zoned routing",
    "correct_answer": "A",
    "explanation": "Example Corporation is using segmentation, separating different risk or functional groupings. Software-defined networking is not mentioned, as no code-based changes or configurations are being made. There is nothing to indicate a single point of failure, and zoned routing was made up for this question\u2014but the zone routing protocol is a network protocol used to maintain routes in a local network region.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      11,
      37,
      10,
      36,
      9
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 38,
    "question": "During a penetration test of Anna\u2019s company, the penetration testers were able to compromise the company\u2019s web servers and deleted their log files, preventing analysis of their attacks. What compensating control is best suited to prevent this issue in the future?",
    "choice_a": "Using full-disk encryption",
    "choice_b": "Using log rotation",
    "choice_c": "Sending logs to a syslog server",
    "choice_d": "Using TLS to protect traffic",
    "correct_answer": "C",
    "explanation": "Sending logs to a remote log server or bastion host is an appropriate compensating control. This ensures that copies of the logs exist in a secure location, allowing them to be reviewed if a similar compromise occurred. Full-disk encryption leaves files decrypted while in use and would not secure the log files from a compromise, whereas log rotation simply means that logs get changed out when they hit a specific size or time frame. TLS encryption for data (including logs) in transit can keep it private and prevent modification but wouldn\u2019t protect the logs from being deleted.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      13,
      52,
      72,
      1,
      6
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 39,
    "question": "Ben is preparing a system hardening procedure for his organization. Which of the following is <i>not</i> a typical system hardening process or step?",
    "choice_a": "Updating and patching systems",
    "choice_b": "Enabling additional services",
    "choice_c": "Enabling logging",
    "choice_d": "Configuration disk encryption",
    "correct_answer": "B",
    "explanation": "Ben knows that hardening processes typically focus on disabling unnecessary services, not enabling additional services. Updating, patching, enabling logging, and configuring security capabilities like disk encryption are all common hardening practices.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      29,
      12,
      35,
      52,
      96
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 40,
    "question": "Gabby is designing a multifactor authentication system for her company. She has decided to use a passphrase, a time-based code generator, and a PIN to provide additional security. How many distinct factors will she have implemented when she is done?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "While it may seem like Gabby has implemented three different factors, both a PIN and a passphrase are knowledge-based factors and cannot be considered distinct factors. She has implemented two distinct factors with her design. If she wanted to add a third factor, she could replace either the password or the PIN with a fingerprint scan or other biometric factor.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      42,
      1,
      29,
      9,
      43
    ],
    "source": "182909_Ch02"
  },
  {
    "id": 41,
    "question": "Which of the following Linux commands will show you how much disk space is in use?",
    "choice_a": "<code>top</code>",
    "choice_b": "<code>df</code>",
    "choice_c": "<code>lsof</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "B",
    "explanation": "The <code>df</code> command will show you a system\u2019s current disk utilization. Both the <code>top</code> command and the <code>ps</code> command will show you information about processes, CPU, and memory utilization, whereas <code>lsof</code> is a multifunction tool for listing open files.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      64,
      62,
      32,
      61,
      72
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 42,
    "question": "What Windows tool provides detailed information, including information about USB host controllers, memory usage, and disk transfers?",
    "choice_a": "Statmon",
    "choice_b": "Resmon",
    "choice_c": "Perfmon",
    "choice_d": "Winmon",
    "correct_answer": "C",
    "explanation": "Perfmon, or Performance Monitor, provides the ability to gather detailed usage statistics for many items in Windows. Resmon, or Resource Monitor, monitors CPU, memory, and disk usage but does not provide information about things like USB host controllers and other detailed instrumentation. Statmon and winmon are not Windows built-in tools.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      60,
      62,
      66,
      69,
      72
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 43,
    "question": "What type of network information should you capture to be able to provide a report about how much traffic systems in your network sent to remote systems?",
    "choice_a": "Syslog data",
    "choice_b": "WMI data",
    "choice_c": "Resmon data",
    "choice_d": "Flow data",
    "correct_answer": "D",
    "explanation": "Flow data provides information about the source and destination IP address, protocol, and total data sent and would provide the detail needed. Syslog, WMI, and resmon data are all system log information and would not provide this information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      57,
      56,
      75,
      59
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 44,
    "question": "Which of the following technologies is best suited to prevent wired rogue devices from connecting to a network?",
    "choice_a": "NAC",
    "choice_b": "PRTG",
    "choice_c": "Port security",
    "choice_d": "NTP",
    "correct_answer": "A",
    "explanation": "Network access control (NAC) can be set up to require authentication. Port security is limited to recognizing MAC addresses, making it less suited to preventing rogue devices. PRTG is a monitoring tool, and NTP is the Network Time Protocol.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      9,
      36,
      10,
      11,
      37
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 45,
    "question": "As part of her job, Danielle sets an alarm to notify her team via email if her Windows server uses 80 percent of its memory and to send a text message if it reaches 90 percent utilization. What is this setting called?",
    "choice_a": "A monitoring threshold",
    "choice_b": "A preset notification level",
    "choice_c": "Page monitoring",
    "choice_d": "Perfmon calibration",
    "correct_answer": "A",
    "explanation": "A monitoring threshold is set to determine when an alarm or report action is taken. Thresholds are often set to specific values or percentages of capacity.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      62,
      60,
      35,
      8,
      24
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 46,
    "question": "Chris is reviewing a file that is part of an exploit package. He notes that there is a file that has content with curly brackets (<code>{}</code>) around statements. What file type from the following list he most likely reviewing?",
    "choice_a": "Plain text",
    "choice_b": "JSON",
    "choice_c": "XML",
    "choice_d": "HTML",
    "correct_answer": "B",
    "explanation": "Chris is most likely reviewing a JSON file. HTML and XML typically use angle brackets (<code><</code> and <code>></code>) rather than curly brackets. Plain text does not use or require either.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      83,
      76,
      18,
      77,
      82
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 47,
    "question": "What term describes a system sending heartbeat traffic to a botnet command-and-control server?",
    "choice_a": "Beaconing",
    "choice_b": "Zombie ping",
    "choice_c": "CNCstatus",
    "choice_d": "CNClog",
    "correct_answer": "A",
    "explanation": "Beaconing activity (sometimes called heartbeat traffic) occurs when traffic is sent to a botnet command-and-control system. The other terms are made up.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      79,
      75,
      56,
      95,
      73
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 48,
    "question": "Cameron wants to check if a file matches a known-good original. What technique can he use to do so?",
    "choice_a": "Decrypt both the file and the original to compare them.",
    "choice_b": "Use strings to compare the file content.",
    "choice_c": "Hash both the file and the original and compare the hashes.",
    "choice_d": "Check the file size and creation date.",
    "correct_answer": "C",
    "explanation": "Cameron should compare the hashes of the known-good original and the new file to see if they match. The files are not described as encrypted, so decrypting them won\u2019t help. Strings can show text in binary files but won\u2019t compare the files. File size and creation date are not guarantees of a file being the same.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      1,
      62,
      4,
      6
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 49,
    "question": "What can the MAC address of a rogue device tell you?",
    "choice_a": "Its operating system version",
    "choice_b": "The TTL of the device",
    "choice_c": "What type of rogue it is",
    "choice_d": "The manufacturer of the device",
    "correct_answer": "D",
    "explanation": "Hardware vendor ID codes are part of MAC addresses and can be checked for devices that have not had their MAC address changed. It is possible to change MAC addresses, so relying on only the MAC address is not recommended, but it can be useful to help identify what a rogue device might be.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      36,
      9,
      19,
      79
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 50,
    "question": "How can Jim most effectively locate a wireless rogue access point that is causing complaints from employees in his building?",
    "choice_a": "Nmap",
    "choice_b": "Signal strength and triangulation",
    "choice_c": "Connecting to the rogue AP",
    "choice_d": "NAC",
    "correct_answer": "B",
    "explanation": "Locating a rogue AP is often best done by performing a physical survey and triangulating the likely location of the device by checking its signal strength. If the AP is plugged into the organization\u2019s network, nmap may be able to find it, but connecting to it is unlikely to provide its location (or be safe!). NAC would help prevent the rogue device from connecting to an organizational network but won\u2019t help locate it.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      15,
      14,
      9,
      55,
      94
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 51,
    "question": "Which of the following tools does not provide real-time drive capacity monitoring for Windows?",
    "choice_a": "Microsoft Configuration Manager",
    "choice_b": "Resmon",
    "choice_c": "SCOM",
    "choice_d": "Perfmon",
    "correct_answer": "A",
    "explanation": "Microsoft Configuration Manager provides non-real-time reporting for disk space. Resmon, perfmon, and SCOM can all provide real-time reporting, which can help identify problems before they take a system down.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      60,
      62,
      69,
      68,
      12
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 52,
    "question": "One of the business managers in Geeta\u2019s organization reports that she received an email with a link that appeared to be a link to the organization\u2019s HR website, and that the website it went to when she clicked on it was very similar to the organization\u2019s website. Fortunately, the manager noticed that the URL was different than usual. What technique best describes a link that is disguised to appear legitimate?",
    "choice_a": "An obfuscated link",
    "choice_b": "A symbolic link",
    "choice_c": "A phishing link",
    "choice_d": "A decoy link",
    "correct_answer": "A",
    "explanation": "Obfuscated links take advantage of tricks, including using alternate encodings, typos, and long URLs that contain legitimate links wrapped in longer malicious links. Symbolic links are a pointer used by Linux operating systems to point to an actual file using a filename and link. Phishing links and decoy links are not common terms.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      95,
      84,
      88,
      70,
      59
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 53,
    "question": "Angela wants to review the syslog on a Linux system. What directory should she check to find it on most Linux distributions?",
    "choice_a": "<code> /home/log</code>",
    "choice_b": "<code> /var/log</code>",
    "choice_c": "<code> /log</code>",
    "choice_d": "<code> /var/syslog</code>",
    "correct_answer": "B",
    "explanation": "The syslog file is found in <code>/var/log</code> on most Linux hosts.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      72,
      31,
      35,
      34,
      64
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 54,
    "question": "Laura wants to review headers in an email that one of her staff is suspicious of. What should she not have that person do if she wants to preserve the headers?",
    "choice_a": "She shouldn\u2019t have them print the email.",
    "choice_b": "She shouldn\u2019t have them reply to the email.",
    "choice_c": "She shouldn\u2019t have them forward the email to her.",
    "choice_d": "She shouldn\u2019t have them download the email.",
    "correct_answer": "C",
    "explanation": "Forwarding an email will remove the headers and replace them with new headers on the forwarded email\u2014but not the original. Laura should use a \u201cview headers\u201d or \u201cview original email\u201d option if it exists to view and analyze the headers. Printing, replying, or downloading an email will not impact the headers.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      31
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 55,
    "question": "Which of the following is a key differentiator between a SIEM and a SOAR?",
    "choice_a": "A SIEM does not provide a dashboard.",
    "choice_b": "A SOAR provides automated response capabilities.",
    "choice_c": "A SOAR does not provide log aggregation.",
    "choice_d": "A SIEM provides log analysis.",
    "correct_answer": "B",
    "explanation": "SOAR tools focus on orchestration and response. SIEM tools typically do not focus on automated response. Both leverage log analysis and aggregation and will provide dashboards and reporting.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      22,
      78,
      24,
      23,
      81
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 56,
    "question": "Which of the following options is not a valid way to check the status of a service in Windows?",
    "choice_a": "Use <code>sc</code> at the command line.",
    "choice_b": "Use <code>service \u2013\u2013status</code> at the command line.",
    "choice_c": "Use <code>services.msc</code>.",
    "choice_d": "Query service status using PowerShell.",
    "correct_answer": "B",
    "explanation": "The <code>service --status</code> command is a Linux command. Windows service status can be queried using <code>sc</code>, the Services snap-in for the Microsoft Management Console (MMC), or via a PowerShell query.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      32,
      71,
      69,
      72
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 57,
    "question": "Avik has been asked to identify unexpected traffic on her organization\u2019s network. Which of the following is not a technique she should use?",
    "choice_a": "Protocol analysis",
    "choice_b": "Heuristics",
    "choice_c": "Baselining",
    "choice_d": "Beaconing",
    "correct_answer": "D",
    "explanation": "Protocol analysis, using heuristic (behavior)-based detection capabilities, and building a network traffic baseline are all common techniques used to identify unexpected network traffic. Beaconing occurs when a system contacts a botnet command-and-control (C&C) system, and it is likely to be a source of unexpected traffic.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      56,
      79,
      75,
      55,
      70
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 58,
    "question": "Sofia suspects that a system in her datacenter may be sending beaconing traffic to a remote system. Which of the following is not a useful tool to help verify her suspicions?",
    "choice_a": "Flows",
    "choice_b": "A protocol analyzer",
    "choice_c": "SNMP",
    "choice_d": "An IDS or IPS",
    "correct_answer": "C",
    "explanation": "SNMP will not typically provide specific information about a system\u2019s network traffic that would allow you to identify outbound connections. Flows, sniffers (protocol analyzers), and an IDS or IPS can all provide a view that would allow the suspect traffic to be captured.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      79,
      55,
      75,
      73,
      56
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 59,
    "question": "Susan wants to use an email security protocol to determine the authenticity of an email. Which of the following options will ensure that her organization\u2019s email server can determine if it should accept email from a sender?",
    "choice_a": "DMARC",
    "choice_b": "SPF",
    "choice_c": "DKIM",
    "choice_d": "POP3",
    "correct_answer": "A",
    "explanation": "DMARC (Domain-Based Message Authentication, Reporting, and Conformance) is a protocol that combines SPF and DKIM to prove that a sender is who they claim to be. DKIM validates that a domain is associated with a message, whereas SPF lists the servers that are authorized to send from your domain. POP3 is an email protocol but does not perform the function described.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [],
    "source": "182909_Ch03"
  },
  {
    "id": 60,
    "question": "Juan wants to see a list of processes along with their CPU utilization in an interactive format. What built-in Linux tool should he use?",
    "choice_a": "<code>df</code>",
    "choice_b": "<code>top</code>",
    "choice_c": "<code>tail</code>",
    "choice_d": "<code>cpugrep</code>",
    "correct_answer": "B",
    "explanation": "The <code>top</code> command in Linux provides an interactive interface to view CPU utilization, memory usage, and other details for running processes. <code>df</code> shows disk usage, <code>tail</code> displays the end of a file, and <code>cpugrep</code> is a made-up command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      62,
      32,
      68,
      69
    ],
    "source": "182909_Ch03"
  },
  {
    "id": 61,
    "question": "Which of the following measures is not commonly used to assess threat intelligence?",
    "choice_a": "Timeliness",
    "choice_b": "Detail",
    "choice_c": "Accuracy",
    "choice_d": "Relevance",
    "correct_answer": "B",
    "explanation": "While higher levels of detail can be useful, it isn\u2019t a common measure used to assess threat intelligence. Instead, the timeliness, accuracy, and relevance of the information are considered critical to determining whether you should use the threat information.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      86,
      89,
      87,
      85,
      88
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 62,
    "question": "Nandita has encountered an attacker who appears to be using a commonly available exploit package to attack her organization. The package seems to have been run with default configurations against her entire public-facing Internet presence from a single system. What type of threat actor is she most likely facing?",
    "choice_a": "An APT",
    "choice_b": "A hacktivist",
    "choice_c": "A script kiddie",
    "choice_d": "A nation-state actor",
    "correct_answer": "C",
    "explanation": "The lack of complexity and nuance most likely indicates that she has discovered an attack by an unskilled attacker, sometimes called a \u201cscript kiddie.\u201d.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      6,
      89,
      84,
      95
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 63,
    "question": "Which of the following activities follows threat data analysis in the threat intelligence cycle?",
    "choice_a": "Gathering feedback",
    "choice_b": "Threat data collection",
    "choice_c": "Threat data review",
    "choice_d": "Threat intelligence dissemination",
    "correct_answer": "D",
    "explanation": "Threat intelligence dissemination or sharing typically follows threat data analysis. The goal is to get the threat data into the hands of the organizations and individuals who need it.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      89,
      90,
      88,
      91,
      98
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 64,
    "question": "Susan wants to start performing intelligence gathering. Which of the following options is frequently conducted in the requirements gathering stage?",
    "choice_a": "Review of security breaches or compromises your organization has faced",
    "choice_b": "Review of current vulnerability scans",
    "choice_c": "Review of current data handling standards",
    "choice_d": "Review of threat intelligence feeds for new threats",
    "correct_answer": "A",
    "explanation": "Understanding what your organization needs is important for the requirements gathering phase of the intelligence cycle. Reviewing recent breaches and compromises can help to define what threats you are currently facing. Current vulnerability scans can identify where you may be vulnerable but are less useful for threat identification. Data handling standards do not provide threat information, and intelligence feed reviews list new threats, but those are useful only if you know what type of threats you\u2019re likely to face so that you can determine which ones you should target.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      92,
      6,
      5,
      90
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 65,
    "question": "What organizations did the U.S. government help create to help share knowledge between organizations in specific verticals?",
    "choice_a": "DHS",
    "choice_b": "SANS",
    "choice_c": "CERTs",
    "choice_d": "ISACs",
    "correct_answer": "D",
    "explanation": "The U.S. government created the information sharing and analysis centers (ISACs). ISACs help infrastructure owners and operators share threat information, as well as provide tools and assistance to their members.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      91,
      90,
      89,
      88,
      98
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 66,
    "question": "Which of the following threat actors typically has the greatest access to resources?",
    "choice_a": "Nation-state actors",
    "choice_b": "Organized crime",
    "choice_c": "Hacktivists",
    "choice_d": "Insider threats",
    "correct_answer": "A",
    "explanation": "Nation-state actors are government sponsored and typically have the greatest access to resources, including tools, money, and talent.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      92,
      5,
      94,
      89,
      84
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 67,
    "question": "Organizations like Anonymous, which target governments and businesses for political reasons, are examples of what type of threat actor?",
    "choice_a": "Hacktivists",
    "choice_b": "Military assets",
    "choice_c": "Nation-state actors",
    "choice_d": "Organized crime",
    "correct_answer": "A",
    "explanation": "Hacktivists execute attacks for political reasons, including those against governments and businesses. The key element in this question is the political reasons behind the attack.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      92,
      89,
      6,
      4,
      5
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 68,
    "question": "Jason gathers threat intelligence that tells him that an adversary his organization considers a threat likes to use USB key drops to compromise their targets. What is this an example of?",
    "choice_a": "His organization\u2019s attack surface",
    "choice_b": "A possible attack vector",
    "choice_c": "An example of adversary capability",
    "choice_d": "A probability assessment",
    "correct_answer": "B",
    "explanation": "Attack vectors, or the means by which an attacker can gain access to their target, can include things like USB key drops. You may be tempted to answer this question with adversary capability, but remember the definition: the resources, intent, or ability of the likely threat actor. Capability here doesn\u2019t mean what they can do but their ability to do so. The attack surface might include the organization\u2019s parking lot in this example, but this is not an example of an attack surface, and there was no probability assessment included in this problem.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      89,
      6,
      4,
      8,
      94
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 69,
    "question": "What type of assessment is particularly useful for identifying insider threats?",
    "choice_a": "Behavioral",
    "choice_b": "Instinctual",
    "choice_c": "Habitual",
    "choice_d": "IOCs",
    "correct_answer": "A",
    "explanation": "Behavioral assessments are very useful when you are attempting to identify insider threats. Since insider threats are often hard to distinguish from normal behavior context of the actions performed, such as after-hours logins, misuse of credentials, and logins from abnormal locations or in abnormal patterns, other behavioral indicators are often used.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      80,
      7,
      92,
      59,
      56
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 70,
    "question": "Felix want to gather threat intelligence about an organized crime threat actor. Where is he most likely to find information published by the threat actor ?",
    "choice_a": "Social media",
    "choice_b": "Blogs",
    "choice_c": "Government bulletins",
    "choice_d": "The dark web",
    "correct_answer": "D",
    "explanation": "Threat actors like criminal organizations frequently operate via the dark web. Forums operate as clearinghouses for information, resources, and access via TOR-hosted sites. While social media, blogs, or government bulletins may provide information about a criminal organization, more likely to publish information themselves on the dark web.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      92,
      89,
      84,
      85,
      90
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 71,
    "question": "Which of the following is not a common indicator of compromise?",
    "choice_a": "Administrative account logins",
    "choice_b": "Unexpected modifications of configuration files",
    "choice_c": "Login activity from atypical countries or locations",
    "choice_d": "Large outbound data transfers from administrative systems",
    "correct_answer": "A",
    "explanation": "Administrative logins themselves are not IOCs, but unexpected behavior associated with them or other atypical behavior is an indicator of compromise. Unexpected modifications of configuration files, login activity from atypical countries or locations, and large file transfers from administrative systems are all common indicators of compromise.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      95,
      80,
      59,
      62,
      70
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 72,
    "question": "Nick wants to analyze attacker tactics and techniques. What type of tool can he deploy to most effectively capture actual attack data for analysis?",
    "choice_a": "A firewall",
    "choice_b": "A honeypot",
    "choice_c": "A web application firewall",
    "choice_d": "A SIEM",
    "correct_answer": "B",
    "explanation": "Nick should deploy a honeypot to capture attack tools and techniques for further analysis. Firewalls block traffic. A web application firewall is a firewall designed to protect web applications, and while it may capture useful information it is not as well suited to this purpose. A SIEM, or security information and event management tool, may also capture relevant attack data but it\u2019s not specifically designed for the purpose like a honeypot is.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      97,
      93,
      73,
      75,
      15
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 73,
    "question": "Which of the following is not a common focus area for threat hunting activities?",
    "choice_a": "Policies",
    "choice_b": "Misconfigurations",
    "choice_c": "Isolated networks",
    "choice_d": "Business-critical assets",
    "correct_answer": "A",
    "explanation": "Threat hunters are less likely to look at policies. Instead, configurations and misconfigurations, isolated networks, and business-critical assets are all common focuses of threat hunters.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      96,
      94,
      92,
      98,
      90
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 74,
    "question": "What term describes an analysis of threat information that might include details such as whether it is confirmed by multiple independent sources or has been directly confirmed?",
    "choice_a": "Threat quality level",
    "choice_b": "STIX level",
    "choice_c": "Confidence level",
    "choice_d": "Assurance level",
    "correct_answer": "C",
    "explanation": "The confidence level of your threat information is how certain you are of the information. A high confidence threat assessment will typically be confirmed either by multiple independent and reliable sources or via direct verification.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      86,
      89,
      88,
      87,
      98
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 75,
    "question": "What drove the creation of ISACs in the United States?",
    "choice_a": "Threat information sharing for infrastructure owners",
    "choice_b": "The Cybersecurity Act of 1994",
    "choice_c": "Threat information collection network providers",
    "choice_d": "The 1998 ISAC Act",
    "correct_answer": "A",
    "explanation": "ISACs were introduced in 1998 as part of a presidential directive, and they focus on threat information sharing and analysis for critical infrastructure owners.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      88,
      89,
      90,
      98
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 76,
    "question": "How is threat intelligence sharing most frequently used for vulnerability management?",
    "choice_a": "To identify zero-day threats before they are released",
    "choice_b": "As part of vulnerability feeds for scanning systems",
    "choice_c": "As part of patch management processes to determine which patches are not installed",
    "choice_d": "To perform quantitative risk assessment",
    "correct_answer": "B",
    "explanation": "Threat intelligence feeds often provide information about what vulnerabilities are being actively exploited as well as about new exploits. This can influence patching priorities and vulnerability management efforts. Zero-day threats aren\u2019t known until they are released. Vulnerability management efforts help to determine what patches aren\u2019t installed, but threat intelligence doesn\u2019t determine that. Threat intelligence isn\u2019t directly leveraged for quantitative risk assessment as part of vulnerability management efforts in typical organizations.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      90,
      89,
      95,
      86,
      88
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 77,
    "question": "OpenIOC uses a base set of indicators of compromise originally created and provided by which security company?",
    "choice_a": "Mandiant",
    "choice_b": "McAfee",
    "choice_c": "CrowdStrike",
    "choice_d": "Cisco",
    "correct_answer": "A",
    "explanation": "The threat indicators built into OpenIOC are based on Mandiant\u2019s indicator list. You can extend and include additional indicators of compromise beyond the 500 built-in definitions.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      88,
      95,
      84,
      24,
      87
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 78,
    "question": "Advanced persistent threats are most commonly associated with which type of threat actor?",
    "choice_a": "Insider threats",
    "choice_b": "Nation-state actors",
    "choice_c": "Organized crime",
    "choice_d": "Hacktivists",
    "correct_answer": "B",
    "explanation": "Advanced persistent threats (APTs) are most commonly associated with nation-state actors. The complexity of their operations and the advanced tools that they bring typically require significant resources to leverage fully.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      93,
      6,
      8,
      4
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 79,
    "question": "What are the two types of insider threats?",
    "choice_a": "Attack and defense",
    "choice_b": "Approved and prohibited",
    "choice_c": "Real and imagined",
    "choice_d": "Intentional and unintentional",
    "correct_answer": "D",
    "explanation": "Insider threats may be intentional or unintentional.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      7,
      92,
      5,
      8,
      70
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 80,
    "question": "Forensic data is most often used for what type of threat assessment data?",
    "choice_a": "STIX",
    "choice_b": "Behavioral",
    "choice_c": "IOCs",
    "choice_d": "TAXII",
    "correct_answer": "C",
    "explanation": "Forensic data is very helpful when defining indicators of compromise (IOCs). Behavioral threat assessments can also be partially defined by forensic data, but the key here is where the data is most frequently used.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      95,
      93,
      79,
      24,
      89
    ],
    "source": "182909_Ch04"
  },
  {
    "id": 81,
    "question": "Megan wants to use the Metasploit Framework to conduct a web application vulnerability scan. What module from the following list is best suited to her needs?",
    "choice_a": "smb_login",
    "choice_b": "Angry IP",
    "choice_c": "nmap",
    "choice_d": "wmap",
    "correct_answer": "D",
    "explanation": "The wmap scanner is a web application scanner module for the Metasploit Framework that can scan for vulnerable web applications. The smb_login tool looks for SMB shares, not web applications. Angry IP Scanner is not integrated with Metasploit, and nmap is a port scanner, not a full web application vulnerability scanner.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      124,
      134,
      131,
      135
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 82,
    "question": "What command-line tool can be used to determine the path that traffic takes to a remote system?",
    "choice_a": "Whois",
    "choice_b": "traceroute",
    "choice_c": "nslookup",
    "choice_d": "routeview",
    "correct_answer": "B",
    "explanation": "Traceroute (or tracert on Windows systems) is a command-line tool that uses ICMP to trace the route that a packet takes to a host. Whois and nslookup are domain tools, and routeview is not a command-line tool.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      99,
      113,
      107,
      100,
      106
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 83,
    "question": "Valerie wants to use a graphical interface to control nmap and wants to display her scans as a visual map to help her understand her target networks. What tool from the following list should she use?",
    "choice_a": "Angry IP Scanner",
    "choice_b": "wmap",
    "choice_c": "Zenmap",
    "choice_d": "nmap-gs",
    "correct_answer": "C",
    "explanation": "Zenmap is a graphical user interface for nmap that also supports graphical output, including visual maps of networks. Valerie can use Zenmap to control nmap and create the output she wants. Angry IP Scanner is a separate scanner and does not generate a visual map of networks\u2014instead, it provides lists. Wmap is a plug-in for the Metasploit Framework and a stand-alone tool that is a web application and service vulnerability testing tool, and nmap-gs was made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      103,
      100,
      105
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 84,
    "question": "Susan runs an nmap scan using the following command:<br>nmap -<code>O</code> -Pn 192.168.1.0/255 <br>What information will she see about the hosts she scans?",
    "choice_a": "The hostname and service ports",
    "choice_b": "The hostname, service ports, and operating system",
    "choice_c": "The hostname and operating system",
    "choice_d": "The hostname, uptime, and logged-in user",
    "correct_answer": "B",
    "explanation": "Along with the time to run the scan and time to live of packets sent, Susan will see the hostname, service ports, and operating system using the scan flags above. The <code>-O</code> flag attempts to identify the operating system, while the <code><i>-Pn</i></code> flag skips pinging and scans all hosts in the network on their typically scanned ports.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      103,
      106,
      104,
      118
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 85,
    "question": "Tuan wants to gather additional information about a domain that he has entered in Maltego. What functionality is used to perform server-based actions in Maltego?",
    "choice_a": "A worker",
    "choice_b": "A query",
    "choice_c": "A transform",
    "choice_d": "A scan",
    "correct_answer": "C",
    "explanation": "Maltego calls its server-based functions for information gathering \u201ctransforms.\u201d.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      116,
      113,
      114,
      103,
      100
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 86,
    "question": "Laura wants to conduct a search for hosts using Recon-ng but wants to leverage a search engine with API access to acquire existing data. What module should she use?",
    "choice_a": "recon/companies-multi/whois_miner",
    "choice_b": "import/nmap",
    "choice_c": "recon/domains-hosts/shodan_hostname",
    "choice_d": "import/list",
    "correct_answer": "C",
    "explanation": "While you may not know the full list of Recon-ng plug-ins, Shodan is a well-known search engine. Laura could leverage API access to Shodan to gather information from previously performed searches. Both the import utilities will require her to have data she has already gathered, and the Whois miner can be assumed to use Whois information rather than an existing search engine dataset.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      116,
      114,
      113,
      103,
      107
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 87,
    "question": "After running an nmap scan, Geoff sees ports 80 and 443 open on a system he scanned. What reasonable guess can he make about the system based on this result?",
    "choice_a": "The system is a Windows system.",
    "choice_b": "The system is running a database server.",
    "choice_c": "The system is a Linux system.",
    "choice_d": "The system is running a web server.",
    "correct_answer": "D",
    "explanation": "Ports 80 and 443 are commonly associated with unencrypted (port 80) and TLS encrypted (port 443) web servers. There is not enough information to determine if this might be a Windows or Linux system, and these are not typical ports for a database server.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      100,
      103,
      101,
      107,
      118
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 88,
    "question": "What information is used to identify network segments and topology when conducting an nmap scan?",
    "choice_a": "IP addresses",
    "choice_b": "Hostnames",
    "choice_c": "Time to live",
    "choice_d": "Port numbers",
    "correct_answer": "C",
    "explanation": "The time to live (TTL) provided as part of responses is used to evaluate the number of hops in a network, and thus to derive a best guess at network topology. While IP addresses can sometimes be related to network topology, they\u2019re less likely to be directly associated with it. Hostnames and port numbers have no correlation to topology.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      99,
      102,
      101,
      113,
      105
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 89,
    "question": "Murali wants to scan a network using nmap and has run a scan without any flags without discovering all of the hosts that he thinks should show. What scan flag can he use to scan without performing host discovery that will also determine if services are open on the systems?",
    "choice_a": "<code>-sn</code>",
    "choice_b": "<code>-PS</code>",
    "choice_c": "<code>-Pn</code>",
    "choice_d": "-<code>sL</code>",
    "correct_answer": "C",
    "explanation": "The -<code>Pn</code>, or \u201cno ping\u201d, flag skips host discovery and performs a port scan. The <code>-sn</code> flag skips the port scan after discovery, <code>sL</code> lists hosts by performing DNS lookups, and <code>-PS</code> performs probes using a TCP SYN.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      103,
      107,
      99,
      106
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 90,
    "question": "Jaime is using the Angry IP Scanner and notices that it supports multiple types of pings to identify hosts. Why might she choose to use a specific type of ping over others?",
    "choice_a": "To bypass firewalls",
    "choice_b": "To allow better vulnerability detection",
    "choice_c": "To prevent the scan from being flagged by DDoS protection tools",
    "choice_d": "To leverage the faster speed of TCP pings over UDP pings",
    "correct_answer": "A",
    "explanation": "Some firewalls block ICMP ping but allow UDP or TCP pings. Jaime knows that choosing her ping protocol can help to bypass some firewalls. Angry IP Scanner is not a vulnerability scanner, and UDP pings are faster than TCP pings.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      107,
      102,
      124,
      118,
      153
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 91,
    "question": "Hue wants to perform network footprinting as part of a reconnaissance effort. Which of the following tools is best suited to passive footprinting given a domain name as the starting point for her efforts?",
    "choice_a": "Traceroute",
    "choice_b": "Maltego",
    "choice_c": "Nmap",
    "choice_d": "Angry IP Scanner",
    "correct_answer": "B",
    "explanation": "Hue knows that Maltego provides transforms that can identify hosts and IP addresses related to a domain and that it can then gather additional information using other OSINT transforms. Nmap and Angry IP Scanner are both active scanning tools, and traceroute won\u2019t provide useful footprinting information given just a domain name.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      116,
      102,
      113,
      114,
      99
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 92,
    "question": "Jack wants to scan a system using the Angry IP Scanner. What information does he need to run the scan?",
    "choice_a": "The system\u2019s IP address",
    "choice_b": "The system\u2019s Whois data",
    "choice_c": "The system\u2019s MAC address",
    "choice_d": "The system administrator\u2019s username and password",
    "correct_answer": "A",
    "explanation": "To conduct a port scan, all Jack needs is an IP address, hostname, or IP range.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      102,
      100,
      118,
      122,
      123
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 93,
    "question": "Which of the following is not a reason that security professionals often perform packet capture while conducting port and vulnerability scanning?",
    "choice_a": "Work process documentation",
    "choice_b": "To capture additional data for analysis",
    "choice_c": "To prevent external attacks",
    "choice_d": "To provide a timeline",
    "correct_answer": "C",
    "explanation": "A packet capture can\u2019t prevent external attacks, although it might capture evidence of one. Packet capture is often used to document work, including the time that a given scan or process occurred, and it can also be used to provide additional data for further analysis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      102,
      104,
      135,
      137
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 94,
    "question": "What process uses information such as the way that a system\u2019s TCP stack responds to queries, what TCP options it supports, and the initial window size it uses?",
    "choice_a": "Service identification",
    "choice_b": "Fuzzing",
    "choice_c": "Application scanning",
    "choice_d": "OS detection",
    "correct_answer": "D",
    "explanation": "Operating system detection often uses TCP options support, IP ID sampling, and window size checks, as well as other indicators that create unique fingerprints for various operating systems. Service identification often leverages banners since TCP capabilities are not unique to a given service. Fuzzing is a code testing method, and application scanning is usually related to web application security.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      101,
      103,
      102,
      100,
      179
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 95,
    "question": "Li wants to use Recon-ng to gather data from systems. Which of the following is not a common use for Recon-ng?",
    "choice_a": "Conducting vulnerability scans of services",
    "choice_b": "Looking for sensitive files",
    "choice_c": "Conducting OSINT gathering of Whois, DNS, and similar data",
    "choice_d": "Finding target IP addresses",
    "correct_answer": "A",
    "explanation": "Recon-ng is not a vulnerability scanner. It does help with OSINT activities like looking for sensitive files, conducting OSINT information gathering, and finding target IP addresses. Li knows that Recong-ng is an OSINT-focused tool and that vulnerability scanning is an active, rather than passive, information-gathering effort. While Recon-ng supports port scanning, it does not have a vulnerability scanner function.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      116,
      113,
      100,
      104
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 96,
    "question": "Jason wants to conduct a port scan using the Metasploit Framework. What tool can he use from the framework to do this?",
    "choice_a": "Angry IP Scanner",
    "choice_b": "Recon-ng",
    "choice_c": "Maltego",
    "choice_d": "Nmap",
    "correct_answer": "D",
    "explanation": "Nmap support is built into MSF, allowing easy port scanning by simply calling nmap as you would normally from the command line. Angry IP Scanner is not built in, and both Recon-ng and Maltego are separate tools with OSINT and information management capabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      103,
      99,
      116,
      118
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 97,
    "question": "Sally wants to use operating system identification using nmap to determine what OS a device is running. Which of the following is not a datapoint used by nmap to identify operating systems?",
    "choice_a": "TCP sequences",
    "choice_b": "TCP timestamps",
    "choice_c": "TCP OS header",
    "choice_d": "TCP options",
    "correct_answer": "C",
    "explanation": "Operating system fingerprinting relies in many cases on knowing what the TCP stack for a given operating system does when it sends responses. You can read more detail about the many ways nmap tests for and filters the data at <code>https://nmap.org/book/osdetect-methods.html#osdetect-probes</code>. Sally knows that banners are provided at interactive logins or by services and that nmap uses network protocol data for OS detection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      102,
      103,
      99,
      106
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 98,
    "question": "Chris wants to perform network-based asset discovery. What limitation will he encounter if he relies on a port scanner to perform his discovery?",
    "choice_a": "Port scanners cannot detect vulnerabilities.",
    "choice_b": "Port scanners cannot determine what services are running on a given port.",
    "choice_c": "Firewalls can prevent port scanners from detecting systems.",
    "choice_d": "A port scanner can create a denial-of-service condition for many modern systems.",
    "correct_answer": "C",
    "explanation": "Firewalls can prevent responses to port scanners, making systems essentially invisible to the scanner. A port scanner alone is not sufficient for asset discovery in many networks. Port scanners often have some limited vulnerability detection built in, often relying on version information or fingerprinting, but not detecting vulnerabilities does not prevent discovery. Port scanners make a best guess at services on a port based on information provided by the service. Port scanners do not typically cause problems for most modern applications and services but can under some circumstances. This shouldn\u2019t stop a discovery port scan, though!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      107,
      105,
      118,
      99,
      108
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 99,
    "question": "Emily wants to gather open source intelligence and centralize it using an open source tool. Which of the following tools is best suited to managing the collection of data for her OSINT efforts?",
    "choice_a": "The Metasploit Framework",
    "choice_b": "Recon-ng",
    "choice_c": "nmap",
    "choice_d": "Angry IP Scanner",
    "correct_answer": "B",
    "explanation": "Recon-ng is a Python-based open source framework for open source intelligence gathering and web-based reconnaissance. The Metasploit Framework is a penetration testing and compromise tool with a multitude of other features, but it is not as well suited to information gathering as a core purpose. Nmap and the Angry IP Scanner are both port scanners.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      116,
      113,
      106,
      104
    ],
    "source": "182909_Ch05"
  },
  {
    "id": 100,
    "question": "What federal law requires the use of vulnerability scanning on information systems operated by federal government agencies?",
    "choice_a": "HIPAA",
    "choice_b": "GLBA",
    "choice_c": "FISMA",
    "choice_d": "FERPA",
    "correct_answer": "C",
    "explanation": "The Federal Information Security Management Act (FISMA) requires that federal agencies implement vulnerability management programs for federal information systems. The Health Insurance Portability and Accountability Act (HIPAA) regulates the ways that healthcare providers, insurance companies, and their business associates handle protected health (PHI) information. Similarly, the Gramm\u2013Leach\u2013Bliley Act (GLBA) governs how financial institutions handle customer financial records. The Family Educational Rights and Privacy Act (FERPA), which is not covered in this chapter or on the CySA+ exam, allows parents to access their children\u2019s educational records.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      117,
      104,
      130,
      125,
      129
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 101,
    "question": "Which one of the following industry standards describes a standard approach for setting up an information security management system?",
    "choice_a": "OWASP",
    "choice_b": "CIS",
    "choice_c": "ISO 27002",
    "choice_d": "ISO 27001",
    "correct_answer": "D",
    "explanation": "ISO 27001 describes a standard approach for setting up an information security management system, while ISO 27002 goes into more detail on the specifics of information security controls. The Open Web Application Security Project (OWASP) provides advice and tools focused on web application security. The Center for Internet Security (CIS) produces a set of configuration benchmarks used to securely configure operating systems, applications, and devices.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      121,
      183,
      181,
      182,
      188
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 102,
    "question": "What tool can administrators use to help identify the systems present on a network prior to conducting vulnerability scans?",
    "choice_a": "Asset inventory",
    "choice_b": "Web application assessment",
    "choice_c": "Router",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "An asset inventory supplements automated tools with other information to detect systems present on a network. The asset inventory provides critical information for vulnerability scans.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      118,
      105,
      122,
      107,
      99
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 103,
    "question": "Tonya is configuring vulnerability scans for a system that is subject to the PCI DSS compliance standard. What is the minimum frequency with which she must conduct scans?",
    "choice_a": "Daily",
    "choice_b": "Weekly",
    "choice_c": "Monthly",
    "choice_d": "Quarterly",
    "correct_answer": "D",
    "explanation": "PCI DSS requires that organizations conduct vulnerability scans on at least a quarterly basis, although many organizations choose to conduct scans on a much more frequent basis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      122,
      136,
      126
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 104,
    "question": "Which one of the following is not an example of a vulnerability scanning tool?",
    "choice_a": "Nikto",
    "choice_b": "Snort",
    "choice_c": "Nessus",
    "choice_d": "OpenVAS",
    "correct_answer": "B",
    "explanation": "Nessus and OpenVAS are network vulnerability scanning tools, while Nikto is a web application vulnerability scanner. Snort is an intrusion detection system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      124,
      123,
      131,
      134
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 105,
    "question": "Bethany is the vulnerability management specialist for a large retail organization. She completed her last PCI DSS compliance scan in March. In April, the organization upgraded their point-of-sale system, and Bethany is preparing to conduct new scans. When must she complete the new scan?",
    "choice_a": "Immediately.",
    "choice_b": "June.",
    "choice_c": "December.",
    "choice_d": "No scans are required.",
    "correct_answer": "A",
    "explanation": "PCI DSS requires that organizations conduct vulnerability scans quarterly, which would have Bethany\u2019s next regularly scheduled scan scheduled for June. However, the standard also requires scanning after any significant change in the payment card environment. This would include an upgrade to the point-of-sale system, so Bethany must complete a new compliance scan immediately.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      119,
      117,
      167,
      186,
      126
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 106,
    "question": "Renee is configuring her vulnerability management solution to perform credentialed scans of servers on her network. What type of account should she provide to the scanner?",
    "choice_a": "Domain administrator",
    "choice_b": "Local administrator",
    "choice_c": "Root",
    "choice_d": "Read-only",
    "correct_answer": "D",
    "explanation": "Credentialed scans only require read-only access to target servers. Renee should follow the principle of least privilege and limit the access available to the scanner.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      123,
      104,
      124,
      117,
      130
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 107,
    "question": "Jason is writing a report about a potential security vulnerability in a software product and wishes to use standardized product names to ensure that other security analysts understand the report. Which SCAP component can Jason turn to for assistance?",
    "choice_a": "CVSS",
    "choice_b": "CVE",
    "choice_c": "CPE",
    "choice_d": "OVAL",
    "correct_answer": "C",
    "explanation": "Common Platform Enumeration (CPE) is an SCAP component that provides standardized nomenclature for product names and versions.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      125,
      132,
      133,
      134,
      131
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 108,
    "question": "Bill would like to run an internal vulnerability scan on a system for PCI DSS compliance purposes. Who is authorized to complete one of these scans?",
    "choice_a": "Any employee of the organization",
    "choice_b": "An approved scanning vendor",
    "choice_c": "A PCI DSS service provider",
    "choice_d": "Any qualified individual",
    "correct_answer": "D",
    "explanation": "Internal scans completed for PCI DSS compliance purposes may be conducted by any qualified individual.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      117,
      124,
      123,
      104,
      136
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 109,
    "question": "Which type of organization is the most likely to face a regulatory requirement to conduct vulnerability scans?",
    "choice_a": "Bank",
    "choice_b": "Hospital",
    "choice_c": "Government agency",
    "choice_d": "Doctor\u2019s office",
    "correct_answer": "C",
    "explanation": "The Federal Information Security Management Act (FISMA) requires that government agencies conduct vulnerability scans. HIPAA, which governs hospitals and doctors\u2019 offices, does not include a vulnerability scanning requirement, nor does GLBA, which covers financial institutions. Banks may be required to conduct scans under PCI DSS, but this is a contractual obligation and not a statutory requirement.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      117,
      119,
      122,
      136,
      186
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 110,
    "question": "Which one of the following organizations focuses on providing tools and advice for secure web application development?",
    "choice_a": "OWASP",
    "choice_b": "CIS",
    "choice_c": "NIST",
    "choice_d": "Microsoft",
    "correct_answer": "A",
    "explanation": "All of these organizations provide security tools and advice. However, only the Open Web Application Security Project (OWASP) has a dedicated focus on the development of secure web applications.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      176,
      144,
      174,
      177
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 111,
    "question": "What term describes an organization\u2019s willingness to tolerate risk in their computing environment?",
    "choice_a": "Risk landscape",
    "choice_b": "Risk appetite",
    "choice_c": "Risk level",
    "choice_d": "Risk adaptation",
    "correct_answer": "B",
    "explanation": "The organization\u2019s risk appetite is its willingness to tolerate risk within the environment. If an organization is extremely risk-averse, it may choose to conduct scans more frequently to minimize the amount of time between when a vulnerability comes into existence and when it is detected by a scan.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      119,
      160,
      154,
      159,
      152
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 112,
    "question": "Which one of the following factors is least likely to impact vulnerability scanning schedules?",
    "choice_a": "Regulatory requirements",
    "choice_b": "Technical constraints",
    "choice_c": "Business constraints",
    "choice_d": "Staff availability",
    "correct_answer": "D",
    "explanation": "Scan schedules are most often determined by the organization\u2019s risk appetite, regulatory requirements, technical constraints, business constraints, and licensing limitations. Most scans are automated and do not require staff availability.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      119,
      117,
      122,
      130,
      118
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 113,
    "question": "Barry placed all of his organization\u2019s credit card processing systems on an isolated network dedicated to card processing. He has implemented appropriate segmentation controls to limit the scope of PCI DSS to those systems through the use of VLANs and firewalls. When Barry goes to conduct vulnerability scans for PCI DSS compliance purposes, what systems must he scan?",
    "choice_a": "Customer systems",
    "choice_b": "Systems on the isolated network",
    "choice_c": "Systems on the general enterprise network",
    "choice_d": "Both B and C",
    "correct_answer": "B",
    "explanation": "If Barry is able to limit the scope of his PCI DSS compliance efforts to the isolated network, then that is the only network that must be scanned for PCI DSS compliance purposes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      118,
      186,
      162,
      119
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 114,
    "question": "Ryan is planning to conduct a vulnerability scan of a business-critical system using dangerous plug-ins. What would be the best approach for the initial scan?",
    "choice_a": "Run the scan against production systems to achieve the most realistic results possible.",
    "choice_b": "Run the scan during business hours.",
    "choice_c": "Run the scan in a test environment.",
    "choice_d": "Do not run the scan to avoid disrupting the business.",
    "correct_answer": "C",
    "explanation": "Ryan should first run his scan against a test environment to identify likely vulnerabilities and assess whether the scan itself might disrupt business activities.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      171,
      129,
      130,
      119,
      122
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 115,
    "question": "Which one of the following activities is not part of the vulnerability management life cycle?",
    "choice_a": "Detection",
    "choice_b": "Remediation",
    "choice_c": "Reporting",
    "choice_d": "Testing",
    "correct_answer": "C",
    "explanation": "Although reporting and communication are an important part of vulnerability management, they are not included in the life cycle. The three life-cycle phases are detection, remediation, and testing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      128,
      127,
      125,
      135
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 116,
    "question": "What approach to vulnerability scanning incorporates information from agents running on the target servers?",
    "choice_a": "Continuous monitoring",
    "choice_b": "Ongoing scanning",
    "choice_c": "On-demand scanning",
    "choice_d": "Alerting",
    "correct_answer": "A",
    "explanation": "Continuous monitoring incorporates data from agent-based approaches to vulnerability detection and reports security-related configuration changes to the vulnerability management platform as soon as they occur, providing the ability to analyze those changes for potential vulnerabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      126,
      120,
      124,
      117
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 117,
    "question": "Kolin would like to use an automated web application vulnerability scanner to identify any potential security issues in an application that is about to be deployed in his environment. Which one of the following tools is least likely to meet his needs?",
    "choice_a": "ZAP",
    "choice_b": "Nikto",
    "choice_c": "Arachni",
    "choice_d": "Burp Suite",
    "correct_answer": "A",
    "explanation": "The Zed Attack Proxy (ZAP) is a proxy server that may be used in web application penetration tests but it is not itself an automated vulnerability scanning tool. Nikto and Arachni are examples of dedicated web application vulnerability scanners. Burp Suite is a web proxy used in penetration testing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      134,
      131,
      135,
      116,
      123
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 118,
    "question": "Jessica is reading reports from vulnerability scans run by different part of her organization using different products. She is responsible for assigning remediation resources and is having difficulty prioritizing issues from different sources. What SCAP component can help Jessica with this task?",
    "choice_a": "CVSS",
    "choice_b": "CVE",
    "choice_c": "CPE",
    "choice_d": "XCCDF",
    "correct_answer": "A",
    "explanation": "The Common Vulnerability Scoring System (CVSS) provides a standardized approach for measuring and describing the severity of security vulnerabilities. Jessica could use this scoring system to prioritize issues raised by different source systems.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      132,
      133,
      128,
      126,
      131
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 119,
    "question": "Sarah would like to run an external vulnerability scan on a system for PCI DSS compliance purposes. Who is authorized to complete one of these scans?",
    "choice_a": "Any employee of the organization",
    "choice_b": "An approved scanning vendor",
    "choice_c": "A PCI DSS service provider",
    "choice_d": "Any qualified individual",
    "correct_answer": "B",
    "explanation": "While any qualified individual may conduct internal compliance scans, PCI DSS requires the use of a scanning vendor approved by the PCI SSC for external compliance scans.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      117,
      124,
      104,
      118,
      122
    ],
    "source": "182909_Ch06"
  },
  {
    "id": 120,
    "question": "Tom is reviewing a vulnerability scan report and finds that one of the servers on his network suffers from an internal IP address disclosure vulnerability. What technology is likely in use on this network that resulted in this vulnerability?",
    "choice_a": "TLS",
    "choice_b": "NAT",
    "choice_c": "SSH",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "Although the network can support any of these protocols, internal IP disclosure vulnerabilities occur when a network uses Network Address Translation (NAT) to map public and private IP addresses but a server inadvertently discloses its private IP address to remote systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      131,
      146,
      108,
      112
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 121,
    "question": "Which one of the CVSS metrics would contain information about the type of account access that an attacker must have to execute an attack?",
    "choice_a": "AV",
    "choice_b": "C",
    "choice_c": "PR",
    "choice_d": "AC",
    "correct_answer": "C",
    "explanation": "The privileges required (PR) metric indicates the type of account access the attacker must have.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      128,
      125,
      126
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 122,
    "question": "Which one of the following values for the CVSS attack complexity metric would indicate that the specified attack is simplest to exploit?",
    "choice_a": "High",
    "choice_b": "Medium",
    "choice_c": "Low",
    "choice_d": "Severe",
    "correct_answer": "C",
    "explanation": "An attack complexity of \u201clow\u201d indicates that exploiting the vulnerability does not require any specialized conditions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      128,
      125,
      126
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 123,
    "question": "Which one of the following values for the confidentiality, integrity, or availability CVSS metric would indicate the potential for total compromise of a system?",
    "choice_a": "N",
    "choice_b": "L",
    "choice_c": "M",
    "choice_d": "H",
    "correct_answer": "D",
    "explanation": "A value of High (H) for an impact metric indicates the potential for complete loss of confidentiality, integrity, and/or availability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      128,
      125,
      159
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 124,
    "question": "What is the most recent version of CVSS that is currently available?",
    "choice_a": "2.0",
    "choice_b": "2.5",
    "choice_c": "3.1",
    "choice_d": "3.2",
    "correct_answer": "C",
    "explanation": "CVSS 3.1 is the most recent version of the standard as of the time this book was published in 2023.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      125,
      128,
      140
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 125,
    "question": "Which one of the following metrics is not included in the calculation of the CVSS exploitability score?",
    "choice_a": "Attack vector",
    "choice_b": "Vulnerability age",
    "choice_c": "Attack complexity",
    "choice_d": "Privileges required",
    "correct_answer": "B",
    "explanation": "The CVSS exploitability score is computed using the attack vector (AV), attack complexity (AC), privileges required (PR), and user interaction (UI) metrics. Vulnerability age is not an included metric.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      133,
      132,
      125,
      128,
      126
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 126,
    "question": "Kevin recently identified a new software vulnerability and computed its CVSS base score as 6.5. Which risk category would this vulnerability fall into?",
    "choice_a": "Low",
    "choice_b": "Medium",
    "choice_c": "High",
    "choice_d": "Critical",
    "correct_answer": "B",
    "explanation": "Vulnerabilities with CVSS base scores between 4.0 and 6.9 fit into the medium risk category.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      132,
      128,
      152,
      154
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 127,
    "question": "Tara recently analyzed the results of a vulnerability scan report and found that a vulnerability reported by the scanner did not exist because the system was actually patched as specified. What type of error occurred?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "True positive",
    "choice_d": "True negative",
    "correct_answer": "A",
    "explanation": "A false positive error occurs when the vulnerability scanner reports a vulnerability that does not actually exist.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      131,
      137,
      128,
      127
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 128,
    "question": "Which one of the following is not a common source of information that may be correlated with vulnerability scan results?",
    "choice_a": "Logs",
    "choice_b": "Database tables",
    "choice_c": "SIEM",
    "choice_d": "Configuration management system",
    "correct_answer": "B",
    "explanation": "It is unlikely that a database table would contain information relevant to assessing a vulnerability scan report. Logs, SIEM reports, and configuration management systems are much more likely to contain relevant information.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      137,
      131,
      167,
      125,
      127
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 129,
    "question": "Which one of the following operating systems should be avoided on production networks?",
    "choice_a": "Windows Server 2008 R2",
    "choice_b": "Red Hat Enterprise Linux 9",
    "choice_c": "Debian Linux 11",
    "choice_d": "Ubuntu 22",
    "correct_answer": "A",
    "explanation": "Microsoft discontinued support for Windows Server 2008 R2 in 2020, and it is highly likely that the operating system contains unpatchable vulnerabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      168,
      140,
      139,
      162
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 130,
    "question": "In what type of attack does the attacker place more information in a memory location than is allocated for that use?",
    "choice_a": "SQL injection",
    "choice_b": "LDAP injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Buffer overflow",
    "correct_answer": "D",
    "explanation": "Buffer overflow attacks occur when an attacker manipulates a program into placing more data into an area of memory than is allocated for that program\u2019s use. The goal is to overwrite other information in memory with instructions that may be executed by a different process running on the system.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      142,
      175,
      174,
      148,
      125
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 131,
    "question": "The Dirty COW attack is an example of what type of vulnerability?",
    "choice_a": "Malicious code",
    "choice_b": "Privilege escalation",
    "choice_c": "Buffer overflow",
    "choice_d": "LDAP injection",
    "correct_answer": "B",
    "explanation": "In October 2016, security researchers announced the discovery of a Linux kernel vulnerability dubbed Dirty COW. This vulnerability, present in the Linux kernel for nine years, was extremely easy to exploit and provided successful attackers with administrative control of affected systems.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      139,
      138,
      168,
      132,
      136
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 132,
    "question": "Which one of the following protocols should never be used on a public network?",
    "choice_a": "SSH",
    "choice_b": "HTTPS",
    "choice_c": "SFTP",
    "choice_d": "Telnet",
    "correct_answer": "D",
    "explanation": "Telnet is an insecure protocol that does not make use of encryption. The other protocols mentioned are all considered secure.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      143,
      141,
      175,
      174,
      149
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 133,
    "question": "Betty is selecting a transport encryption protocol for use in a new public website she is creating. Which protocol would be the best choice?",
    "choice_a": "SSL 2.0",
    "choice_b": "SSL 3.0",
    "choice_c": "TLS 1.0",
    "choice_d": "TLS 1.3",
    "correct_answer": "D",
    "explanation": "TLS 1.3 is a secure transport protocol that supports web traffic. The other protocols listed all have flaws that render them insecure and unsuitable for use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      176,
      177,
      144,
      175
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 134,
    "question": "Which one of the following conditions would not result in a certificate warning during a vulnerability scan of a web server?",
    "choice_a": "Use of an untrusted CA",
    "choice_b": "Inclusion of a public encryption key",
    "choice_c": "Expiration of the certificate",
    "choice_d": "Mismatch in certificate name",
    "correct_answer": "B",
    "explanation": "Digital certificates are intended to provide public encryption keys, and this would not cause an error. The other circumstances are all causes for concern and would trigger an alert during a vulnerability scan.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      143,
      131,
      124,
      140,
      137
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 135,
    "question": "What type of attack depends on the fact that users are often logged into many websites simultaneously in the same browser?",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Cross-site request forgery",
    "choice_d": "File inclusion",
    "correct_answer": "C",
    "explanation": "XSRF attacks work by making the reasonable assumption that users are often logged into many different websites at the same time. Attackers then embed code in one website that sends a command to a second website.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      148,
      165,
      174,
      162
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 136,
    "question": "penetration testers attempted to access the following URL:<br><code>www.mycompany.com/sortusers.php?file=C:\\uploads\\attack.exe</code><br>What type of attack did they most likely attempt?",
    "choice_a": "Reflected XSS",
    "choice_b": "Persistent XSS",
    "choice_c": "Local file inclusion",
    "choice_d": "Remote file inclusion",
    "correct_answer": "C",
    "explanation": "This URL contains the address of a local file passed to a web application as an argument. It is most likely a local file inclusion (LFI) exploit, attempting to execute a malicious file that the testers previously uploaded to the server.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      148,
      144,
      177,
      174,
      165
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 137,
    "question": "Which one of the following terms is not typically used to describe the connection of physical devices to a network?",
    "choice_a": "IoT",
    "choice_b": "IDS",
    "choice_c": "SCADA",
    "choice_d": "ICS",
    "correct_answer": "B",
    "explanation": "Intrusion detection systems (IDSs) are a security control used to detect network or host attacks. The Internet of Things (IoT), supervisory control and data acquisition (SCADA) systems, and industrial control systems (ICSs) are all associated with connecting physical world objects to a network.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      147,
      162,
      161,
      153,
      183
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 138,
    "question": "Monica discovers that an attacker posted a message in a web forum that she manages that is attacking users who visit the site. Which one of the following attack types is most likely to have occurred?",
    "choice_a": "SQL injection",
    "choice_b": "Malware injection",
    "choice_c": "LDAP injection",
    "choice_d": "Cross-site scripting",
    "correct_answer": "D",
    "explanation": "In a cross-site scripting (XSS) attack, an attacker embeds scripting commands on a website that will later be executed by an unsuspecting visitor accessing the site. The idea is to trick a user visiting a trusted site into executing malicious code placed there by an untrusted third party.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      150,
      148,
      174,
      165
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 139,
    "question": "Alan is reviewing web server logs after an attack and finds many records that contain semicolons and apostrophes in queries from end users. What type of attack should he suspect?",
    "choice_a": "SQL injection",
    "choice_b": "LDAP injection",
    "choice_c": "Cross-site scripting",
    "choice_d": "Buffer overflow",
    "correct_answer": "A",
    "explanation": "In a SQL injection attack, the attacker seeks to use a web application to gain access to an underlying database. Semicolons and apostrophes are characteristic of these attacks.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      144,
      176,
      177,
      179,
      115
    ],
    "source": "182909_Ch07"
  },
  {
    "id": 140,
    "question": "Jen identified a missing patch on a Windows server that might allow an attacker to gain remote control of the system. After consulting with her manager, she applied the patch. From a risk management perspective, what has she done?",
    "choice_a": "Removed the threat",
    "choice_b": "Reduced the threat",
    "choice_c": "Removed the vulnerability",
    "choice_d": "Reduced the vulnerability",
    "correct_answer": "C",
    "explanation": "By applying the patch, Jen has removed the vulnerability from her server. This also has the effect of eliminating this particular risk. Jen cannot control the external threat of an attacker attempting to gain access to her server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      162,
      140,
      159,
      126
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 141,
    "question": "You notice a high number of SQL injection attacks against a web application run by your organization and you install a web application firewall to block many of these attacks before they reach the server. How have you altered the severity of this risk?",
    "choice_a": "Reduced the magnitude",
    "choice_b": "Eliminated the vulnerability",
    "choice_c": "Reduced the probability",
    "choice_d": "Eliminated the threat",
    "correct_answer": "C",
    "explanation": "Installing a web application firewall reduces the probability that an attack will reach the web server. Vulnerabilities may still exist in the web application and the threat of an external attack is unchanged. The impact of a successful SQL injection attack is also unchanged by a web application firewall.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      154,
      132,
      162,
      161,
      160
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 142,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5% chance of a successful attack in any given year.<br>What is the asset value (AV)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "The asset at risk in this case is the customer database. Losing control of the database would result in a $500,000 fine, so the asset value (AV) is $500,000.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      159,
      160,
      153,
      144
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 143,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5% chance of a successful attack in any given year.<br>What is the exposure factor (EF)?",
    "choice_a": "5%",
    "choice_b": "20%",
    "choice_c": "50%",
    "choice_d": "100%",
    "correct_answer": "D",
    "explanation": "The attack would result in the total loss of customer data stored in the database, making the exposure factor (EF) 100%.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      159,
      153,
      160,
      144
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 144,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5% chance of a successful attack in any given year.<br>What is the single loss expectancy (SLE)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "We compute the single loss expectancy (SLE) by multiplying the asset value (AV) ($500,000) and the exposure factor (EF) (100%) to get an SLE of $500,000.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      151,
      159,
      160,
      153,
      164
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 145,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5% chance of a successful attack in any given year.<br>What is the annualized rate of occurrence (ARO)?",
    "choice_a": "0.05",
    "choice_b": "0.20",
    "choice_c": "2.00",
    "choice_d": "5.00",
    "correct_answer": "A",
    "explanation": "Aziz\u2019s threat intelligence research determined that the threat has a 5% likelihood of occurrence each year. This is an ARO of 0.05.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      159,
      160,
      153,
      164
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 146,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm\u2019s customers. He expects that a compromise of that database would result in $500,000 of fines against his firm.<br>Aziz is assessing the risk of a SQL injection attack against the database where the attacker would steal all of the customer personally identifiable information (PII) from the database. After consulting threat intelligence, he believes that there is a 5% chance of a successful attack in any given year.<br>What is the annualized loss expectancy (ALE)?",
    "choice_a": "$5,000",
    "choice_b": "$25,000",
    "choice_c": "$100,000",
    "choice_d": "$500,000",
    "correct_answer": "B",
    "explanation": "We compute the annualized loss expectancy (ALE) by multiplying the SLE ($500,000) and the ARO (0.05) to get an ALE of $25,000.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      151,
      159,
      160,
      153,
      164
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 147,
    "question": "Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace\u2019s first idea is to add a web application firewall to protect her organization against SQL injection attacks. What risk management strategy does this approach adopt?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Installing new controls or upgrading existing controls is an effort to reduce the probability or magnitude of a risk. This is an example of a risk mitigation activity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      160,
      161,
      162,
      144,
      186
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 148,
    "question": "Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Business leaders are considering dropping the customer activities that collect and store sensitive personal information. What risk management strategy would this approach use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "B",
    "explanation": "Changing business processes or activities to eliminate a risk is an example of risk avoidance.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      160,
      156,
      157,
      158,
      159
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 149,
    "question": "Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>The business decided to install the web application firewall and continue doing business. They still were worried about other risks to the information that were not addressed by the firewall and consider purchasing an insurance policy to cover those risks. What strategy does this use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Insurance policies use a risk transference strategy by shifting some or all of the financial risk from the organization to an insurance company.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      160,
      158,
      159,
      154
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 150,
    "question": "Grace recently completed a risk assessment of her organization\u2019s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>In the end, risk managers found that the insurance policy was too expensive and opted not to purchase it. They are taking no additional action. What risk management strategy is being used in this situation?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "A",
    "explanation": "When an organization decides to take no further action to address remaining risk, they are choosing a strategy of risk acceptance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      158,
      157,
      156,
      159
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 151,
    "question": "Which of the following is a formal process that allows organizations to open their systems to inspection by security researchers in a controlled environment?",
    "choice_a": "Edge discovery",
    "choice_b": "Passive discovery",
    "choice_c": "Security controls testing",
    "choice_d": "Bug bounty",
    "correct_answer": "D",
    "explanation": "Bug bounty programs provide a formal process that allows organizations to open their systems to inspection by security researchers in a controlled environment that encourages attackers to report vulnerabilities in a responsible fashion. Edge discovery scanning identifies any systems or devices with public exposure by scanning IP addresses belonging to the organization. Passive discovery techniques monitor inbound and outbound traffic to detect devices that did not appear during other discovery scans. Security controls testing verifies that the organization\u2019s array of security controls are functioning properly.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      166,
      165,
      118,
      161,
      153
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 152,
    "question": "Which of the following is often used to assist with the prevention of XSS and SQL injection attacks?",
    "choice_a": "Secure session management",
    "choice_b": "Input validation",
    "choice_c": "SLOs",
    "choice_d": "Maintenance windows",
    "correct_answer": "B",
    "explanation": "Input validation helps prevent a wide range of problems, from cross-site scripting (XSS) to SQL injection attacks. Secure session management ensures that attackers cannot hijack user sessions or that session issues don\u2019t cause confusion among users. Organizations that offer technology services to customers may define service level objectives (SLOs) that set formal expectations for service availability, data preservation, and other key requirements. Many organizations choose to consolidate many changes in a single period of time known as a maintenance window. Maintenance windows typically occur on evenings and weekends or during other periods of time where business activity is low.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      176,
      148,
      145,
      150
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 153,
    "question": "Which of the following is designed specifically to support penetration testing and the reverse engineering of malware?",
    "choice_a": "Immunity debugger",
    "choice_b": "GDB",
    "choice_c": "SDLC",
    "choice_d": "Parameterized queries",
    "correct_answer": "A",
    "explanation": "The Immunity debugger is designed specifically to support penetration testing and the reverse engineering of malware. GNU debugger (GDB) is a widely used open source debugger for Linux that works with a variety of programming languages. The software development life cycle (SDLC) describes the steps in a model for software development throughout its life. Parameterized queries prevent SQL injection attacks by precompiling SQL queries so that new code may not be inserted when the query is executed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      106,
      104,
      178,
      179
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 154,
    "question": "Jason gathers threat intelligence that notes that an adversary that his organization considers a threat likes to use USB key drops to compromise their targets. What is this an example of?",
    "choice_a": "His organization\u2019s attack surface",
    "choice_b": "A possible attack vector",
    "choice_c": "An example of adversary capability",
    "choice_d": "A probability assessment",
    "correct_answer": "B",
    "explanation": "Attack vectors, or the means by which an attacker can gain access to their target can include things like USB key drops. You may be tempted to answer this question with adversary capability, but remember the definition: the resources, intent, or ability of the likely threat actor. Capability here doesn\u2019t mean what they can do, but their ability to do so. The attack surface might include the organization\u2019s parking lot in this example, but this is not an example of an attack surface, and there was no probability assessment included in this problem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      153,
      161,
      165,
      154
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 155,
    "question": "STRIDE, PASTA, and LIDDUN are all examples of what?",
    "choice_a": "Zero-day rating systems",
    "choice_b": "Vulnerability assessment tools",
    "choice_c": "Adversary analysis tools",
    "choice_d": "Threat classification tools",
    "correct_answer": "D",
    "explanation": "STRIDE, PASTA, and LIDDUN are all examples of threat classification tools. LIDDUN focuses on threats to privacy, STRIDE is a Microsoft tool, and PASTA is an attacker-centric threat modeling tool.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      164,
      159,
      154,
      162
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 156,
    "question": "What type of software testing tool executes the code as it is being tested?",
    "choice_a": "Static analysis",
    "choice_b": "Dynamic analysis",
    "choice_c": "Compilation",
    "choice_d": "Decompilation",
    "correct_answer": "B",
    "explanation": "Dynamic analysis techniques actually execute the code during the testing process. Static code analysis tools and techniques analyze the structure and content of code without executing the code itself. Compilation is the process of transforming source code into an executable and decompilation attempts to reverse that process. Neither compilation nor decompilation executes the code.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      178,
      173,
      170
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 157,
    "question": "Adam is conducting software testing by reviewing the source code of the application. What type of code testing is Adam conducting?",
    "choice_a": "Mutation testing",
    "choice_b": "Static code analysis",
    "choice_c": "Dynamic code analysis",
    "choice_d": "Fuzzing",
    "correct_answer": "B",
    "explanation": "Adam is conducting static code analysis by reviewing the source code. Dynamic code analysis requires running the program, and both mutation testing and fuzzing are types of dynamic analysis.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      178,
      179,
      180,
      173,
      174
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 158,
    "question": "During testing, Tiffany slowly increases the number of connections to an application until it fails. What is she doing?",
    "choice_a": "Regression testing",
    "choice_b": "Unit testing",
    "choice_c": "Stress testing",
    "choice_d": "Fagan testing",
    "correct_answer": "C",
    "explanation": "Tiffany is stress-testing the application. Stress testing intentionally goes beyond the application\u2019s normal limits to see how it responds to extreme loads or other abnormal conditions beyond its normal capacity. Unit testing tests individual components of an applications, while regression testing is done to ensure that new versions don\u2019t introduce old bugs. Fagan testing is a formal method of code inspection.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      179,
      180,
      170,
      173,
      174
    ],
    "source": "182909_Ch08"
  },
  {
    "id": 159,
    "question": "Which one of the following is an example of a computer security incident?",
    "choice_a": "User accesses a secure file",
    "choice_b": "Administrator changes a file\u2019s permission settings",
    "choice_c": "Intruder breaks into a building",
    "choice_d": "Former employee crashes a server",
    "correct_answer": "D",
    "explanation": "A former employee crashing a server is an example of a computer security incident because it is an actual violation of the availability of that system. A user accessing a secure file and an administrator changing file permission settings are examples of security events but are not security incidents.<br>An intruder breaking into a building may be a security event, but it is not necessarily a computer security event unless they perform some action affecting a computer system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      190,
      192,
      199,
      193,
      194
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 160,
    "question": "During what phase of the incident response process would an organization implement defenses designed to reduce the likelihood of a security incident?",
    "choice_a": "Preparation",
    "choice_b": "Detection and analysis",
    "choice_c": "Containment, eradication, and recovery",
    "choice_d": "Post-incident activity",
    "correct_answer": "A",
    "explanation": "Organizations should build solid, defense-in-depth approaches to cybersecurity during the preparation phase of the incident response process. The controls built during this phase serve to reduce the likelihood and impact of future incidents.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      191,
      195,
      193,
      267,
      222
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 161,
    "question": "Alan is responsible for developing his organization\u2019s detection and analysis capabilities. He would like to purchase a system that can combine log records from multiple sources to detect potential security incidents. What type of system is best suited to meet Alan\u2019s security objective?",
    "choice_a": "IPS",
    "choice_b": "IDS",
    "choice_c": "SIEM",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "A security information and event management (SIEM) system correlates log entries from multiple sources and attempts to identify potential security incidents.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      192,
      211,
      208,
      210,
      224
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 162,
    "question": "Ben is working to classify the functional impact of an incident. The incident has disabled email service for approximately 30 percent of his organization\u2019s staff. How should Ben classify the functional impact of this incident according to the NIST scale?",
    "choice_a": "None",
    "choice_b": "Low",
    "choice_c": "Medium",
    "choice_d": "High",
    "correct_answer": "C",
    "explanation": "The definition of a medium functional impact is that the organization has lost the ability to provide a critical service to a subset of system users. That accurately describes the situation that Ben finds himself in. Assigning a low functional impact is only done when the organization can provide all critical services to all users at diminished efficiency. Assigning a high functional impact is only done if a critical service is not available to all users.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      201,
      204,
      203,
      199,
      190
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 163,
    "question": "What phase of the incident response process would include measures designed to limit the damage caused by an ongoing breach?",
    "choice_a": "Preparation",
    "choice_b": "Detection and analysis",
    "choice_c": "Containment, eradication, and recovery",
    "choice_d": "Post-incident activity",
    "correct_answer": "C",
    "explanation": "The containment protocols contained in the containment, eradication, and recovery phases are designed to limit the damage caused by an ongoing security incident.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      214,
      215,
      216,
      221
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 164,
    "question": "What common criticism is leveled at the Cyber Kill Chain?",
    "choice_a": "Not all threats are aimed at a kill.",
    "choice_b": "It is too detailed.",
    "choice_c": "It includes actions outside the defended network.",
    "choice_d": "It focuses too much on insider threats.",
    "correct_answer": "C",
    "explanation": "The Kill Chain includes actions outside the defended network which many defenders cannot take action on, resulting in one of the common criticisms of the model. Other criticisms include the focus on a traditional perimeter and on antimalware-based techniques, as well as a lack of focus on insider threats.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      200,
      208,
      215
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 165,
    "question": "Karen is responding to a security incident that resulted from an intruder stealing files from a government agency. Those files contained unencrypted information about protected critical infrastructure. How should Karen rate the information impact of this loss?",
    "choice_a": "None",
    "choice_b": "Privacy breach",
    "choice_c": "Proprietary breach",
    "choice_d": "Integrity loss",
    "correct_answer": "C",
    "explanation": "In a proprietary breach, unclassified proprietary information is accessed or exfiltrated. Protected critical infrastructure information (PCII) is an example of unclassified proprietary information.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      202,
      201,
      203,
      190,
      225
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 166,
    "question": "Matt is concerned about the fact that log records from his organization contain conflicting timestamps due to unsynchronized clocks. What protocol can he use to synchronize clocks throughout the enterprise?",
    "choice_a": "NTP",
    "choice_b": "FTP",
    "choice_c": "ARP",
    "choice_d": "SSH",
    "correct_answer": "A",
    "explanation": "The Network Time Protocol (NTP) provides a common source of time information that allows the synchronizing of clocks throughout an enterprise.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 167,
    "question": "Which one of the following document types would outline the authority of a CSIRT responding to a security incident?",
    "choice_a": "Policy",
    "choice_b": "Procedure",
    "choice_c": "Playbook",
    "choice_d": "Baseline",
    "correct_answer": "A",
    "explanation": "An organization\u2019s incident response policy should contain a clear description of the authority assigned to the CSIRT while responding to an active security incident.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      195,
      198,
      191,
      225,
      204
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 168,
    "question": "A cross-site scripting attack is an example of what type of threat vector?",
    "choice_a": "Impersonation",
    "choice_b": "Email",
    "choice_c": "Attrition",
    "choice_d": "Web",
    "correct_answer": "D",
    "explanation": "A web attack is an attack executed from a website or web-based application\u2014for example, a cross-site scripting attack used to steal credentials or redirect to a site that exploits a browser vulnerability and installs malware.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      199,
      207,
      206,
      205,
      208
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 169,
    "question": "What phase of the Cyber Kill Chain includes creation of persistent backdoor access for attackers?",
    "choice_a": "Delivery",
    "choice_b": "Exploitation",
    "choice_c": "Installation",
    "choice_d": "C2",
    "correct_answer": "C",
    "explanation": "The installation phase of the Cyber Kill Chain focuses on providing persistent backdoor access for attackers. Delivery occurs when the tool is put into action either directly or indirectly, whereas exploitation occurs when a vulnerability is exploited. Command-and-control (C2) uses two-way communications to provide continued remote control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      208,
      209,
      211
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 170,
    "question": "Robert is finishing a draft of a proposed incident response policy for his organization. Who would be the most appropriate person to sign the policy?",
    "choice_a": "CEO",
    "choice_b": "Director of security",
    "choice_c": "CIO",
    "choice_d": "CSIRT leader",
    "correct_answer": "A",
    "explanation": "The incident response policy provides the CSIRT with the authority needed to do their job. Therefore, it should be approved by the highest possible level of authority within the organization, preferably the CEO.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      195,
      198,
      196,
      191,
      225
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 171,
    "question": "Which one of the following is not an objective of the containment, eradication, and recovery phase of incident response?",
    "choice_a": "Detect an incident in progress.",
    "choice_b": "Implement a containment strategy.",
    "choice_c": "Identify the attackers.",
    "choice_d": "Eradicate the effects of the incident.",
    "correct_answer": "A",
    "explanation": "Detection of a potential incident occurs during the detection and analysis phase of incident response. The other activities listed are all objectives of the containment, eradication, and recovery phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      221,
      222,
      219
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 172,
    "question": "Renee is responding to a security incident that resulted in the unavailability of a website critical to her company\u2019s operations. She is unsure of the amount of time and effort that it will take to recover the website. How should Renee classify the recoverability effort?",
    "choice_a": "Regular",
    "choice_b": "Supplemented",
    "choice_c": "Extended",
    "choice_d": "Not recoverable",
    "correct_answer": "C",
    "explanation": "Extended recoverability effort occurs when the time to recovery is unpredictable. In those cases, additional resources and outside help are typically needed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      203,
      204,
      222,
      196,
      193
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 173,
    "question": "Which one of the following is an example of an attrition attack?",
    "choice_a": "SQL injection",
    "choice_b": "Theft of a laptop",
    "choice_c": "User installs file sharing software",
    "choice_d": "Brute-force password attack",
    "correct_answer": "D",
    "explanation": "An attrition attack employs brute-force methods to compromise, degrade, or destroy systems, networks, or services\u2014for example, a DDoS attack intended to impair or deny access to a service or application or a brute-force attack against an authentication mechanism.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      199,
      208,
      211
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 174,
    "question": "Who is the best facilitator for a post-incident lessons learned session?",
    "choice_a": "CEO",
    "choice_b": "CSIRT leader",
    "choice_c": "Independent facilitator",
    "choice_d": "First responder",
    "correct_answer": "C",
    "explanation": "Lessons learned sessions are most effective when facilitated by an independent party who was not involved in the incident response effort.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      267,
      225,
      266,
      197,
      195
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 175,
    "question": "Which one of the following elements is not normally found in an incident response policy?",
    "choice_a": "Performance measures for the CSIRT",
    "choice_b": "Definition of cybersecurity incidents",
    "choice_c": "Definition of roles, responsibilities, and levels of authority",
    "choice_d": "Procedures for rebuilding systems",
    "correct_answer": "D",
    "explanation": "Procedures for rebuilding systems are highly technical and would normally be included in a playbook or procedure document rather than an incident response policy.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      195,
      191,
      198,
      220,
      221
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 176,
    "question": "An on-path attack is an example of what type of threat vector?",
    "choice_a": "Attrition",
    "choice_b": "Impersonation",
    "choice_c": "Web",
    "choice_d": "Email",
    "correct_answer": "B",
    "explanation": "An impersonation attack involves the replacement of something benign with something malicious\u2014for example, spoofing, on-path (man-in-the-middle) attacks, rogue wireless access points, and SQL injection attacks all involve impersonation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      199,
      200,
      206,
      205,
      208
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 177,
    "question": "Tommy is the CSIRT team leader for his organization and is responding to a newly discovered security incident. What document is most likely to contain step-by-step instructions that he might follow in the early hours of the response effort?",
    "choice_a": "Policy",
    "choice_b": "Baseline",
    "choice_c": "Playbook",
    "choice_d": "Textbook",
    "correct_answer": "C",
    "explanation": "Incident response playbooks contain detailed, step-by-step instructions that guide the early response to a cybersecurity incident. Organizations typically have playbooks prepared for high-severity and frequently occurring incident types.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      195,
      191,
      198,
      192,
      225
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 178,
    "question": "Hank is responding to a security event where the CEO of his company had her laptop stolen. The laptop was encrypted but contained sensitive information about the company\u2019s employees. How should Hank classify the information impact of this security event?",
    "choice_a": "None",
    "choice_b": "Privacy breach",
    "choice_c": "Proprietary breach",
    "choice_d": "Integrity loss",
    "correct_answer": "A",
    "explanation": "The event described in this scenario would not qualify as a security incident with measurable information impact. Although the laptop did contain information that might cause a privacy breach, that breach was avoided by the use of encryption to protect the contents of the laptop.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      190,
      202,
      203,
      214,
      217
    ],
    "source": "182909_Ch09"
  },
  {
    "id": 179,
    "question": "Susan needs to track evidence that has been obtained throughout its life cycle. What documentation does she need to create and maintain if she expects the evidence to be used in a legal case?",
    "choice_a": "Forensic hashes",
    "choice_b": "Legal hold",
    "choice_c": "Chain of custody",
    "choice_d": "IoC ratings",
    "correct_answer": "C",
    "explanation": "Susan needs to track the chain of custody for the evidence and should ensure that a proper chain of custody is maintained. This is especially important when dealing with data that may become part of legal proceedings. Forensic hashes are typically generated as part of forensic processes to ensure that the original and copies of forensic data match, but a hash alone does not provide chain-of-custody tracking. Legal holds require organizations to preserve data but don\u2019t track chain of custody, and IoC ratings are unrelated to this question.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      261,
      246,
      217,
      212,
      265
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 180,
    "question": "Hui wants to comply with a legal hold but knows that her organization has a regular process that purges logs after 45 days due to space limitations. What should she do if the logs are covered by the legal hold?",
    "choice_a": "Notify counsel that the logs will be deleted automatically in 45 days.",
    "choice_b": "Delete the logs now to allow longer before space is filled up.",
    "choice_c": "Identify a preservation method to comply with the hold.",
    "choice_d": "Make no changes; holds allow ongoing processes to continue as normal.",
    "correct_answer": "C",
    "explanation": "Hui knows that she needs to preserve the logs per the legal hold notice and will need to identify a method to preserve the logs while maintaining operations for her organization. Failing to do so can have significant legal repercussions.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      213,
      261,
      212,
      214,
      217
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 181,
    "question": "Juan wants to validate the integrity of a drive that he has forensically imaged as part of an incident response process. Which of the options should he select?",
    "choice_a": "Compare a hash of the original drive to the drive image.",
    "choice_b": "Compare the file size on disk of the original drive to the space taken up by the drive image.",
    "choice_c": "Compare the vendor\u2019s drive size listing to the space taken up by the drive image.",
    "choice_d": "Use PGP to encrypt the drive and image and make sure that both encrypted versions match.",
    "correct_answer": "A",
    "explanation": "Hashes are used to validate drive images and other forensic artifacts. Comparing a hash of the original and the image is commonly used to ensure that they match. None of the other options will validate a drive image, and encrypting a drive will modify it, spoiling the evidence.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      251,
      248,
      212,
      244,
      261
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 182,
    "question": "Kathleen wants to determine if the traffic she is seeing is unusual for her network. Which of the following options would be most useful to determine if traffic levels are not typical for this time of day in a normal week?",
    "choice_a": "Heuristics",
    "choice_b": "Baselines",
    "choice_c": "Protocol analysis",
    "choice_d": "Network flow logs",
    "correct_answer": "B",
    "explanation": "A baseline for traffic patterns and levels would allow Kathleen to determine if the traffic was typical or if something unusual was going on. Heuristics focus on behaviors, and Kathleen wants to see if traffic levels are different, not behaviors. Protocol analysis looks at whether there is an unusual protocol or data, and network flow logs are useful for determining which systems are sending traffic to where and via what protocol.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      192,
      210,
      209,
      266,
      204
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 183,
    "question": "Renee wants to adopt an open IoC feed. What issue is Renee most likely to need to address when adopting it?",
    "choice_a": "The cost of the IoC feed",
    "choice_b": "The quality of the feed",
    "choice_c": "The update frequency of the feed",
    "choice_d": "The level of detail in the feed",
    "correct_answer": "B",
    "explanation": "Open feed data can vary in quality and reliability. That means Renee will have to put processes in place to assess the quality and reliability of the IoC information she is receiving. An open feed implies that it is free. Open feeds are generally active, and IoC detail levels vary as IoCs are created and updated, regardless of the type of feed.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      208,
      211,
      225,
      195,
      206
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 184,
    "question": "Chris wants to use an active monitoring approach to test his network. Which of the following techniques is appropriate?",
    "choice_a": "Collecting NetFlow data",
    "choice_b": "Using a protocol analyzer",
    "choice_c": "Pinging remote systems",
    "choice_d": "Enabling SNMP",
    "correct_answer": "C",
    "explanation": "Active monitoring is focused on reaching out to gather data using tools like ping and iPerf. Passive monitoring using protocol analyzers collects network traffic and router-based monitoring using SNMP, and flows gather data by receiving or collecting logged information.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      192,
      255,
      211,
      214,
      212
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 185,
    "question": "Which of the following is not information commonly found in an IoC?",
    "choice_a": "IP addresses",
    "choice_b": "Domain names",
    "choice_c": "System images",
    "choice_d": "Behavior-based information",
    "correct_answer": "C",
    "explanation": "System images are not typically part of an IOC. Hashes of malicious software may be, as well as IP addresses, hostnames, domains, and behavior- based information, among other common details.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      208,
      225,
      210,
      212,
      200
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 186,
    "question": "Cameron wants to be able to detect a denial-of-service attack against his web server. Which of the following tools should he avoid?",
    "choice_a": "Log analysis",
    "choice_b": "Flow monitoring",
    "choice_c": "iPerf",
    "choice_d": "IPS",
    "correct_answer": "C",
    "explanation": "Log analysis, flow monitoring, and deploying an IPS are all appropriate solutions to help detect denial-of-service attacks. iPerf is a performance testing tool used to establish the maximum bandwidth available on a network connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      192,
      215,
      208,
      191,
      199
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 187,
    "question": "Sameer finds log information that indicates that a process that he believes is malicious starts at the same time every day on a Linux system. Where should he start looking for an issue like this?",
    "choice_a": "He should review the system log.",
    "choice_b": "He should check the Task Scheduler.",
    "choice_c": "He should check cron jobs.",
    "choice_d": "He should check user directories.",
    "correct_answer": "C",
    "explanation": "While there could be other issues, a recurring scheduled task is most likely to be set as a cron job, and Sameer should start his search there. The Task Scheduler is a Windows tool, system logs may or may not contain information about the process, and searching user directories would not provide indications of what process was starting at a given time.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      208,
      210,
      264,
      250,
      225
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 188,
    "question": "Jim uses an IoC feed to help detect new attacks against his organization. What should he do first if his security monitoring system flags a match for an IoC?",
    "choice_a": "Shut down the system that caused the alert",
    "choice_b": "Review the alert to determine why it occurred",
    "choice_c": "Check network logs to identify the remote attacker",
    "choice_d": "Run a port scan to determine if the system is compromised",
    "correct_answer": "B",
    "explanation": "Reviewing why the alert occurred is Jim's first step. IoCs in isolation may not indicate a compromise or attack, so validating the alert is an important first step. shutting down a system due to an alert could cause an outage or prevent forensic investigation. There is nothing in question to indicate that this is a network-based attack that will have been logged, and port scans are also not indicated by the question.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      208,
      211,
      223,
      258,
      195
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 189,
    "question": "While monitoring network traffic to his web server cluster, Mark notices a significant increase in traffic. He checks the source addresses for inbound traffic and finds that the traffic is coming from many different systems all over the world. What should Mark identify this as if he believes that it may be an attack?",
    "choice_a": "A denial-of-service attack",
    "choice_b": "A distributed network scan",
    "choice_c": "A DNS-based attack",
    "choice_d": "A distributed denial-of-service attack",
    "correct_answer": "D",
    "explanation": "The behavior described with a significant increase in traffic from many systems all over the world is most likely a distributed denial-of-service attack if it is malicious. Mark\u2019s challenge will be in determining if it is an attack or if some other event has occurred that is driving traffic to his website\u2014a post that goes viral can be difficult to differentiate from an attack in some cases!",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      199,
      192,
      208,
      204,
      211
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 190,
    "question": "Valentine wants to check for unauthorized access to a system. What two log types are most likely to contain this information?",
    "choice_a": "Authentication logs and user creation logs",
    "choice_b": "System logs and application logs",
    "choice_c": "Authentication logs and application logs",
    "choice_d": "System logs and authentication logs",
    "correct_answer": "A",
    "explanation": "Valentine knows that unauthorized access often involves the creation of unauthorized user accounts and authentication events that allowed access to the system. System logs contain system events, but not authentication or user creation information. Application logs track application events and also typically won\u2019t show this type of information.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      208,
      209,
      250,
      211,
      262
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 191,
    "question": "Sayed notices that a remote system has attempted to log into a system he is responsible for multiple times using the same administrator\u2019s user ID but different passwords. What has Sayed most likely discovered?",
    "choice_a": "A user who forgot their password",
    "choice_b": "A broken application",
    "choice_c": "A brute-force attack",
    "choice_d": "A misconfigured service",
    "correct_answer": "C",
    "explanation": "A series of attempted logins from the remote system with the same username but different passwords is a common indicator of a brute-force attack. While more sophisticated attackers will use multiple remote systems and will spread attempts over time, a simple brute-force attack will appear exactly like this. Sayed can verify this by checking in with the administrator whose username is being used.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      210,
      209,
      199,
      214
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 192,
    "question": "While Susan is monitoring a router via network flows, she sees a sudden drop in network traffic levels to zero, and the traffic chart shows a flat line. What has likely happened?",
    "choice_a": "The sampling rate is set incorrectly.",
    "choice_b": "The router is using SNMP.",
    "choice_c": "The monitored link failed.",
    "choice_d": "A DDoS attack is occurring.",
    "correct_answer": "C",
    "explanation": "The most likely answer is that the link has failed. Incorrectly set sampling rates will not provide a good view of traffic, and a DDoS attack is more likely to show large amounts of traffic. SNMP is a monitoring tool and would not result in flow data changing.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      192,
      211,
      208,
      255,
      199
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 193,
    "question": "Leo wants to monitor his application for common issues. Which of the following is not a typical method of monitoring for application issues?",
    "choice_a": "Up/down logging",
    "choice_b": "System logging",
    "choice_c": "Performance logging",
    "choice_d": "Transactional logging",
    "correct_answer": "B",
    "explanation": "System logging is typically handled separately from application logging. Up/down, performance, transactional logs, and service logging are all common forms of monitoring used to ensure applications are performing correctly.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      224,
      211,
      208,
      192,
      225
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 194,
    "question": "Greg notices that a user account on a Linux server he is responsible for has connected to 10 machines via SSH within seconds. What type of IoC best matches this type of behavior?",
    "choice_a": "Bot-like behavior",
    "choice_b": "Port scanning",
    "choice_c": "Denial of service",
    "choice_d": "Escalation of privileges",
    "correct_answer": "A",
    "explanation": "Actions performed more quickly than a typical user would perform them can be an indicator of bot-like behavior. If the user performing the actions does not typically run scripts or connect to multiple machines, Greg may want to investigate more deeply, including checking logs on the remote systems to see what authentication was attempted. SSH connections alone are not indicators of port scanning, escalation of privilege, or denial-of-service attacks.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      209,
      208,
      211,
      210,
      225
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 195,
    "question": "Arun wants to monitor for unusual database usage. Which of the following is most likely to be indicative of a malicious actor?",
    "choice_a": "Increases in cached hits to the database",
    "choice_b": "Decreases in network traffic to the database",
    "choice_c": "Increases in disk reads for the database",
    "choice_d": "Decreases in database size",
    "correct_answer": "C",
    "explanation": "An attacker is likely to attempt to gather information from the entire database, meaning that cached hits will not make up the full volume of queries. Thus, disk reads from a database may be a more important indicator of compromise than an increase in cached hits that may simply be more typical usage.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      208,
      209,
      211,
      210,
      205
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 196,
    "question": "Valerie is concerned that an attacker may have gained access to a system in her datacenter. Which of the following behaviors is not a common network-based IoC that she should monitor for?",
    "choice_a": "Traffic to unexpected destinations",
    "choice_b": "Unusual volumes of outbound traffic",
    "choice_c": "Increases in system memory consumption",
    "choice_d": "Outbound traffic at unusual times",
    "correct_answer": "C",
    "explanation": "Valerie is specifically looking for network-related IoCs, and system memory consumption is a host- or system-related IoC, not a network-related IoC.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      208,
      209,
      211,
      215,
      221
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 197,
    "question": "Alex has noticed that the primary disk for his Windows server is quickly filling up. What should he do to determine what is filling up the drive?",
    "choice_a": "Check the filesystem logs.",
    "choice_b": "Check the security logs.",
    "choice_c": "Search for large files and directories.",
    "choice_d": "Search for file changes.",
    "correct_answer": "C",
    "explanation": "The first step in Alex\u2019s process should be to identify where the files that are filling the drive are located and what they are. A simple search can help with this by sorting by large directories and files. Windows does not have a filesystem log that would record this, and security logs are focused on security events, not filesystem information. Searching for files that have changed requires a tool that tracks changes, which is not part of a default Windows installation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      250,
      210,
      264,
      192,
      208
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 198,
    "question": "Joseph wants to be notified if user behaviors vary from normal on systems he maintains. He uses a tool to capture and analyze a week of user behavior and uses that to determine if unusual behavior occurs. What is this practice called?",
    "choice_a": "Pattern matching",
    "choice_b": "Baselining",
    "choice_c": "Fingerprinting",
    "choice_d": "User modeling",
    "correct_answer": "B",
    "explanation": "Joseph has created a user behavior baseline, which will allow him to see if there are exceptions to the normal behaviors and commands that users run. Pattern matching, fingerprinting, and user modeling are not terms used to describe this process.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      209,
      211,
      208,
      210,
      206
    ],
    "source": "182909_Ch10"
  },
  {
    "id": 199,
    "question": "Which one of the phases of incident response involves primarily active undertakings designed to limit the damage that an attacker might cause?",
    "choice_a": "Containment, Eradication, and Recovery",
    "choice_b": "Preparation",
    "choice_c": "Post-Incident Activity",
    "choice_d": "Detection and Analysis",
    "correct_answer": "A",
    "explanation": "The Containment, Eradication, and Recovery phase of incident response includes active undertakings designed to minimize the damage caused by the incident and restore normal operations as quickly as possible.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      193,
      214,
      221,
      222,
      215
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 200,
    "question": "Which one of the following criteria is not normally used when evaluating the appropriateness of a cybersecurity incident containment strategy?",
    "choice_a": "Effectiveness of the strategy",
    "choice_b": "Evidence preservation requirements",
    "choice_c": "Log records generated by the strategy",
    "choice_d": "Cost of the strategy",
    "correct_answer": "C",
    "explanation": "NIST recommends using six criteria to evaluate a containment strategy: the potential damage to resources, the need for evidence preservation, service availability, time and resources required (including cost), effectiveness of the strategy, and duration of the solution.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      214,
      193,
      212,
      215,
      216
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 201,
    "question": "Alice is responding to a cybersecurity incident and notices a system that she suspects is compromised. She places this system on a quarantine VLAN with limited access to other networked systems. What containment strategy is Alice pursuing?",
    "choice_a": "Eradication",
    "choice_b": "Isolation",
    "choice_c": "Segmentation",
    "choice_d": "Removal",
    "correct_answer": "C",
    "explanation": "In a segmentation approach, the suspect system is placed on a separate network where it has very limited access to other networked resources.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      214,
      216,
      193,
      217
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 202,
    "question": "Alice confers with other team members and decides that even allowing limited access to other systems is an unacceptable risk and chooses instead to prevent the quarantine VLAN from accessing any other systems by putting firewall rules in place that limit access to other enterprise systems. The attacker can still control the system to allow Alice to continue monitoring the incident. What strategy is she now pursuing?",
    "choice_a": "Eradication",
    "choice_b": "Isolation",
    "choice_c": "Segmentation",
    "choice_d": "Removal",
    "correct_answer": "B",
    "explanation": "In the isolation strategy, the quarantine network is directly connected to the Internet or restricted severely by firewall rules so that the attacker may continue to control it but not gain access to any other networked resources.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      214,
      215,
      216,
      193,
      217
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 203,
    "question": "After observing the attacker, Alice decides to remove the Internet connection entirely, leaving the systems running but inaccessible from outside the quarantine VLAN. What strategy is she now pursuing?",
    "choice_a": "Eradication",
    "choice_b": "Isolation",
    "choice_c": "Segmentation",
    "choice_d": "Removal",
    "correct_answer": "D",
    "explanation": "In the removal approach, Alice keeps the systems running for forensic purposes but completely cuts off their access to or from other networks, including the Internet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      215,
      258,
      260,
      193
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 204,
    "question": "Which one of the following tools may be used to isolate an attacker so that they may not cause damage to production systems but may still be observed by cybersecurity analysts?",
    "choice_a": "Sandbox",
    "choice_b": "Playpen",
    "choice_c": "IDS",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "Sandboxes are isolation tools used to contain attackers within an environment where they believe they are conducting an attack but, in reality, are operating in a benign environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      216,
      214,
      193,
      192
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 205,
    "question": "Tamara is a cybersecurity analyst for a private business that is suffering a security breach. She believes the attackers have compromised a database containing sensitive information. Which one of the following activities should be Tamara\u2019s first priority?",
    "choice_a": "Identifying the source of the attack",
    "choice_b": "Eradication",
    "choice_c": "Containment",
    "choice_d": "Recovery",
    "correct_answer": "C",
    "explanation": "Tamara\u2019s first priority should be containing the attack. This will prevent it from spreading to other systems and also potentially stop the exfiltration of sensitive information. Only after containing the attack should Tamara move on to eradication and recovery activities. Identifying the source of the attack should be a low priority.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      193,
      215,
      216,
      221,
      222
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 206,
    "question": "What should be clearly identified during a lessons learned review in order to reduce the likelihood of a similar incident escaping attention in the future?",
    "choice_a": "IOCs",
    "choice_b": "Scope",
    "choice_c": "Impact",
    "choice_d": "Reimaging",
    "correct_answer": "A",
    "explanation": "During an incident investigation, the team may encounter new indicators of compromise (IOCs) based on the tools, techniques, and tactics used by attackers. As part of the lessons learned review, the team should clearly identify any new IOCs and make recommendations for updating the organization\u2019s security monitoring program to include those IOCs. This will reduce the likelihood of a similar incident escaping attention in the future. Scope, impact, and reimaging should be considered during containment, eradication, and recovery.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      267,
      208,
      194,
      225,
      266
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 207,
    "question": "Which one of the following pieces of information is most critical to conducting a solid incident recovery effort?",
    "choice_a": "Identity of the attacker",
    "choice_b": "Time of the attack",
    "choice_c": "Root cause of the attack",
    "choice_d": "Attacks on other organizations",
    "correct_answer": "C",
    "explanation": "Understanding the root cause of an attack is critical to the incident recovery effort. Analysts should examine all available information to help reconstruct the attacker\u2019s actions. This information is crucial to remediating security controls and preventing future similar attacks.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      219,
      266,
      222,
      194,
      258
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 208,
    "question": "Lynda is disposing of a drive containing sensitive information that was collected during the response to a cybersecurity incident. The information is categorized as a high security risk and she wishes to reuse the media during a future incident. What is the appropriate disposition for this information?",
    "choice_a": "Clear",
    "choice_b": "Erase",
    "choice_c": "Purge",
    "choice_d": "Destroy",
    "correct_answer": "C",
    "explanation": "Lynda should consult the flowchart that appears in Figure 11.7. Following that chart, the appropriate disposition for media that contains high security risk information and will be reused within the organization is to purge it.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      225,
      222,
      217,
      244,
      258
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 209,
    "question": "Which one of the following activities is not normally conducted during the recovery validation phase?",
    "choice_a": "Verify the permissions assigned to each account.",
    "choice_b": "Implement new firewall rules.",
    "choice_c": "Conduct vulnerability scans.",
    "choice_d": "Verify logging is functioning properly.",
    "correct_answer": "B",
    "explanation": "New firewall rules, if required, would be implemented during the eradication and recovery phase. The validation phase includes verifying accounts and permissions, verifying that logging is working properly, and conducting vulnerability scans.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      223,
      224,
      222,
      221,
      220
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 210,
    "question": "What incident response activity focuses on removing any artifacts of the incident that may remain on the organization\u2019s network?",
    "choice_a": "Containment",
    "choice_b": "Recovery",
    "choice_c": "Post-Incident Activities",
    "choice_d": "Eradication",
    "correct_answer": "D",
    "explanation": "The primary purpose of eradication is to remove any of the artifacts of the incident that may remain on the organization\u2019s network. This may include the removal of any malicious code from the network, the sanitization of compromised media, and the securing of compromised user accounts.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      221,
      193,
      222,
      192,
      215
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 211,
    "question": "Which one of the following is not a common use of formal incident reports?",
    "choice_a": "Training new team members",
    "choice_b": "Sharing with other organizations",
    "choice_c": "Developing new security controls",
    "choice_d": "Assisting with legal action",
    "correct_answer": "B",
    "explanation": "There are many potential uses for written incident reports. First, it creates an institutional memory of the incident that is useful when developing new security controls and training new security team members. Second, it may serve as an important record of the incident if there is ever legal action that results from the incident. These reports should be classified and not disclosed to external parties.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      225,
      267,
      217,
      212,
      246
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 212,
    "question": "Which one of the following data elements would not normally be included in an evidence log?",
    "choice_a": "Serial number",
    "choice_b": "Record of handling",
    "choice_c": "Storage location",
    "choice_d": "Malware signatures",
    "correct_answer": "D",
    "explanation": "Malware signatures would not normally be included in an evidence log. The log would typically contain identifying information (e.g., the location, serial number, model number, hostname, MAC addresses and IP addresses of a computer), the name, title and phone number of each individual who collected or handled the evidence during the investigation, the time and date (including time zone) of each occurrence of evidence handling, and the locations where the evidence was stored.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      246,
      217,
      265,
      248,
      250
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 213,
    "question": "Sondra determines that an attacker has gained access to a server containing critical business files and wishes to ensure that the attacker cannot delete those files. Which one of the following strategies would meet Sondra\u2019s goal?",
    "choice_a": "Isolation",
    "choice_b": "Segmentation",
    "choice_c": "Removal",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "Even removing a system from the network doesn\u2019t guarantee that the attack will not continue. In the example given in this chapter, an attacker can run a script on the server that detects when it has been removed from the network and then proceeds to destroy data stored on the server.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      216,
      220,
      221,
      214,
      193
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 214,
    "question": "Joe would like to determine the appropriate disposition of a flash drive used to gather highly sensitive evidence during an incident response effort. He does not need to reuse the drive but wants to return it to its owner, an outside contractor. What is the appropriate disposition?",
    "choice_a": "Destroy",
    "choice_b": "Clear",
    "choice_c": "Erase",
    "choice_d": "Purge",
    "correct_answer": "A",
    "explanation": "The data disposition flowchart in Figure 11.7 directs that any media containing highly sensitive information that will leave the control of the organization must be destroyed. Joe should purchase a new replacement device to provide to the contractor.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      202,
      217,
      225,
      246,
      244
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 215,
    "question": "Which one of the following is not typically found in a cybersecurity incident report?",
    "choice_a": "Chronology of events",
    "choice_b": "Identity of the attacker",
    "choice_c": "Estimates of impact",
    "choice_d": "Documentation of lessons learned",
    "correct_answer": "B",
    "explanation": "Incident reports should include a chronology of events, estimates of the impact, and documentation of lessons learned, in addition to other information. Incident response efforts should not normally focus on uncovering the identity of the attacker, so this information would not be found in an incident report.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      218,
      225,
      265,
      266,
      267
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 216,
    "question": "What NIST publication contains guidance on cybersecurity incident handling?",
    "choice_a": "SP 800-53",
    "choice_b": "SP 800-88",
    "choice_c": "SP 800-18",
    "choice_d": "SP 800-61",
    "correct_answer": "D",
    "explanation": "NIST SP 800-61 is the <i>Computer Security Incident Handling Guide</i>. NIST SP 800-53 is <i>Security and Privacy Controls for Federal Information Systems and Organizations</i>. NIST SP 800-88 is <i>Guidelines for Media Sanitization</i>. NIST SP 800-18 is the <i>Guide for Developing Security Plans for Federal Information Systems</i>.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      195,
      191,
      192,
      193,
      194
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 217,
    "question": "Which one of the following is not a purging activity?",
    "choice_a": "Resetting to factory state",
    "choice_b": "Overwriting",
    "choice_c": "Block erase",
    "choice_d": "Cryptographic erase",
    "correct_answer": "A",
    "explanation": "Resetting a device to factory state is an example of a data clearing activity. Data purging activities include overwriting, block erase, and cryptographic erase activities when performed through the use of dedicated, standardized device commands.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      221,
      220,
      212,
      264,
      223
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 218,
    "question": "Ben is responding to a security incident and determines that the attacker is using systems on Ben\u2019s network to attack a third party. Which one of the following containment approaches will prevent Ben\u2019s systems from being used in this manner?",
    "choice_a": "Removal",
    "choice_b": "Isolation",
    "choice_c": "Detection",
    "choice_d": "Segmentation",
    "correct_answer": "A",
    "explanation": "Only removal of the compromised system from the network will stop the attack against other systems. Isolated and/or segmented systems are still permitted access to the Internet and could continue their attack. Detection is a purely passive activity that does not disrupt the attacker at all.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      216,
      215,
      193,
      221,
      217
    ],
    "source": "182909_Ch11"
  },
  {
    "id": 219,
    "question": "Why should organizations predetermine communication guidelines according to NIST?",
    "choice_a": "To limit how many individuals know sensitive incident information",
    "choice_b": "To ensure compliance with federal law",
    "choice_c": "To ensure that appropriate communications are shared with the right parties",
    "choice_d": "To ensure consistency of communications",
    "correct_answer": "C",
    "explanation": "NIST guidelines note that predetermined communications ensure that appropriate communications are shared with the right parties.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      227,
      235,
      237,
      238,
      241
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 220,
    "question": "Valentine is preparing a vulnerability management report. What data point will provide the greatest help in determining if patching programs are not succeeding?",
    "choice_a": "A list of affected hosts",
    "choice_b": "Information about recurrence",
    "choice_c": "Prioritization information",
    "choice_d": "Risk scores",
    "correct_answer": "B",
    "explanation": "Information about recurrence will help Valentine determine if there is an ongoing issue with the patching program. For example, recurrence might demonstrate that the underlying base images for systems were not being patched, resulting in vulnerabilities when new instances of an image are being deployed.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      230,
      228,
      231,
      226,
      233
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 221,
    "question": "Jake wants to identify stakeholders for vulnerability management communications. Which stakeholder group is most likely to want information to be available via an API instead of a written communication?",
    "choice_a": "Security operations and oversight stakeholders",
    "choice_b": "Audit and compliance stakeholders",
    "choice_c": "System administration stakeholders",
    "choice_d": "Management stakeholders",
    "correct_answer": "A",
    "explanation": "Security operations and oversight stakeholders will likely want to ingest vulnerability management data to perform data enrichment activities for other security systems. Audit and compliance, system administration, and management stakeholders are more likely to want written reports to review and use in their roles.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      227,
      230,
      226,
      232,
      233
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 222,
    "question": "What phase of the NIST IR cycle does communication to stakeholders occur in?",
    "choice_a": "Detection and Analysis",
    "choice_b": "Containment, Eradication, and Recovery",
    "choice_c": "Post-Incident Activity",
    "choice_d": "All cycles include communication with stakeholders.",
    "correct_answer": "D",
    "explanation": "Communication with stakeholders should occur during all phases of the NIST IR cycle to ensure that they are aware and participating as required.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      235,
      241,
      240,
      236,
      237
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 223,
    "question": "Which of the following potential incident response metrics is least useful in understanding the organization\u2019s ability to respond to incidents?",
    "choice_a": "Mean time to detect",
    "choice_b": "Alert volume",
    "choice_c": "Mean time to respond",
    "choice_d": "Mean time to remediate",
    "correct_answer": "B",
    "explanation": "Simply knowing the volume of alerts for an organization is not a useful metric without context. It may indicate that the organization has a poorly tuned alerting system, that the system does not detect most events, or that there are other issues. Mean time to detect, mean time to respond, and mean time to remediate provide more useful information, although each requires context as well.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      240,
      235,
      236,
      239,
      241
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 224,
    "question": "Why might a service level agreement cause an organization to delay patching?",
    "choice_a": "To force vendor compliance",
    "choice_b": "To remain compliance with licensing",
    "choice_c": "To achieve organizational governance targets",
    "choice_d": "To meet performance targets defined by the SLA",
    "correct_answer": "D",
    "explanation": "Service level agreements (SLAs) often have performance targets like uptime included. Organizations that need to meet an SLA may delay patching to ensure they meet their overall uptime guarantees. SLAs and patching are not typically used to force vendor compliance or to ensure license compliance, nor are they likely to impact organizational governance targets.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      231,
      228,
      230,
      227,
      234
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 225,
    "question": "Ian wants to ensure that patches are installed as part of a baseline for his organization. What type of tool should he invest in as part of his overall action plan for remediation?",
    "choice_a": "A vulnerability scanner",
    "choice_b": "A configuration management tool or system",
    "choice_c": "A baseline configuration scanner",
    "choice_d": "An endpoint detection and response (EDR) tool",
    "correct_answer": "B",
    "explanation": "Ian\u2019s desire to ensure patches across his infrastructure points to a need for a configuration management tool that can be used to deploy patches at scale. A vulnerability scanner doesn\u2019t install patches, baseline configuration scanners help determine whether the baseline is being met but won\u2019t help maintain the baseline, and EDR is used to detect malicious software and activity, not to patch or maintain a patch level.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      233,
      228,
      231,
      230,
      229
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 226,
    "question": "Sally is preparing an incident response report. What part of the report is intended to help organizations understand the outcome of the incident and financial, reputational, or other damages?",
    "choice_a": "The impact assessment",
    "choice_b": "The timeline",
    "choice_c": "The scope",
    "choice_d": "The recommendations",
    "correct_answer": "A",
    "explanation": "Impact assessments focus on describing what the incident means to the organization including financial, reputational, or other impacts. Timeline, scope, and recommendations all help describe the incident but don\u2019t focus on impact.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      235,
      239,
      240,
      241,
      237
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 227,
    "question": "Jaime is concerned that her organization may face multiple inhibitors to remediation. Which of the following inhibitors to remediation is most often associated with performance or uptime targets?",
    "choice_a": "Organizational governance",
    "choice_b": "Legacy systems",
    "choice_c": "Memorandums of understanding",
    "choice_d": "Proprietary systems",
    "correct_answer": "C",
    "explanation": "Memorandums of understanding (MOUs) are often associated with performance or uptime targets that may not be met if systems are taken offline for patching. Jaime should review her infrastructure designs, MOUs, and patching processes to determine if they are all appropriate to what her organization can accomplish and needs to do to stay secure.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      231,
      228,
      227,
      234,
      233
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 228,
    "question": "Selah wants to include sections of relevant logs in her incident report. What report section most frequently includes logs?",
    "choice_a": "In the timeline",
    "choice_b": "As part of the executive summary",
    "choice_c": "As evidence in the appendix",
    "choice_d": "As part of the recommendations",
    "correct_answer": "C",
    "explanation": "Detailed evidence like logs are typically attached as evidence in an appendix.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      239,
      235,
      241,
      240,
      236
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 229,
    "question": "Danielle has completed her incident report and wants to ensure that her organization benefits from the process. What exercise is most frequently conducted after the report to improve future IR processes?",
    "choice_a": "Media training",
    "choice_b": "Government compliance reporting",
    "choice_c": "A lessons learned exercise",
    "choice_d": "A mandatory report to auditors",
    "correct_answer": "C",
    "explanation": "A lessons learned exercise is used to ensure that organizations leverage their findings and experiences from incidents. Media training is useful, and a need for it might be a lesson learned, but it is not a typical follow-up. Reporting to the government or auditors is also not a typical process improvement step after an incident.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      241,
      239,
      240,
      235,
      236
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 230,
    "question": "What phase of the IR cycle does media training typically occur in?",
    "choice_a": "Preparation",
    "choice_b": "Detection and Analysis",
    "choice_c": "Containment, Eradication, and Recovery",
    "choice_d": "Post-Incident Activity",
    "correct_answer": "A",
    "explanation": "Training is most commonly associated with the Preparation phase of the IR life cycle. Conducting media training during an incident is not a common practice.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      238,
      235,
      233,
      241,
      236
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 231,
    "question": "Michelle is performing root cause analysis. Which of the following is not one of the four common steps in an RCA exercise?",
    "choice_a": "Documenting the root cause analysis using a chart or diagram",
    "choice_b": "Establishing a timeline of events",
    "choice_c": "Determining which individual or team was responsible for the problem",
    "choice_d": "Identifying the problems and events that occurred during the event and describing them as completely as possible",
    "correct_answer": "C",
    "explanation": "Root cause analysis exercises are not designed or intended to determine who to blame. Instead, they focus on identifying the root cause so that it can be remediated.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      239,
      241,
      235,
      236,
      237
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 232,
    "question": "The organization that Charles works for has experienced a significant incident. Which of the following is most likely to require the organization to report the incident in a specific timeframe?",
    "choice_a": "Organizational policy",
    "choice_b": "Internal governance",
    "choice_c": "Regulatory compliance",
    "choice_d": "Media requirements",
    "correct_answer": "C",
    "explanation": "Internal requirements are unlikely to require an incident report in a specific timeline, as they typically acknowledge the complexity of incident response. While the media may want a report in a specific timeframe, that does not require a response. Instead, of the listed items, regulatory compliance is the primary driver for reporting in a specific timeline for most organizations.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      237,
      232,
      235,
      236,
      238
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 233,
    "question": "After testing, Jim\u2019s team has determined that installing a patch will result in degraded functionality due to a service being modified. What should Jim suggest to address this inhibitor to remediation?",
    "choice_a": "Take the change through organizational governance.",
    "choice_b": "Identify a compensating control.",
    "choice_c": "Replace the legacy system.",
    "choice_d": "Update the service level agreement.",
    "correct_answer": "B",
    "explanation": "The best option that Jim has will likely be to identify a compensating control. This may not be a suitable solution in the long term, and Jim\u2019s organization may need to change their service or design to allow for the security fix to be put in place. Organizational governance won\u2019t change the functional impact, no legacy system is mentioned, nor is there an SLA listed in the question.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      229,
      231,
      228,
      227,
      234
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 234,
    "question": "Which of the following is not a NIST-recommended practice to help with media communication procedures?",
    "choice_a": "Avoiding media contact throughout IR processes",
    "choice_b": "Establishing procedures for briefing the media",
    "choice_c": "Maintaining an IR status document or statement",
    "choice_d": "Media training",
    "correct_answer": "A",
    "explanation": "NIST acknowledges the necessity of dealing with the media and recommends media training, establishing procedures for briefing the media, maintaining an IR status document or statement, preparing staff for media contact and requests for information, and holding ongoing practice sessions for incident responders as part of IR exercises.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      238,
      235,
      237,
      236,
      241
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 235,
    "question": "An incident report is typically prepared in what phase of the NIST incident response cycle?",
    "choice_a": "Detection and Analysis",
    "choice_b": "Post-Incident Activity",
    "choice_c": "Preparation",
    "choice_d": "Containment, Eradication, and Recovery",
    "correct_answer": "B",
    "explanation": "Post-Incident Activity typically includes the incident report in the NIST IR life cycle.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      241,
      239,
      240,
      235,
      236
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 236,
    "question": "The security team that Chris works on has been notified of a zero-day vulnerability in Windows Server that was released earlier in the morning. Chris\u2019s manager asks Chris to immediately check recent vulnerability reports to determine if the organization is impacted. What should Chris tell his manager?",
    "choice_a": "That the reports will need to be rerun to list the zero-day vulnerability.",
    "choice_b": "He needs to update the vulnerability scanner to detect the zero-day vulnerability.",
    "choice_c": "Zero-day vulnerabilities won\u2019t show in previously run vulnerability management reports.",
    "choice_d": "That zero-day vulnerabilities cannot be detected.",
    "correct_answer": "C",
    "explanation": "Chris knows that a zero-day vulnerability means that the scanner won\u2019t have had a rule or detection profile for the vulnerability. That means that previously run reports and scans won\u2019t show it. It\u2019s possible that their vendor may release a detection profile or rule for the zero-day, but with very little time from release to the request, that is unlikely to have occurred already. Rerunning reports won\u2019t show unknown vulnerabilities, and zero-day vulnerabilities can be detected if there\u2019s a rule.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      226,
      230,
      229,
      231,
      233
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 237,
    "question": "Mikayla\u2019s organization has identified an ongoing problem based on their vulnerability management dashboard reports. Trends indicate that patching is not occurring in a timely manner, and that patches are not being installed for some of the most critical vulnerabilities. What should Mikayla do if she believes that system administrators are not prioritizing patching?",
    "choice_a": "Engage in awareness, education, and training activities.",
    "choice_b": "Assess changing business requirements.",
    "choice_c": "Deploy compensating controls.",
    "choice_d": "Engage management to punish administrators who are not patching.",
    "correct_answer": "A",
    "explanation": "Mikayla knows that awareness and education are the first step to ensuring that staff are aware of the importance of patching. Her first step should be ensuring appropriate awareness, education, and training are in place. There is no indication of changing business requirements, compensating controls should only be used if they are needed, not as a general practice, and punishment is unlikely to resolve the underlying issues.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      233,
      231,
      227,
      230,
      228
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 238,
    "question": "Geeta\u2019s organization operates a critical system provided by a vendor that specifies that the operating system cannot be patched. What type of solution should Geeta recommend when her vulnerability reporting shows the system is behind on patching and has critical vulnerabilities?",
    "choice_a": "Mark the vulnerabilities as unable to be remediated and continue operations to ensure business continuity.",
    "choice_b": "Shut off the system until a solution can be identified.",
    "choice_c": "Install the operating system patch and test if it causes issues.",
    "choice_d": "Identify and deploy a compensating control.",
    "correct_answer": "D",
    "explanation": "Geeta should identify a compensating control that will appropriately ensure the security of the system with minimal impact to its functionality. Examples might be placing a network firewall logically in front of the device, moving it to an isolated and secured network segment or VLAN, or otherwise adding protection. Marking the vulnerability as unable to be remediated does not protect the system or the company, shutting it off will impact the organization\u2019s ability to function, and installing the patches may cause functional issues or prevent vendor support.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      229,
      231,
      228,
      226,
      233
    ],
    "source": "182909_Ch12"
  },
  {
    "id": 239,
    "question": "Which format does dd produce files in while disk imaging?",
    "choice_a": "ddf",
    "choice_b": "RAW",
    "choice_c": "EN01",
    "choice_d": "OVF",
    "correct_answer": "B",
    "explanation": "dd creates files in RAW, bit-by-bit format. EN01 is the EnCase forensic file format, OVF is virtualization file format, and ddf is a made-up answer.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      259,
      248,
      243,
      252,
      246
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 240,
    "question": "Gurvinder has completed his root cause analysis and wants to use it to avoid future problems. What should he document next?",
    "choice_a": "Lessons learned",
    "choice_b": "The system architecture diagram",
    "choice_c": "An updated forensic process",
    "choice_d": "Current legal holds",
    "correct_answer": "A",
    "explanation": "Once a root cause analysis is done, lessons learned are often documented to ensure that future similar issues are avoided. Architecture diagrams and updated processes may be part of those lessons learned. A list of current legal holds is not typically part of this process.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      267,
      225,
      194,
      266,
      258
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 241,
    "question": "Mike is conducting a root cause analysis. Which of the following is <i>not</i> a typical phase in the root cause analysis process?",
    "choice_a": "Identifying contributing factors",
    "choice_b": "Identifying solutions to the root cause",
    "choice_c": "Performing a risk analysis",
    "choice_d": "Implementing controls or fixes to address the root cause",
    "correct_answer": "C",
    "explanation": "Whereas root cause analysis may involve cost\u2013benefit analysis before controls or fixes are put in place, risk assessment is typically a separate process.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      266,
      194,
      225,
      222,
      218
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 242,
    "question": "Alice wants to copy a drive without any chance of it being modified by the copying process. What type of device should she use to ensure that this does not happen during her data acquisition process?",
    "choice_a": "A read blocker",
    "choice_b": "A drive cloner",
    "choice_c": "A write blocker",
    "choice_d": "A hash validator",
    "correct_answer": "C",
    "explanation": "Write blockers ensure that no changes are made to a source drive when creating a forensic copy. Preventing reads would stop you from copying the drive, drive cloners may or may not have write blocking capabilities built in, and hash validation is useful to ensure contents match but don\u2019t stop changes to the source drive from occurring.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      244,
      248,
      251,
      212,
      259
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 243,
    "question": "Frederick\u2019s organization has been informed that data must be preserved due to pending legal action. What is this type of requirement called?",
    "choice_a": "A retainer",
    "choice_b": "A legal hold",
    "choice_c": "A data freeze",
    "choice_d": "An extra-legal hold",
    "correct_answer": "B",
    "explanation": "A legal hold is a process used to preserve all data related to pending legal action or when legal action may be expected. A retainer is paid to a lawyer to keep them available for work. The other two terms were made up for this question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      261,
      212,
      217,
      258
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 244,
    "question": "What process is often performed as part of incident response forensic analysis?",
    "choice_a": "Blame assignment",
    "choice_b": "Root cause analysis",
    "choice_c": "Reverse hashing",
    "choice_d": "Legal holds",
    "correct_answer": "B",
    "explanation": "A root cause analysis is often performed to identify what went wrong and why. Lessons learned are then identified and applied to ensure the organization doesn\u2019t experience the same issue in the future. Blame assignment is not a part of a forensic procedure and is typically discouraged in most organizations. Reverse hashing isn\u2019t possible, as hashes are one-way functions. Legal holds are associated with legal action, not incident response forensics.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      266,
      194,
      267,
      258,
      219
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 245,
    "question": "Jeff is investigating a system compromise and knows that the first event was reported on October 5. What forensic tool capability should he use to map other events found in logs and files to this date?",
    "choice_a": "A timeline",
    "choice_b": "A log viewer",
    "choice_c": "Registry analysis",
    "choice_d": "Timestamp validator",
    "correct_answer": "A",
    "explanation": "Timelines are one of the most useful tools when conducting an investigation of a compromise or other event. Forensic tools provide built-in timeline capabilities to allow this type of analysis.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      250,
      258,
      243,
      246,
      192
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 246,
    "question": "During her forensic copy validation process, Danielle hashed the original, cloned the image files, and received the following MD5 sums. What is likely wrong?<br>b49794e007e909c00a51ae208cacb169  original.img <br>d9ff8a0cf6bc0ab066b6416e7e7abf35  clone.img",
    "choice_a": "The original was modified.",
    "choice_b": "The clone was modified.",
    "choice_c": "dd failed.",
    "choice_d": "An unknown change or problem occurred.",
    "correct_answer": "D",
    "explanation": "Since Danielle did not hash her source drive prior to cloning, you cannot determine where the problem occurred. If she had run MD5sum prior to the cloning process as well as after, she could verify that the original disk had not changed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      248,
      212,
      259,
      246
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 247,
    "question": "Jennifer wants to perform memory analysis and forensics for Windows, macOS, and Linux systems. Which of the following is best suited to her needs?",
    "choice_a": "LiME",
    "choice_b": "DumpIt",
    "choice_c": "fmem",
    "choice_d": "The Volatility Framework",
    "correct_answer": "D",
    "explanation": "The Volatility Framework is designed to work with Windows, macOS, and Linux, and it provides in-depth memory forensics and analysis capabilities. LiME and fmem are Linux tools, whereas DumpIt is a Windows-only tool.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      262,
      253,
      260,
      252,
      250
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 248,
    "question": "As part of her review of a forensic process, Lisa is reviewing a log that lists each time a person handled a forensic image. She notices that an entry lists forensic analysis actions but does not have a name logged. What concept does this violate?",
    "choice_a": "Image integrity",
    "choice_b": "Forensic authenticity",
    "choice_c": "Preservation",
    "choice_d": "Chain of custody",
    "correct_answer": "D",
    "explanation": "Lisa has discovered an issue with chain of custody documentation. Each transfer, forensic action, or other change or event that occurs should be logged as part of a chain of custody.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      246,
      261,
      217,
      212,
      265
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 249,
    "question": "Why is validating data integrity critical to forensic processes?",
    "choice_a": "It ensures the system has not been compromised.",
    "choice_b": "It ensures the system has not been altered by the forensic examiner.",
    "choice_c": "It ensures the operating system version matches the expected version.",
    "choice_d": "It is required by the legal hold process.",
    "correct_answer": "B",
    "explanation": "Validating data integrity ensures that images or files are forensically sound and have not been altered or modified either on purpose or accidentally during the forensic acquisition and analysis process. It does not ensure the system has not been compromised, and although artifacts can be assessed to validate file versions, typically they are not used to validate operating system versions. Finally, legal holds require data preservation, not data integrity validation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      212,
      244,
      259,
      246
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 250,
    "question": "Carl does not have the ability to capture data from a cell phone using mobile forensic or imaging software, and the phone does not have removable storage. Fortunately, the phone was not set up with a PIN or screen lock. What is his best option to ensure he can see email and other data stored there?",
    "choice_a": "Physical acquisition",
    "choice_b": "Logical access",
    "choice_c": "Filesystem access",
    "choice_d": "Manual access",
    "correct_answer": "D",
    "explanation": "Manual access is used when phones cannot be forensically imaged or accessed as a volume or filesystem. Manual access requires that the phone be reviewed by hand, with pictures and notes preserved to document the contents of the phone.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      248,
      258,
      217,
      247,
      249
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 251,
    "question": "What forensic issue might the presence of a program like CCleaner indicate?",
    "choice_a": "Antiforensic activities",
    "choice_b": "Full disk encryption",
    "choice_c": "Malware packing",
    "choice_d": "MAC time modifications",
    "correct_answer": "A",
    "explanation": "CCleaner is a PC cleanup utility that wipes Internet history, destroys cookies and other cached data, and can impede forensic investigations. CCleaner may be an indication of intentional antiforensic activities on a system. It is not a full-disk encryption tool or malware packer, nor will it modify MAC times.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      264,
      212,
      221,
      246,
      248
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 252,
    "question": "Which of the following is <i>not</i> a potential issue with live imaging of a system?",
    "choice_a": "Remnant data from the imaging tool will remain.",
    "choice_b": "Unallocated space will be captured.",
    "choice_c": "Memory or drive contents may change during the imaging process.",
    "choice_d": "Malware may detect the imaging tool and work to avoid it.",
    "correct_answer": "B",
    "explanation": "Unallocated space is typically not captured during a live image, potentially resulting in data being missed. Remnant data from the tool, memory and drive contents changing while the image is occurring, and malware detecting the tool are all possible issues.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      260,
      262,
      259,
      248,
      253
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 253,
    "question": "During his investigation, Jeff, a certified forensic examiner, is provided with a drive image created by an IT staff member and is asked to add it to his forensic case. What is the most important issue that Jeff could encounter if the case goes to court and his procedures are questioned?",
    "choice_a": "Bad checksums",
    "choice_b": "Hash mismatch",
    "choice_c": "Antiforensic activities",
    "choice_d": "Inability to certify chain of custody",
    "correct_answer": "D",
    "explanation": "Jeff did not create the image and cannot validate chain of custody for the drive. This also means he cannot prove that the drive is a copy of the original. Since we do not know the checksum for the original drive, we do not have a bad checksum or a hash mismatch\u2014there isn\u2019t an original to compare it to. Antiforensic activities may have occurred, but we cannot determine that from the question.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      246,
      261,
      251,
      258,
      217
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 254,
    "question": "Jeff is investigating a system that is running malware that he believes encrypts its data on the drive. What process should he use to have the best chance of viewing that data in an unencrypted form?",
    "choice_a": "Live imaging",
    "choice_b": "Offline imaging",
    "choice_c": "Brute-force encryption cracking",
    "choice_d": "Causing a system crash and analyzing the memory dump",
    "correct_answer": "A",
    "explanation": "Imaging the system while the program is live has the best probability of allowing Jeff to capture the encryption keys or decrypted data from memory. An offline image after the system is shut down will likely result in having to deal with the encrypted file. Brute-force attacks are typically slow and may not succeed, and causing a system crash may result in corrupted or nonexistent data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      262,
      253,
      259,
      248
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 255,
    "question": "Susan needs to capture network traffic from a Linux server that does not use a GUI. What packet capture utility is found on many Linux systems and works from the command line?",
    "choice_a": "tcpdump",
    "choice_b": "netdd",
    "choice_c": "Wireshark",
    "choice_d": "Snifman",
    "correct_answer": "A",
    "explanation": "The tcpdump utility is a command-line packet capture tool that is found on many Linux systems. Wireshark is a GUI tool available for most operating systems. Netdd and snifman were made up for this question.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      255,
      252,
      250,
      258,
      192
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 256,
    "question": "During a forensic investigation, Ben asks Chris to sit with him and to sign off on the actions he has taken. What is he doing?",
    "choice_a": "Maintaining chain of custody",
    "choice_b": "Over-the-shoulder validation",
    "choice_c": "Pair forensics",
    "choice_d": "Separation of duties",
    "correct_answer": "A",
    "explanation": "Ben is maintaining chain of custody documentation. Chris is acting as the validator for the actions that Ben takes and acts as a witness to the process.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      246,
      261,
      265,
      212,
      258
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 257,
    "question": "Which tool is <i>not</i> commonly used to generate the hash of a forensic copy?",
    "choice_a": "MD5",
    "choice_b": "FTK",
    "choice_c": "SHA1",
    "choice_d": "AES",
    "correct_answer": "D",
    "explanation": "While AES does have a hashing mode, MD5, SHA1, and built-in hashing tools in FTK and other commercial tools are more commonly used for forensic hashes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      243,
      252,
      212,
      248
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 258,
    "question": "Which of the following issues makes both cloud and virtualized environments more difficult to perform forensics on?",
    "choice_a": "Other organizations manage them.",
    "choice_b": "Systems may be ephemeral.",
    "choice_c": "No forensic tools work in both environments.",
    "choice_d": "Drive images cannot be verified.",
    "correct_answer": "B",
    "explanation": "Both cloud and virtualized environments are often temporary (ephemeral) and thus can be difficult to perform forensics on. If you have a cloud, virtualized, or containerized environment, make sure you have considered how you would perform forensics, and what data preservation techniques you may need to use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      256,
      260,
      262,
      212,
      248
    ],
    "source": "182909_Ch13"
  },
  {
    "id": 259,
    "question": "Tom is preparing to build a credit card\u2013processing system. As he creates his design, he realizes that the operating environment will not allow him to include one of the PCI DSS required elements. What type of control should Tom discuss implementing?",
    "choice_a": "Technical control",
    "choice_b": "Operational control",
    "choice_c": "Managerial control",
    "choice_d": "Compensating control",
    "correct_answer": "D",
    "explanation": "Compensating controls are used to fulfill the same control objective as a required control when it is not feasible to implement that required control. The scenario describes a need for a compensating control. This control may be technical, operational, and/or managerial in nature.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      162,
      186,
      129,
      141,
      183
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 260,
    "question": "Shane administers a Linux server running an Apache web server. During the middle of his workday, tweets start to appear in his Twitter feed about compromises of Apache web servers due to a flaw that had not been previously reported. What type of threat is this?",
    "choice_a": "A local exploit",
    "choice_b": "Advanced persistent threat",
    "choice_c": "A zero-day exploit",
    "choice_d": "A zero-knowledge threat",
    "correct_answer": "C",
    "explanation": "Zero-day exploits take advantage of a security vulnerability that is not known until the exploit has been used\u2014there is no time (zero days) between the discovery and the attack.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      4,
      6,
      8,
      84,
      88
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 261,
    "question": "Juan is analyzing systems on his network for known indicators of compromise. What term best describes the work he is performing?",
    "choice_a": "Threat hunting",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Intrusion prevention",
    "choice_d": "Data mining",
    "correct_answer": "A",
    "explanation": "Threat hunting activities presume that a compromise has already taken place and search for indicators of that compromise. Vulnerability scanning activities probe systems for known vulnerabilities. Juan\u2019s activity could be described as intrusion detection, but not as intrusion prevention because he is not taking any action to block future attacks. Data mining is a generic term used in machine learning activities and Juan is not leveraging data mining in this work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      79,
      82,
      70,
      93
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 262,
    "question": "Which one of the following controls may be used to attract the attention of intruders who gain access to a network segment so that they are distracted from high-value targets and may be monitored?",
    "choice_a": "MAC",
    "choice_b": "Honeypot",
    "choice_c": "Intrusion prevention system",
    "choice_d": "Rogue AP",
    "correct_answer": "B",
    "explanation": "Honeypots are decoy systems used to attract the attention of intruders so that they may be monitored in a controlled environment. Mandatory access controls (MACs) are used to enforce system security policies. Intrusion prevention systems are designed to detect and block malicious activity. Rogue access points provide an unauthorized means of wireless access.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      97,
      36,
      11,
      13,
      70
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 263,
    "question": "While engaging in an attack, the attacker sends an email message to the targeted victim that contains malicious software as an attachment. What phase of the Cyber Kill Chain is occurring?",
    "choice_a": "Weaponization",
    "choice_b": "Delivery",
    "choice_c": "Action on Objectives",
    "choice_d": "Reconnaissance",
    "correct_answer": "B",
    "explanation": "This is an example of delivering the payload to the victim, so it is from the Delivery stage of the Cyber Kill Chain.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      199,
      208,
      191,
      195
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 264,
    "question": "Theresa wants to collect threat intelligence information from publicly available sources, and wants to find information that is released as soon as possible, placing her emphasis on information\u2019s timeliness. She is willing to have information be less accurate if it is more timely. What collection source listed below would best fit this requirement?",
    "choice_a": "Social media",
    "choice_b": "Government bulletins",
    "choice_c": "CERT updates",
    "choice_d": "Blogs",
    "correct_answer": "A",
    "explanation": "Theresa knows that social media is often the first place that new information is found but that validating information found on social media for relevancy and accuracy can be more difficult. Government bulletins and CERT updates will typically have received more validation and vetting. Blogs are usually slower than social media, and they must be validated and vetted as well.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      84,
      86,
      87,
      89,
      95
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 265,
    "question": "Karen is using Wireshark to analyze network traffic being sent to and from a web server that allows both encrypted and unencrypted web connections. The server also allows SSH access for users to securely drop off files. Which one of the following ports should <i>not</i> be seen in the Wireshark packet capture?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1433",
    "correct_answer": "D",
    "explanation": "Port 1433 is used for Microsoft SQL Server and should not be exposed on a web server. Ports 22, 80, and 443 are required for SSH, HTTP, and HTTPS connectivity, respectively.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      73,
      56,
      55,
      10
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 266,
    "question": "Joanna has infrastructure that exists in both her organization\u2019s datacenter and in an infrastructure-as-a-service (IaaS) hosted environment. Which of the following terms best describes this model?",
    "choice_a": "SASE",
    "choice_b": "On-premises",
    "choice_c": "Hybrid",
    "choice_d": "SDN",
    "correct_answer": "C",
    "explanation": "Architectures that are both on-premises and in the cloud are hybrid environments. SASE is secure access, secure edge, a design model that uses software-defined wide area networks (SDWAN) and security tools to provide end-to-end security for a more secure environment. SDN is software-defined networking.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      41,
      38,
      39,
      36,
      47
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 267,
    "question": "Kevin is configuring a web-based SIEM application and would like it to trigger a vulnerability scan of a web server each time a certain event occurs in the SIEM. What technology would he configure on the SIEM to allow this action?",
    "choice_a": "API",
    "choice_b": "Webhook",
    "choice_c": "IPS",
    "choice_d": "CASB",
    "correct_answer": "B",
    "explanation": "Webhooks allow one application to send a signal to another using a web request when a specific event occurs. The SIEM would be set up with a webhook based upon the event characteristics. That webhook would call the API on the vulnerability scanner (not the SIEM). This scenario does not call for the use of an intrusion prevention system (IPS) or a cloud access security broker (CASB).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      177,
      173,
      104,
      115
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 268,
    "question": "Sameer\u2019s organization includes an e-commerce arm. What type of vulnerability management reporting is he most likely to have to conduct due to accepting credit cards?",
    "choice_a": "SLA reports",
    "choice_b": "MOU reports",
    "choice_c": "Compliance reports",
    "choice_d": "Trend reports",
    "correct_answer": "C",
    "explanation": "Organizations that deal with credit card information typically have to comply with the PCI standard, meaning that Sameer is likely to need to provide compliance reports a part of the organization\u2019s overall compliance requirements. Service level agreements (SLAs) and memorandums of understanding (MOUs) are typically provided as part of agreements with customers or vendors, and trend reports are used for internal metrics and performance measurement.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      232,
      227,
      231,
      226,
      230
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 269,
    "question": "Saanvi is starting his incident response process and has been asked to immediately remediate the compromised web servers that were impacted to allow them to return to production. Why might he need to replace the drives in the systems and keep hashed copies of them?",
    "choice_a": "To prevent data loss",
    "choice_b": "Evidence retention",
    "choice_c": "To ensure proper data remanence prevention",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Retaining evidence may be required in the event of a criminal investigation or civil suit, and Saanvi may need to retain the original drives. He might opt to create copies of the drives for forensic purposes and will need to ensure that proper chain of custody and documentation is done, which may require engaging law enforcement before he takes any action.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      212,
      261,
      248,
      220
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 270,
    "question": "Jacob discovers that systems in his datacenter have begun to connect to each other via SSH at regular intervals. Which of the following indicators of potentially malicious activity best matches this type of behavior?",
    "choice_a": "Beaconing",
    "choice_b": "Irregular peer-to-peer communication",
    "choice_c": "Scans",
    "choice_d": "Unusual traffic spikes",
    "correct_answer": "B",
    "explanation": "Systems in the same network segment or trust zone connecting to each other in abnormal ways is an example of irregular peer-to-peer communication. Servers are likely to connect to each other in known and expected ways, using services like database or HTTPS connections if they\u2019re part of an established service architecture. Beaconing traffic typically leaves datacenters destined for command-and-control hosts. A single protocol like SSH at regular intervals is atypical for a scan or sweep, and the traffic is not described as a spike or high usage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      56,
      70,
      79,
      11
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 271,
    "question": "Jerome has listed the systems and services that were included in an incident. What common incident response report component best describes this?",
    "choice_a": "Impact",
    "choice_b": "Recommendations",
    "choice_c": "Timeline",
    "choice_d": "Scope",
    "correct_answer": "D",
    "explanation": "The scope of an incident includes all of the systems, services, personnel, or other parts of an organization that were impacted. The impact describes what damage or other results the incident caused. Recommendations list how to recover or what to do after and due to an incident. Timelines describe what happened during the course of an incident and when it occurred.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      235,
      239,
      241,
      240,
      236
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 272,
    "question": "Jocelyn is concerned that her organization\u2019s reliance on systems that run a custom operating system and software package will mean that her staff will be unable to remediate vulnerabilities found on the devices that rely on it. What inhibitor to remediation should she identify based on this concern?",
    "choice_a": "The use of legacy systems",
    "choice_b": "Issues with organization governance",
    "choice_c": "Issues with degraded functionality",
    "choice_d": "The use of proprietary systems",
    "correct_answer": "D",
    "explanation": "Jocelyn should note that the proprietary software and operating systems may mean that her team will be unable to remediate vulnerabilities unless the vendor provides appropriate patches. Legacy systems are outdated and no longer supported, but this concern is not described. Governance and functionality concerns are also not listed in the question.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      141,
      186,
      128,
      126,
      130
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 273,
    "question": "Kayla wants to check configuration information about a Windows system. Where does Windows store configuration information about the operating system like security settings?",
    "choice_a": "The user directory",
    "choice_b": "The system directory",
    "choice_c": "The Registry",
    "choice_d": "The Windows NT directory",
    "correct_answer": "C",
    "explanation": "Windows stores information about things like security settings in the Windows Registry.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      30,
      31,
      29,
      12,
      96
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 274,
    "question": "Laura is investigating a potential security breach within her organization. She believes that an attacker stole a file containing employee information. Which information security tenet would this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Nonrepudiation",
    "correct_answer": "A",
    "explanation": "The three pillars of information security are confidentiality, integrity, and availability (CIA). Attacks against confidentiality seek to disclose sensitive information. Attacks against integrity seek to alter information in an unauthorized manner. Attacks against availability seek to prevent legitimate use of information or systems. Nonrepudiation is the assurance that something cannot be denied by someone.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      1,
      59,
      53,
      76,
      4
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 275,
    "question": "Jacinda wants to use data from her firewalls, EDR, and other security tools to help detect a potential incident. What type of information should she feed to her central security log and even management tools to help identify new attacks with known patterns?",
    "choice_a": "LFIs and RFIs",
    "choice_b": "OWASP feeds",
    "choice_c": "Kill chain models",
    "choice_d": "IoCs",
    "correct_answer": "D",
    "explanation": "Indicator of compromise (IoC) feeds can be used to allow security monitoring systems to correlate log and other security information and to check it against known attack patterns and techniques. Jacinda can use this to identify newly identified attacks. LFIs and RFIs are local and remote file inclusions in the context of the CySA exam. OWASP does not provide threat data feeds, and the Cyber Kill Chain is an attack model.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      95,
      84,
      88,
      79,
      82
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 276,
    "question": "Henry wants to identify potentially unauthorized scheduled tasks on a Linux system. What Linux command is most useful to identify scheduled tasks?",
    "choice_a": "<code>cron</code>",
    "choice_b": "<code>ls</code>",
    "choice_c": "<code>ps</code>",
    "choice_d": "<code>chmod</code>",
    "correct_answer": "A",
    "explanation": "The <code>cron</code> command is used to set, view, and maintain scheduled tasks in Linux. The <code>ls</code> command is used to display directory and file listings, <code>ps</code> shows running tasks, and <code>chmod</code> is used to set or view permissions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      63,
      31,
      64,
      72,
      62
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 277,
    "question": "Alaina wants to describe adversary tactics and techniques using a standardized taxonomy. Which framework can she use to do this?",
    "choice_a": "The ANCHOR chain framework",
    "choice_b": "The Biba Model",
    "choice_c": "The Star Model",
    "choice_d": "MITRE ATT&CK",
    "correct_answer": "D",
    "explanation": "MITRE\u2019s ATT&CK framework provides a way to describe adversary tactics and techniques using a common taxonomy. The remainder of these models may sound familiar, but they were made up for this question.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      206,
      205,
      208,
      192,
      266
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 278,
    "question": "Which of the following is <i>not</i> typically involved in the initial phases of a CSIRT activation?",
    "choice_a": "Technical staff",
    "choice_b": "CSIRT leader",
    "choice_c": "Law enforcement",
    "choice_d": "First responder",
    "correct_answer": "C",
    "explanation": "For most organizations, CSIRT activities initially involve internal resources. Law enforcement is involved only when it is believed that a crime has been committed, requiring participation of law enforcement officers.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      218,
      197,
      198,
      191,
      195
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 279,
    "question": "Which one of the following activities would <i>not</i> normally occur during the attack phase of a penetration test?",
    "choice_a": "System browsing",
    "choice_b": "Network reconnaissance",
    "choice_c": "Escalating privileges",
    "choice_d": "Gaining access",
    "correct_answer": "B",
    "explanation": "Network reconnaissance normally takes place during the discovery phase of a penetration test. The attack phase consists of gaining access, escalating privileges, system browsing, and installing additional tools.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      191,
      192,
      208
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 280,
    "question": "Bob is evaluating the risk to his organization from advanced persistent threat (APT) attackers. He assesses the likelihood of this risk occurring to be medium and the impact high. How would this risk be categorized under most organizations\u2019 risk evaluation matrices?",
    "choice_a": "Low risk",
    "choice_b": "Moderate risk",
    "choice_c": "Semi-moderate risk",
    "choice_d": "High risk",
    "correct_answer": "D",
    "explanation": "Under the risk management matrix used by most organizations, a risk with a medium likelihood and high impact would be considered a high risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      154,
      159,
      160,
      158
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 281,
    "question": "Which of the following is <i>not</i> a common network issue?",
    "choice_a": "Bandwidth consumption",
    "choice_b": "Beaconing",
    "choice_c": "Link aggregation",
    "choice_d": "Unexpected traffic",
    "correct_answer": "C",
    "explanation": "Bandwidth consumption, beaconing, and unexpected traffic are all common network issues that you should monitor for. Link aggregation refers to combining links to create a higher throughput link.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      79,
      57,
      56,
      58,
      59
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 282,
    "question": "Ian wants to provide additional email security for his organization. Which of the following is not used to enhance email security?",
    "choice_a": "DKIM",
    "choice_b": "DMARC",
    "choice_c": "S/PDIF",
    "choice_d": "SPF",
    "correct_answer": "C",
    "explanation": "DKIM (Domain Keys Identified Mail), DMARC (Domain-based Message Authentication, Reporting, and Compliance), and SPF (Sender Policy Framework) are all used to enhanced email security. S/PDIF is a connector used for audio interfaces.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      113,
      114,
      143,
      121,
      161
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 283,
    "question": "Asha wants to report CVSS scores for her organization as part of her vulnerability management program. Which of the following is a typical use of CVSS scores by system administrators?",
    "choice_a": "Understanding whether vulnerabilities are recurring",
    "choice_b": "Understanding the severity of the vulnerability",
    "choice_c": "Understanding the mitigation state of the vulnerability",
    "choice_d": "Listing the number of affected hosts",
    "correct_answer": "B",
    "explanation": "Common Vulnerability Scoring System (CVSS) scores are used to provide an understanding of the severity of a vulnerability. While internal risk information like the number of affected hosts helps to influence scores, the overall score is used to indicate the severity of the vulnerability. It does not indicate if a vulnerability is recurring or if it is mitigated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      128,
      131,
      125
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 284,
    "question": "Gavin is responding to a security incident. He has taken actions to limit the amount of damage caused by the attack and is now moving on to remove malware installed by attackers on the network. What phase of the incident response process is Gavin beginning?",
    "choice_a": "Containment",
    "choice_b": "Recovery",
    "choice_c": "Post-Incident Activities",
    "choice_d": "Eradication",
    "correct_answer": "D",
    "explanation": "The primary purpose of eradication is to remove any of the artifacts of the incident that may remain on the organization\u2019s network. This may include the removal of any malicious code from the network, the sanitization of compromised media, and the securing of compromised user accounts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      193,
      222,
      214,
      215
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 285,
    "question": "What security tool generated the output shown here?<img src=\"/question_assets/CySA+/practice_uf001.png\"/>",
    "choice_a": "Nessus",
    "choice_b": "Traceroute",
    "choice_c": "Nmap",
    "choice_d": "Syslog",
    "correct_answer": "C",
    "explanation": "Nmap is a network port scanner and generated the output shown in the question: a list of network ports. Nessus is a vulnerability scanner and would produce a detailed report of vulnerabilities. Traceroute determines the path between two points on a network. Syslog is a logging facility on Linux systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      100,
      103,
      99,
      104
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 286,
    "question": "Ryan uses the following command later in his forensic investigation and receives the response shown. What has occurred?<br>root@demo:~# md5sum -c image1.md5 image1v2.md5 <br>image1.raw: FAILED <br>md5sum: WARNING: 1 computed checksum did NOT match <br>image1.raw: OK",
    "choice_a": "The hash was miscalculated.",
    "choice_b": "No hash was created.",
    "choice_c": "The files are the same.",
    "choice_d": "The files are different.",
    "correct_answer": "D",
    "explanation": "Hashes are compared to verify that the files are the same. Since MD5 returns a warning that the checksum did not match, we know that the files are different.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      251,
      259,
      246,
      265,
      258
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 287,
    "question": "Fiona is investigating the misuse of her company\u2019s network and needs to capture network traffic for analysis. She wants to use a dedicated open source tool that is designed for packet capture and analysis. Which one of the following tools best meets her needs?",
    "choice_a": "Nessus",
    "choice_b": "Nmap",
    "choice_c": "Wireshark",
    "choice_d": "Nikto",
    "correct_answer": "C",
    "explanation": "Wireshark is a protocol analyzer and can be used to capture network traffic in a standard format. Nessus and Nmap are vulnerability scanners. Nikto is a web application security scanner.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      75,
      56,
      79,
      73,
      95
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 288,
    "question": "Jim has been provided with a CVE number for a vulnerability. What does the CVE tell him?",
    "choice_a": "It tells him the severity of the risk.",
    "choice_b": "It allows him to look up the risk.",
    "choice_c": "It tells him how many hosts are affected.",
    "choice_d": "It allows him to provide a compliance report.",
    "correct_answer": "B",
    "explanation": "Common Vulnerabilities and Exposures (CVE) numbers are used to identify vulnerabilities and will allow Jim to look up and reference the vulnerability across vendor-provided databases and other sources of information. The CVE number does not provide information about the vulnerability itself like severity, number of affected hosts, or compliance information.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      125,
      132,
      128,
      137,
      131
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 289,
    "question": "Which of the following is <i>not</i> a reason to avoid imaging live systems?",
    "choice_a": "The drive may be modified by the forensic tool.",
    "choice_b": "The drive contents may change during the imaging process.",
    "choice_c": "Unallocated space will not be included.",
    "choice_d": "Capturing memory contents is more difficult.",
    "correct_answer": "D",
    "explanation": "There are many reasons to avoid imaging live machines if it is not absolutely necessary, but one advantage that imaging a live machine is the ability to directly capture the contents of memory. Risks of capturing images from live machines include inadvertent modification of the systems, changes that may occur on the machine during imaging, the potential for malware to attack the imaging system or to detect and avoid it, and the fact that most live images don\u2019t capture unallocated space.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      262,
      253,
      259,
      248
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 290,
    "question": "Which incident response phase includes filing catch-up change requests in the organization\u2019s change control process?",
    "choice_a": "Eradication",
    "choice_b": "Containment",
    "choice_c": "Recovery",
    "choice_d": "Post-incident activities",
    "correct_answer": "D",
    "explanation": "Organizational change management processes are often bypassed during an incident response process due to the urgency of the need to make quick changes. Once the incident response has been completed, changes are often filed as catch-up documentation as part of the post-incident activities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      225,
      267,
      222,
      219,
      193
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 291,
    "question": "Brian is a new hire to his company as a threat hunter and he is beginning by developing scenarios of potential attacks. What threat hunting activity is Brian performing?",
    "choice_a": "Reducing the attack surface area",
    "choice_b": "Establishing the hypothesis",
    "choice_c": "Profiling threat actors",
    "choice_d": "Gathering evidence",
    "correct_answer": "B",
    "explanation": "Brian is developing potential scenarios that might result in a successful attack. This is an example of establishing a threat-hunting hypothesis. Next, Brian should look for evidence of such an attack in an attempt to confirm or refute his hypothesis.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      94,
      93,
      95,
      96,
      92
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 292,
    "question": "Rodney\u2019s company wants to prevent phishing attacks from resulting in account compromise. Which of the following solutions will provide the most effective solution?",
    "choice_a": "Implement context-aware authentication.",
    "choice_b": "Use enhanced password requirements.",
    "choice_c": "Add token-based authentication.",
    "choice_d": "Set a shorter password lifespan.",
    "correct_answer": "C",
    "explanation": "Multifactor authentication like token-based authentication can help prevent phishing attacks that result in stolen credentials from resulting in attackers accessing systems. As long as attackers do not also acquire the token (often an app on a smartphone or a physical device kept in the user\u2019s pocket), the attacker will not have all the factors they need to authenticate. Context-aware authentication might help if attackers log in from places that legitimate users don\u2019t, but enhanced password requirements and shorter password lifespans have a relatively small impact, if any.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      145,
      176,
      162,
      186,
      174
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 293,
    "question": "The group of developers that Cynthia is part of tests each software component or function before integrating it into larger software modules. What is this process called?",
    "choice_a": "Code segmentation",
    "choice_b": "Unit testing",
    "choice_c": "UAT",
    "choice_d": "Fagan inspection",
    "correct_answer": "B",
    "explanation": "Unit testing tests the smallest testable parts of an application or program, ensuring that each component works properly before they are put together. UAT is user acceptance testing, Fagan inspection is a form of formal code review, and code segmentation is not a term used in software engineering or development.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      16,
      14,
      15,
      18
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 294,
    "question": "At what stage in the incident response process does a CSIRT move from primarily passive to primarily active work?",
    "choice_a": "Preparation",
    "choice_b": "Detection and Analysis",
    "choice_c": "Containment, Eradication, and Recovery",
    "choice_d": "Post-incident Activity",
    "correct_answer": "C",
    "explanation": "Once a security incident has been detected and analyzed, CSIRTs move into an active phase of containment, eradication, and recovery. Active measures seek to limit the damage, gather evidence, identify the attackers and systems they are using, and eradicate the effects of the incident.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      221,
      222,
      191
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 295,
    "question": "Howard is analyzing the logs from his firewall and sees that the same IP address attempted blocked connections to the same server many different times. What is the most likely explanation for this activity?",
    "choice_a": "Denial-of-service (DoS) attack",
    "choice_b": "Port scan",
    "choice_c": "SQL injection",
    "choice_d": "Cross-site scripting",
    "correct_answer": "B",
    "explanation": "This is most likely a port scan being used to conduct reconnaissance and determine what ports are open on the server. A DoS attack would more likely use requests to a service allowed through the firewall. SQL injection and cross-site scripting would be successful only against a web server that was allowed to receive connections through the firewall.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      73,
      15,
      58,
      93,
      95
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 296,
    "question": "Alison is working to streamline operations in her cybersecurity program. She would like to add a tool that allows the automation of workflows. Which one of the following platforms would best meet her needs?",
    "choice_a": "SIEM",
    "choice_b": "Threat intelligence feed",
    "choice_c": "IPS",
    "choice_d": "SOAR",
    "correct_answer": "D",
    "explanation": "It is possible that any of these tools could play a role in automating and streamlining security operations. However, a security orchestration, automation, and response (SOAR) platform is specifically designed for this purpose and would be the best way to meet Alison\u2019s needs.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      22,
      78,
      24,
      25,
      21
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 297,
    "question": "Angela wants to search for rogue devices on her network. Which of the following techniques will best help her identify systems if she has a complete hardware and systems inventory?",
    "choice_a": "MAC address vendor checking",
    "choice_b": "Site surveys",
    "choice_c": "Traffic analysis for unexpected behavior",
    "choice_d": "MAC address verification",
    "correct_answer": "D",
    "explanation": "Since Angela already knows the MAC addresses of all the devices due to her systems inventory, she can simply search for associated MAC addresses that do not match the list.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      36,
      61,
      95,
      56
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 298,
    "question": "What type of control can be put in place and documented if an existing security measure is too difficult to implement or does not fully meet security requirements?",
    "choice_a": "Cost limiting",
    "choice_b": "Administrative",
    "choice_c": "Compensating",
    "choice_d": "Break-fix",
    "correct_answer": "C",
    "explanation": "When existing controls are insufficient, do not resolve the issue, or are too difficult to implement, a compensating control is often put in place. It is important to document compensating controls, because they differ from the expected or typical control that would normally be in place.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      162,
      186,
      129,
      141,
      183
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 299,
    "question": "What security tool generated the output shown here?<img src=\"/question_assets/CySA+/practice_uf002.png\"/>",
    "choice_a": "Wireshark",
    "choice_b": "Nessus",
    "choice_c": "Nmap",
    "choice_d": "Nexpose",
    "correct_answer": "A",
    "explanation": "The image shows a screenshot of network traffic captured using the Wireshark protocol analyzer.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      75,
      56,
      79,
      73,
      95
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 300,
    "question": "Tom would like to use nmap to perform service fingerprinting and wants to request banner information from scanned services. What flag should he use?",
    "choice_a": "<code>-oG</code>",
    "choice_b": "<code>-sS</code>",
    "choice_c": "<code>-b</code>",
    "choice_d": "<code>-sV</code>",
    "correct_answer": "D",
    "explanation": "The <code>\u2013sV</code> flag reports banner and version information. The <code>\u2013oG</code> flag generates greppable output. The <code>\u2013sS</code> flag requests a TCP SYN scan. The <code>\u2013b</code> flag is used to detect servers supporting FTP bounce.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      103,
      102,
      100,
      101,
      116
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 301,
    "question": "Insecure, Inc. has experienced multiple data breaches over the past 6 months and has recently hired Cynthia as an information security officer. Cynthia\u2019s first task is to review Insecure, Inc.\u2019s defenses with the goal of identifying appropriate defenses to put in place.<br>Cynthia knows that her new employers had two major breaches. Breach A occurred when an employee took home a USB external drive with sensitive customer information as well as corporate planning data for the following year. The employee left the drive in their car, and the car was broken into overnight. In the morning, the drive was gone. Insecure, Inc. is uncertain about the fate of the drive and is concerned that customer data as well as their top-secret plans to best their competitors may have been exposed.<br>Breach B was caused when Insecure, Inc.\u2019s new web application was attacked by unknown attackers who used a SQL injection attack to insert new data into their e-commerce application. Insecure, Inc.\u2019s website was quickly deluged with deal seekers, who put in hundreds of orders for Insecure\u2019s newly inexpensive products\u2014the attackers had managed to change the price for almost every product they sold. Insecure, Inc. managed to cancel most of the orders before they shipped, but they have had to deal with angry customers since the event.<br>Using this information, your task is to help Cynthia recommend the best defensive strategy for the following question.<br>Cynthia wants to ensure that data cannot be lost in the same way as the loss that occurred during breach A. Which of the following would make a lost drive not a major concern?",
    "choice_a": "Encrypt the drive with SHA2.",
    "choice_b": "Encrypt the drive with AES256.",
    "choice_c": "Encrypt the drive with DES.",
    "choice_d": "Encrypt the drive with MD5.",
    "correct_answer": "B",
    "explanation": "Encrypting a drive with strong encryption like AES256 will make the loss of a drive less of an issue. In general, strong encryption with a key that has not also been exposed can make confidentiality risks like this negligible. Both MD5 and SHA2 are not encryption methods\u2014they are hashes. DES is an older, weaker encryption method, and it would not provide strong protection for the drive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      162,
      160,
      167,
      176
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 302,
    "question": "Insecure, Inc. has experienced multiple data breaches over the past 6 months and has recently hired Cynthia as an information security officer. Cynthia\u2019s first task is to review Insecure, Inc.\u2019s defenses with the goal of identifying appropriate defenses to put in place.<br>Cynthia knows that her new employers had two major breaches. Breach A occurred when an employee took home a USB external drive with sensitive customer information as well as corporate planning data for the following year. The employee left the drive in their car, and the car was broken into overnight. In the morning, the drive was gone. Insecure, Inc. is uncertain about the fate of the drive and is concerned that customer data as well as their top-secret plans to best their competitors may have been exposed.<br>Breach B was caused when Insecure, Inc.\u2019s new web application was attacked by unknown attackers who used a SQL injection attack to insert new data into their e-commerce application. Insecure, Inc.\u2019s website was quickly deluged with deal seekers, who put in hundreds of orders for Insecure\u2019s newly inexpensive products\u2014the attackers had managed to change the price for almost every product they sold. Insecure, Inc. managed to cancel most of the orders before they shipped, but they have had to deal with angry customers since the event.<br>Using this information, your task is to help Cynthia recommend the best defensive strategy for the following question.<br>If Cynthia wants to address the human side of the issues she has discovered, what solution would best help prevent future issues?",
    "choice_a": "Policy and awareness training",
    "choice_b": "Dual control and cross training",
    "choice_c": "Cross training and an awareness program",
    "choice_d": "Implementing a continuous improvement program",
    "correct_answer": "A",
    "explanation": "It can be easy to forget how important policies and the standards and practices that derive from them are, but policies make up the foundation of an organization\u2019s security practices. When combined with awareness training, it is far more likely that the employees that Cynthia works will avoid bad practices like taking unencrypted drives home or neglecting to use web application security development best practices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      4,
      8,
      5,
      3
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 303,
    "question": "Insecure, Inc. has experienced multiple data breaches over the past 6 months and has recently hired Cynthia as an information security officer. Cynthia\u2019s first task is to review Insecure, Inc.\u2019s defenses with the goal of identifying appropriate defenses to put in place.<br>Cynthia knows that her new employers had two major breaches. Breach A occurred when an employee took home a USB external drive with sensitive customer information as well as corporate planning data for the following year. The employee left the drive in their car, and the car was broken into overnight. In the morning, the drive was gone. Insecure, Inc. is uncertain about the fate of the drive and is concerned that customer data as well as their top-secret plans to best their competitors may have been exposed.<br>Breach B was caused when Insecure, Inc.\u2019s new web application was attacked by unknown attackers who used a SQL injection attack to insert new data into their e-commerce application. Insecure, Inc.\u2019s website was quickly deluged with deal seekers, who put in hundreds of orders for Insecure\u2019s newly inexpensive products\u2014the attackers had managed to change the price for almost every product they sold. Insecure, Inc. managed to cancel most of the orders before they shipped, but they have had to deal with angry customers since the event.<br>Using this information, your task is to help Cynthia recommend the best defensive strategy for the following question.<br>What technical solution can Cynthia use to detect and possibly stop both SQL injection attacks and denial-of-service attacks against her web applications?",
    "choice_a": "An IDS",
    "choice_b": "A PRNG",
    "choice_c": "DLP",
    "choice_d": "An IPS",
    "correct_answer": "D",
    "explanation": "Cynthia\u2019s design should include an intrusion prevention system (IPS). An in-line IPS with the right signatures installed can detect and stop attacks, including SQL injection, cross-site scripting, and even denial-of-service (DoS) attacks. An intrusion detection system (IDS) could detect the attacks but can\u2019t stop them, whereas data loss prevention (DLP) systems are designed to prevent data from exiting an organization. A PRNG, or pseudo-random number generator, is not a security technology.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      162,
      161,
      144,
      176,
      173
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 304,
    "question": "Kevin ran a port scan on a system and determined that it is listening on port 1433. What type of server is Kevin most likely scanning?",
    "choice_a": "Web server",
    "choice_b": "Database server",
    "choice_c": "AAA server",
    "choice_d": "Email server",
    "correct_answer": "B",
    "explanation": "Port 1433 is used by Microsoft SQL Server, so Kevin is most likely scanning a database server.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      15,
      29,
      68,
      60,
      62
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 305,
    "question": "Phil ran a port scan on a server and discovered the following results:<img src=\"/question_assets/CySA+/practice_uf003.png\"/><br>Which one of the services running on this server can Phil be confident is using encryption?",
    "choice_a": "SSH",
    "choice_b": "HTTP",
    "choice_c": "MySQL",
    "choice_d": "SMTP",
    "correct_answer": "A",
    "explanation": "The Secure Shell (SSH) protocol uses encryption by default. HTTP, MySQL, and SMTP do not use encryption unless configured to do so.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      103,
      100,
      102,
      125,
      131
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 306,
    "question": "What requirement of shared authentication is a key differentiator from SSO?",
    "choice_a": "It requires authentication for each site.",
    "choice_b": "It uses the same authentication key for each site.",
    "choice_c": "Shared authentication provides end-to-end encryption.",
    "choice_d": "The shared authentication standard is an open standard.",
    "correct_answer": "A",
    "explanation": "The key difference between a shared authentication model and a single sign-on (SSO) model is that shared authentication systems require users to enter credentials when authenticating to each site. Single sign-on only requires a single sign-on\u2014exactly as the name says!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      45,
      44,
      42,
      48
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 307,
    "question": "Tara ran an nmap scan against a server and received the following results:<img src=\"/question_assets/CySA+/practice_uf004.png\"/><br>Of the services listed, which port is most unusual to find on a web server?",
    "choice_a": "53",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "8080",
    "correct_answer": "A",
    "explanation": "Port 53 is reserved for the Domain Name Service (DNS), which does not normally run on web servers. Ports 80 and 443 are used for HTTP and HTTPS, respectively. Ports in the range of 80xx are commonly used for web services running on nonstandard ports.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      102,
      103,
      107,
      106
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 308,
    "question": "Which Windows tool provides detailed data, including counters, that can measure information about a system like energy consumption, disk usage, and network activity?",
    "choice_a": "Winmon",
    "choice_b": "Perfmon",
    "choice_c": "Sysctl",
    "choice_d": "NICmon",
    "correct_answer": "B",
    "explanation": "Perfmon (Performance Monitor) provides the ability to perform detailed data collection. Winmon is a name typically associated with malware, and sysctl is a Linux tool used for changing kernel parameters at runtime. NICmon was made up for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      62,
      68,
      72,
      61
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 309,
    "question": "Kyle used nslookup to determine the IP address for nytimes.com and received the following results:<img src=\"/question_assets/CySA+/practice_uf005.png\"/><br>What is the IP address of the server that answered Kyle\u2019s request?",
    "choice_a": "172.30.0.2",
    "choice_b": "151.101.1.164",
    "choice_c": "151.101.65.164",
    "choice_d": "151.101.193.164",
    "correct_answer": "A",
    "explanation": "The DNS server that answered Kyle\u2019s request is identified in the first line of the response. The IP addresses that appear at the bottom are the server\u2019s response to Kyle\u2019s query.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      50,
      73,
      56,
      35,
      66
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 310,
    "question": "As part of his forensic investigation, Alex signs and notes in his log when the drive copy he prepared is transferred to legal counsel. What is this process known as?",
    "choice_a": "Handoff documentation",
    "choice_b": "Chain-of-custody tracking",
    "choice_c": "Asset tracking",
    "choice_d": "Forensic certification",
    "correct_answer": "B",
    "explanation": "Chain-of-custody tracking indicates who has access to and authority over drives, devices, and forensic data throughout their life cycle. This is a critical element in investigations that may end up in court or that will involve law enforcement.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      237,
      235,
      236,
      239,
      241
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 311,
    "question": "Ryan uses the following command as part of his forensic image preparation:<br><code>root@demo:~# </code><br><code>sha256sum demo.txt</code><br><code>fda464a72f2957dc125d31099d27bee9308339cec6b71e133b09daf1f359c4cc demo.txt</code><br>What task has he performed?",
    "choice_a": "Encryption",
    "choice_b": "Image creation",
    "choice_c": "Hashing",
    "choice_d": "Secure wipe",
    "correct_answer": "C",
    "explanation": "Ryan has created an SHA256 hash of his image file. This can be compared to the original, or if it is the original, it can be compared to figure copies to validate their integrity.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      251,
      248,
      259,
      246,
      217
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 312,
    "question": "Nicole wants to measure the effectiveness of her vulnerability management practice. Which of the following metrics or measures will best document if her program is effective?",
    "choice_a": "A list of critical vulnerabilities found in her scans",
    "choice_b": "A measure of the time for patches to be released for vulnerabilities",
    "choice_c": "A list of zero-day vulnerabilities found in her scans",
    "choice_d": "A measure of time to remediate for critical vulnerabilities",
    "correct_answer": "D",
    "explanation": "Nicole knows that she needs to understand how long it takes her organization to patch a vulnerability after it is identified. It is particularly important to understand how long critical vulnerabilities take to remediate since those are the most likely to impact her organization. Listing critical or zero-day vulnerabilities found doesn\u2019t indicate whether they\u2019re being patched in a timely manner by itself. Assessing how long it takes for patches to be released may be a good measure of vendor responsiveness but wouldn\u2019t assess Nicole\u2019s program.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      230,
      228,
      231,
      226,
      227
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 313,
    "question": "Ed is preparing an incident response report, and he discovers that some systems were not properly configured to use NTP. What critical element of incident reports may suffer based on this?",
    "choice_a": "The root cause analysis",
    "choice_b": "The chronology of events",
    "choice_c": "The postrecovery validation report",
    "choice_d": "The documentation of specific actions taken to remediate issues",
    "correct_answer": "B",
    "explanation": "NTP (Network Time Protocol) is used to ensure that events that are logged and other actions taken that use system time line up properly. Without NTP enabled, it may be significantly more difficult to determine when events occurred, making the chronological view of events harder, or even impossible, to build.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      239,
      240,
      235,
      241,
      236
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 314,
    "question": "Which one of the following criteria would normally be considered least important when making decisions about the scope of vulnerability scanning programs?",
    "choice_a": "Regulatory requirements",
    "choice_b": "Data classification",
    "choice_c": "Operating system type",
    "choice_d": "Corporate policy",
    "correct_answer": "C",
    "explanation": "The most important criteria when making decisions about the scope of vulnerability management programs are regulatory requirements, corporate policy, asset classification, and data classification.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      117,
      121,
      118,
      128,
      122
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 315,
    "question": "Bernie is designing a PCI DSS\u2013compliant vulnerability management program for his business. Who may conduct the internal scans required by the standard?",
    "choice_a": "Scans must be conducted by an approved scanning vendor (ASV).",
    "choice_b": "Scans must be conducted by an internal audit group or an ASV.",
    "choice_c": "Scans must be conducted by a PCI DSS\u2013certified individual.",
    "choice_d": "Scans may be conducted by any qualified individual.",
    "correct_answer": "D",
    "explanation": "PCI DSS only requires that internal scans be conducted by a qualified individual. External scans must be conducted by an approved scanning vendor (ASV).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      117,
      124,
      123,
      104,
      121
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 316,
    "question": "Which one of the following elements of the Security Content Automation Protocol (SCAP) provides a standard nomenclature for describing security-related software flaws?",
    "choice_a": "CVSS",
    "choice_b": "CPE",
    "choice_c": "CVE",
    "choice_d": "OVAL",
    "correct_answer": "C",
    "explanation": "Common Vulnerabilities and Exposures (CVE) provides a standard nomenclature for describing security-related software flaws. Common Vulnerability Scoring System (CVSS) provides a standardized approach for measuring and describing the severity of security-related software flaws. Common Platform Enumeration (CPE) provides a standard nomenclature for describing product names and versions. Open Vulnerability and Assessment Language (OVAL) is a language for specifying low-level testing procedures used by checklists.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      125,
      132,
      128,
      131,
      135
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 317,
    "question": "Susan wants to analyze a file using only tools natively available on a Linux system. What tool from the following list can she use to identify information contained in a binary file in human-readable form?",
    "choice_a": "Cuckoo Sandbox",
    "choice_b": "<code>strings</code>",
    "choice_c": "<code>grep</code>",
    "choice_d": "Joe Sandbox",
    "correct_answer": "B",
    "explanation": "The <code>strings</code> command is used to retrieve human-readable text from binary files, often providing useful information about the file. The <code>grep</code> command is a search command, but requires search terms. Cuckoo and Joe Sandbox are sandbox tools used for malware analysis but are not natively found on most Linux systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      82,
      64,
      18,
      75
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 318,
    "question": "What step is missing from the vulnerability management life cycle shown here?<img src=\"/question_assets/CySA+/practice_uf006.png\"/>",
    "choice_a": "Assessment",
    "choice_b": "Detection",
    "choice_c": "Patching",
    "choice_d": "Scanning",
    "correct_answer": "B",
    "explanation": "The three steps in the vulnerability management life cycle are detection, remediation, and testing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      126,
      128,
      135,
      136,
      117
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 319,
    "question": "Donna\u2019s organization has received a legal hold notice. Which of the following is not something she will have to do as part of the notice?",
    "choice_a": "Document a chain of custody.",
    "choice_b": "Change deletion and destruction processes to preserve data.",
    "choice_c": "Ensure that all data covered by the hold is preserved.",
    "choice_d": "Produce the data when required by the legal case.",
    "correct_answer": "A",
    "explanation": "Donna must take steps to preserve the data required by the case, including identifying the data, ensuring it is preserved, changing deletion and destruction processes to retain the data, and producing it when required. She does not have to document a chain of custody for the data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      261,
      212,
      246,
      258
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 320,
    "question": "Bryan is preparing to conduct a vulnerability scan and wishes to use credentialed scanning for maximum effectiveness. What type of account should Bryan use to perform this scanning in a secure manner?",
    "choice_a": "Domain administrator",
    "choice_b": "Root user",
    "choice_c": "Local administrator",
    "choice_d": "Read-only user",
    "correct_answer": "D",
    "explanation": "Credentialed scanning should always be performed with a read-only account to limit the potential impact on the system should the scanner malfunction or the account become compromised.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      123,
      104,
      130,
      119,
      118
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 321,
    "question": "Gary is the cybersecurity manager for a federal government agency subject to FISMA. He is evaluating the potential confidentiality impact of a system and decides that the unauthorized disclosure of information stored on the system could have a serious adverse impact on citizens served by his agency. How should Gary rate the confidentiality impact?",
    "choice_a": "Low",
    "choice_b": "Moderate",
    "choice_c": "High",
    "choice_d": "Critical",
    "correct_answer": "B",
    "explanation": "The system should be rated as moderate impact for confidentiality if \u201cthe unauthorized disclosure of information stored on the system could have a serious adverse impact on organizational operations, organizational assets, or individuals,\u201d according to Federal Information Processing Standards (FIPS) 199.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      8,
      1,
      2,
      5
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 322,
    "question": "Nick believes that the system he is investigating may be running crypto-mining malware. Which of the following indicators of compromise is most likely to be useful in identifying other systems that may have similar malicious processes?",
    "choice_a": "Irregular peer-to-peer communication",
    "choice_b": "Processor consumption",
    "choice_c": "Network scans or sweeps",
    "choice_d": "Drive capacity consumption",
    "correct_answer": "B",
    "explanation": "Cryptocurrency mining malware tends to consume CPU and GPU resources. Peer-to-peer communication and network sweeps are not typical indicators of this type malware, and drive capacity consumption from cryptographic malware is usually at a relatively small scale, making it difficult to use to detect it.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      62,
      60,
      95,
      61,
      32
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 323,
    "question": "The system administrators in Yariv\u2019s organization are not installing patching in a timely manner. When asked, they note that they are busy with other tasks, and that their business units require the systems to always be available. Which of the following action plans is most likely to help change this behavior?",
    "choice_a": "Changing business requirements",
    "choice_b": "Compensating controls",
    "choice_c": "Implementing configuration management",
    "choice_d": "Instituting a training program",
    "correct_answer": "D",
    "explanation": "Training programs help increase awareness and compliance with organizational policies and practices. Yariv should institute a training program to ensure that administrators understand why timely patching is needed. Changing business requirements might help resolve the need for systems to always be online but won\u2019t resolve the issue of administrators not finding time to patch. Configuration management still requires administrators to participate, and compensating controls are only useful if they are implemented, thus running into the same time issue.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      182,
      181,
      185,
      188,
      169
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 324,
    "question": "Oliver is developing a prioritization scheme for vulnerability remediation. Which one of the following is <i>not</i> generally accepted as an important criterion for prioritizing remediation?",
    "choice_a": "Vulnerability severity",
    "choice_b": "Age of vulnerability",
    "choice_c": "Criticality of system",
    "choice_d": "Difficulty of remediation",
    "correct_answer": "B",
    "explanation": "The most commonly accepted criteria for vulnerability prioritization include criticality of the systems and information affected by the vulnerability, difficulty of remediating the vulnerability, severity of the vulnerability, and exposure of the vulnerability.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      128,
      126,
      132,
      159,
      154
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 325,
    "question": "What regulatory schemes specifically require the use of vulnerability scanning?",
    "choice_a": "FISMA and PCI DSS",
    "choice_b": "PCI DSS and HIPAA",
    "choice_c": "HIPAA and GLBA",
    "choice_d": "GLBA and FISMA",
    "correct_answer": "A",
    "explanation": "The Federal Information Security Management Act (FISMA) and the Payment Card Industry Data Security Standard (PCI DSS) both require the use of vulnerability scanning. The Gramm\u2013Leach\u2013Bliley Act (GLBA) and Health Insurance Portability and Accountability Act (HIPAA) have no such requirement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      117,
      119,
      136,
      121,
      104
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 326,
    "question": "What type of term describes review of code by running it?",
    "choice_a": "The Run/Test method",
    "choice_b": "Runtime inspection",
    "choice_c": "Static code analysis",
    "choice_d": "Dynamic code analysis",
    "correct_answer": "D",
    "explanation": "Testing code by running it is known as dynamic code analysis. Static code analysis looks at the source code for an application. Runtime is when a program is running, but runtime inspection is not a common term used in software engineering. There is no Run/Test method.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      178,
      173,
      174
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 327,
    "question": "After completing a vulnerability scan, Bob received a report of a blind SQL injection vulnerability. Bob worked with the application developer to inspect the vulnerability and determined that the attack was not possible. What type of error occurred?",
    "choice_a": "True positive",
    "choice_b": "True negative",
    "choice_c": "False positive",
    "choice_d": "False negative",
    "correct_answer": "C",
    "explanation": "This scenario describes a false positive error\u2014the condition where a scanner reports a vulnerability but that vulnerability does not actually exist. When a vulnerability scanner reports a vulnerability, this is known as a positive report. This report may either be accurate (a true positive report) or inaccurate (a false positive report). Similarly, when a scanner reports that a vulnerability is not present, this is a negative report. The negative report may either be accurate (a true negative report) or inaccurate (a false negative report).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      135,
      131,
      127,
      128,
      144
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 328,
    "question": "Which of the following types of staff are <i>not</i> frequently part of a CSIRT?",
    "choice_a": "Technical subject matter experts",
    "choice_b": "IT support staff",
    "choice_c": "Legal counsel",
    "choice_d": "Comptrollers",
    "correct_answer": "D",
    "explanation": "Technical subject matter experts (SMEs), IT support staff, legal counsel, human resources staff members, and public relations and marking staff are all frequently part of the CSIRT. Comptrollers are rarely part of the response process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      197,
      191,
      195,
      192,
      221
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 329,
    "question": "Greg has implemented a honeypot as part of his defenses. What term best describes this type of defense?",
    "choice_a": "A darknet defense",
    "choice_b": "A Trojan Horse defense",
    "choice_c": "An active defense",
    "choice_d": "A tarpit defense",
    "correct_answer": "C",
    "explanation": "Greg has implemented a honeypot, which is a type of active defense used to capture information about attacker behavior. A darknet is a network that is otherwise unused that is monitored for attack traffic and scans to identify potential malicious actors. A Trojan Horse is a form of malware, and a tarpit is a defensive technique that is used to slow down attackers.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      97,
      93,
      95,
      17,
      73
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 330,
    "question": "Olivia has requested that her development team run their web application security testing tools against their web applications, despite the fact that they just installed the most recent patches. What is this type of testing called?",
    "choice_a": "Regression testing",
    "choice_b": "Patch state validation",
    "choice_c": "WAV testing",
    "choice_d": "HTTP checking",
    "correct_answer": "A",
    "explanation": "Regression testing focuses on ensuring that changes have not reintroduced problems or created new issues. Olivia has asked her team to do regression testing to make sure that the patches have not created new problems or brought an old problem back.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      180,
      177,
      173,
      168,
      170
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 331,
    "question": "What type of testing directly targets error handing paths, particularly those that are rarely used or might otherwise be missed during normal testing?",
    "choice_a": "Fuzzing",
    "choice_b": "Mutation testing",
    "choice_c": "Fault injection",
    "choice_d": "Fagan inspection",
    "correct_answer": "C",
    "explanation": "Fault injection directly injects faults into the error handling paths of an application and focuses on areas that might otherwise be missed. Fuzzing sends unexpected data, whereas mutation testing modifies the program itself to see how it handles unexpected behaviors. Fagan inspection is a formal inspection process.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      179,
      180,
      174,
      177,
      173
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 332,
    "question": "Theresa wants to determine why an incident occurred, and she believes that a combination of technical, administrative, and process issues were involved. What process should she use to determine this?",
    "choice_a": "Root cause analysis",
    "choice_b": "Forensic analysis",
    "choice_c": "A lessons learned exercise",
    "choice_d": "An architecture review",
    "correct_answer": "A",
    "explanation": "Root cause analysis processes focus on identifying the underlying issues that allowed an event to occur, allowing organizations to identify and implement appropriate solutions. A forensic analysis looks at timelines, events, and actions to determine what happened, when, and how. Lessons learned exercises look for both positive and negative lessons to take from events. Architecture reviews look at the technical architecture for a system or service.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      266,
      219,
      194,
      258,
      225
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 333,
    "question": "Which one of the following is not considered a core feature of the Diamond model of intrusion analysis?",
    "choice_a": "Adversary",
    "choice_b": "Methodology",
    "choice_c": "Victim",
    "choice_d": "Infrastructure",
    "correct_answer": "B",
    "explanation": "Methodology is considered a meta-feature, rather than a core feature of the Diamond model. The four core features, which correspond to the four vertices of the diamond, are the adversary, capability, infrastructure, and victim.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      89,
      6,
      4,
      95,
      79
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 334,
    "question": "Martin is looking for ways to optimize his organization\u2019s incident response effort. He would like to automatically pull information from DNS records when his SIEM triggers an alert, saving incident analysts the time of looking up those records. What term best describes this activity?",
    "choice_a": "Threat feed combination",
    "choice_b": "Webhook",
    "choice_c": "Data enrichment",
    "choice_d": "Single pane of glass",
    "correct_answer": "C",
    "explanation": "This is best described as data enrichment, saving human analysts the tedious time of investigating routine details of an incident. There is no indication in the scenario that Martin is combining information from multiple threat feeds, using webhooks, or creating a single pane of glass environment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      78,
      22,
      21,
      98
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 335,
    "question": "Harry identified the following vulnerability in one of his systems:<img src=\"/question_assets/CySA+/practice_uf007.png\"/><br>He would like to search network traffic to identify connection attempts that might have attempted to exploit this vulnerability. What port would traffic exploiting this vulnerability most likely use?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1521",
    "correct_answer": "A",
    "explanation": "This vulnerability is in the SSH protocol, which uses TCP port 22, as shown in the bottom portion of the graphic.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      73,
      56,
      55,
      82
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 336,
    "question": "Erik identified the following vulnerability in one of his systems:<img src=\"/question_assets/CySA+/practice_uf008.png\"/><br>What technique would be the most effective way to combat this vulnerability?",
    "choice_a": "Firewall rule",
    "choice_b": "Input validation",
    "choice_c": "Honeypot",
    "choice_d": "Patching",
    "correct_answer": "B",
    "explanation": "The most effective defense against SQL injection is the use of input validation. Firewall rules would not likely be effective because the web server likely requires access from the outside world. Honeypots and patching would not serve as a defense against a SQL injection attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      176,
      162,
      148,
      174
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 337,
    "question": "Bonnie ran a vulnerability scan against one of her servers and received a report that the server contains buffer overflow vulnerabilities in the operating system. Which one of the following would be the most effective defense?",
    "choice_a": "Input validation",
    "choice_b": "Firewall",
    "choice_c": "Operating system patching",
    "choice_d": "Intrusion prevention system",
    "correct_answer": "C",
    "explanation": "Buffer overflow vulnerabilities in an operating system require a vendor-supplied patch to correct. Input validation would not be an effective defense. Although firewalls and intrusion prevention systems may block an attack, they would not resolve the underlying problem.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      140,
      142,
      139,
      126,
      162
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 338,
    "question": "Which one of the following protocols would <i>not</i> generate a network vulnerability report if run on a production system?",
    "choice_a": "SSLv2",
    "choice_b": "SSLv3",
    "choice_c": "TLS 1.1",
    "choice_d": "All three would generate a vulnerability.",
    "correct_answer": "D",
    "explanation": "None of these protocols should be used on a secure network. All versions of SSL contain unfixable vulnerabilities, as do TLS versions earlier than 1.2.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      131,
      134,
      132,
      104
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 339,
    "question": "Ben identified the following vulnerability in one of his systems:<img src=\"/question_assets/CySA+/practice_uf009.png\"/><br>What technique would be the most effective way to combat this vulnerability?",
    "choice_a": "Firewall rule",
    "choice_b": "Input validation",
    "choice_c": "Honeypot",
    "choice_d": "Patching the operating system",
    "correct_answer": "B",
    "explanation": "The most effective defense against cross-site scripting is the use of input validation. Firewall rules would not likely be effective because the web server likely requires access from the outside world. Honeypots and operating system patching would not serve as a defense against a cross-site scripting attack.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      144,
      177,
      174,
      162,
      148
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 340,
    "question": "Chelsea\u2019s company runs an industrial control system (ICS) from a vendor that no longer provides support. The system has a newly discovered vulnerability to buffer overflow attacks. What would be the best way to defend this system?",
    "choice_a": "Apply a patch.",
    "choice_b": "Rewrite the code.",
    "choice_c": "Place it on a segmented network.",
    "choice_d": "Use encryption.",
    "correct_answer": "C",
    "explanation": "Network segmentation is a strong security control for ICS networks. Chelsea does not have access to the source code, so she cannot rewrite it. No patch is available because the vendor no longer provides support. Encryption would not provide a defense against a buffer overflow attack.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      141,
      162,
      147,
      112,
      128
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 341,
    "question": "What information does a CVSS score provide that will influence administrator\u2019s prioritization of patch installation timeframes?",
    "choice_a": "Risk information",
    "choice_b": "Patch availability",
    "choice_c": "A zero-day score",
    "choice_d": "A MOU analysis",
    "correct_answer": "A",
    "explanation": "CVSS provides a risk rating that can help administrators prioritize patch installation. It does not indicate patch availability or analyze MOUs, and zero-day scores were made up for this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      128,
      131,
      133,
      159
    ],
    "source": "182909_PracticeExam"
  },
  {
    "id": 342,
    "question": "Marek wants to engage with appropriate groups as he communicates about an incident. Which group should he involve if he believes that a crime was committed during the incident?",
    "choice_a": "Legal counsel",
    "choice_b": "Public relations",
    "choice_c": "Law enforcement",
    "choice_d": "Regulatory agencies",
    "correct_answer": "C",
    "explanation": "While Marek may choose to involve others, if a crime was committed during an incident Marek is most likely to involve law enforcement.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      237,
      235,
      236,
      238,
      241
    ],
    "source": "182909_PracticeExam"
  }
];
